<template>
  <OrderModifyDiv>
    <OrderUpClientArea>
      <OrderUpTitleArea>
        <OrderUpTitleDiv>주문서 수정</OrderUpTitleDiv>
      </OrderUpTitleArea>

      <!-- ! 수급자, 거래처 불러오기 -->
      <OrderUpClientBtnContainer>
        <OrderUpClientUpBtn @click="showModal_obj.client_up = true">
          한큐 불러오기
        </OrderUpClientUpBtn>
        <OrderUpClientUpBtn @click="showModal_obj.company_up = true">
          거래처 불러오기
        </OrderUpClientUpBtn>
      </OrderUpClientBtnContainer>

      <!-- ! 수급자 정보 테이블-->
      <OrderUpClientTable :style="tableStyles">
        <thead></thead>
        <tbody>
          <tr>
            <OrderModifyClientTableTd>주문일자</OrderModifyClientTableTd>
            <td>
              <Datepicker v-model:value="orderDate" placeholder="주문일자" style="width:130px; height:35px;"
                :class="{ 'blurred': isTestUser }" :lang="ko" />
            </td>
            <OrderModifyClientTableTd>인정번호</OrderModifyClientTableTd>
            <td>
              <OrderUpClientInputTxtW150 type="text" placeholder="요양인정번호 10자리" v-model="client_data_obj.number"
                :class="{ 'blurred': isTestUser }" />
            </td>
          </tr>
          <tr>
            <OrderModifyClientTableTd>수급자성함</OrderModifyClientTableTd>
            <td>
              <OrderUpClientInputTxtW150 type="text" v-model="client_data_obj.name"
                :class="{ 'blurred': isTestUser }" />
            </td>
            <OrderModifyClientTableTd>보호자성함</OrderModifyClientTableTd>
            <td>
              <OrderUpClientInputTxtW150 type="text" v-model="client_data_obj.guardname"
                :class="{ 'blurred': isTestUser }" />
            </td>
          </tr>
          <tr v-if="rentalTypes.hasRentalProduct">
            <OrderModifyClientTableTd>대여 시작일</OrderModifyClientTableTd>
            <td>
              <Datepicker v-model:value="client_data_obj.rental_start" placeholder="대여시작일"
                style="width:130px; height:35px;" :class="{ 'blurred': isTestUser }" :lang="ko" />
            </td>
            <OrderModifyClientTableTd>대여 종료일</OrderModifyClientTableTd>
            <td>
              <Datepicker v-model:value="client_data_obj.rental_end" placeholder="대여종료일"
                style="width:130px; height:35px;" :class="{ 'blurred': isTestUser }" :lang="ko" />
            </td>
          </tr>
          <tr v-if="rentalTypes.hasOxygenGenerator">
            <OrderModifyClientTableTd>산소치료<br />처방시작일</OrderModifyClientTableTd>
            <td>
              <Datepicker v-model:value="client_data_obj.oxygen_start" placeholder="처방시작일"
                style="width:130px;height:35px;background-color:#f8f9fa;color:#333;" :clearable="true"
                @cleared="client_data_obj.oxygen_start = null" :class="{ 'blurred': isTestUser }" :lang="ko" />
            </td>
            <OrderModifyClientTableTd>산소치료<br />처방종료일</OrderModifyClientTableTd>
            <td>
              <Datepicker v-model:value="client_data_obj.oxygen_end" placeholder="처방종료일"
                style="width:130px;height:35px;background-color:#f8f9fa;color:#333;"
                @cleared="client_data_obj.oxygen_end = null" :class="{ 'blurred': isTestUser }" :lang="ko" />
            </td>
          </tr>
          <tr v-if="rentalTypes.hasDiabetesProduct">
            <OrderModifyClientTableTd>당뇨소모성재료<br />처방시작일</OrderModifyClientTableTd>
            <td>
              <Datepicker v-model:value="client_data_obj.diabetes_start" placeholder="처방시작일"
                style="width:130px;height:35px;background-color:#f8f9fa;color:#333;" :clearable="true"
                @cleared="client_data_obj.diabetes_start = null" :class="{ 'blurred': isTestUser }" :lang="ko" />
            </td>
            <OrderModifyClientTableTd>당뇨소모성재료<br />처방종료일</OrderModifyClientTableTd>
            <td>
              <Datepicker v-model:value="client_data_obj.diabetes_end" placeholder="처방종료일"
                style="width:130px;height:35px;background-color:#f8f9fa;color:#333;"
                @cleared="client_data_obj.diabetes_end = null" :class="{ 'blurred': isTestUser }" :lang="ko" />
            </td>
          </tr>
          <tr>
            <OrderModifyClientTableTd>주소1<br />(배송주소)</OrderModifyClientTableTd>
            <td>
              <AddressControlContainer>
                <orderUpClientAddressBtn @click="openDaumPostcode(1)" style="width: 80px;"
                  :class="{ 'blurred': isTestUser }">주소 검색
                </orderUpClientAddressBtn>
                <SwapVerticalIcon @click="swapAddresses" title="주소1과 주소2를 교환합니다">
                  <SwapVertical :size="25" />
                </SwapVerticalIcon>
              </AddressControlContainer>
              <OrderUpClientInputTxtW150 v-model="postcode_obj.postcode1" type="text" placeholder="우편번호"
                :class="{ 'blurred': isTestUser }" /><br>
            </td>
            <td colspan="2">
              <OrderUpClientInputTxtW260 v-model="postcode_obj.address1" type="text" placeholder="주소"
                :class="{ 'blurred': isTestUser }" />
              <OrderUpClientInputTxtW260 v-model="postcode_obj.detailAddress1" type="text" placeholder="상세주소"
                :class="{ 'blurred': isTestUser }" />
            </td>
          </tr>
          <tr>
            <OrderModifyClientTableTd>주소2</OrderModifyClientTableTd>
            <td>
              <AddressControlContainer>
                <orderUpClientAddressBtn @click="openDaumPostcode(2)" style="width: 123px;"
                  :class="{ 'blurred': isTestUser }">주소 검색
                </orderUpClientAddressBtn>
              </AddressControlContainer>
              <OrderUpClientInputTxtW150 v-model="postcode_obj.postcode2" type="text" placeholder="우편번호"
                :class="{ 'blurred': isTestUser }" /><br>
            </td>
            <td colspan="2">
              <OrderUpClientInputTxtW260 v-model="postcode_obj.address2" type="text" placeholder="주소"
                :class="{ 'blurred': isTestUser }" />
              <OrderUpClientInputTxtW260 v-model="postcode_obj.detailAddress2" type="text" placeholder="상세주소"
                :class="{ 'blurred': isTestUser }" />
            </td>
          </tr>
          <tr>
            <OrderModifyClientTableTd>이메일</OrderModifyClientTableTd>
            <td>
              <OrderUpClientInputTxtW150 type="text" v-model="client_data_obj.email"
                :class="{ 'blurred': isTestUser }" />
            </td>
            <OrderModifyClientTableTd>수급자관계</OrderModifyClientTableTd>
            <td>
              <OrderUpClientInputTxtW150 type="text" v-model="client_data_obj.guardtarget"
                :class="{ 'blurred': isTestUser }" />
            </td>
          </tr>
          <tr>
            <OrderModifyClientTableTd>연락처1</OrderModifyClientTableTd>
            <td>
              <OrderUpClientInputTxtW150 type="text" v-model="client_data_obj.phone1"
                :class="{ 'blurred': isTestUser }" />
            </td>
            <OrderModifyClientTableTd>연락처2</OrderModifyClientTableTd>
            <td>
              <OrderUpClientInputTxtW150 type="text" v-model="client_data_obj.phone2"
                :class="{ 'blurred': isTestUser }" />
            </td>
          </tr>
          <tr>
            <OrderModifyClientTableTd>센터명</OrderModifyClientTableTd>
            <td>
              <OrderUpClientInputTxtW150 type="text" v-model="client_data_obj.centername"
                :class="{ 'blurred': isTestUser }" />
            </td>
            <OrderModifyClientTableTd>담당자</OrderModifyClientTableTd>
            <td>
              <OrderUpClientSelectW162 v-model="client_data_obj.manager" :class="{ 'blurred': isTestUser }">
                <option v-for="managerItem in manager" :key="managerItem.name" :value="managerItem.name"
                  :selected="managerItem.name === client_data_obj.manager">{{
                    managerItem.name }}</option>
              </OrderUpClientSelectW162>
            </td>
          </tr>
          <tr>
            <OrderModifyClientTableTd>배송방법</OrderModifyClientTableTd>
            <td>
              <OrderUpClientSelectW162 v-model="deliveryMethod" :class="{ 'blurred': isTestUser }">
                <option value="1">내방</option>
                <option value="2">물류 (기관배송)</option>
                <option value="3">택배</option>
                <option value="4">소독업체</option>
                <option value="5">공급업체</option>
              </OrderUpClientSelectW162>
            </td>
            <OrderModifyClientTableTd>배송상태</OrderModifyClientTableTd>
            <td>
              <OrderUpClientSelectW162 v-model="deliveryStatus" :class="{ 'blurred': isTestUser }">
                <option value="1">배송완료</option>
                <option value="2">배송대기</option>
                <option value="3">회수중</option>
                <option value="4">회수완료</option>
                <option value="5">배송중</option>
              </OrderUpClientSelectW162>
            </td>
          </tr>
          <OrderUpClientTableTr>
            <OrderModifyClientTableTd>출고요청</OrderModifyClientTableTd>
            <td>
              <OrderUpClientSelectW162 :class="{ 'blurred': isTestUser }">
                <option>선택</option>
              </OrderUpClientSelectW162>
            </td>
            <OrderModifyClientTableTd>배송요청일/시</OrderModifyClientTableTd>
            <td>
              <Datepicker v-model:value="delivery_date" placeholder="배송요청일시" style="width:130px;height:35px;"
                :class="{ 'blurred': isTestUser }" :lang="ko" /><br />
              <OrderUpClientSelectW162 v-model="delivery_time" :class="{ 'blurred': isTestUser }">
                <option value="0">오전</option>
                <option value="1">오후</option>
              </OrderUpClientSelectW162>
            </td>
          </OrderUpClientTableTr>

          <!-- !메모 Area-->
          <OrderUpClientTableTr>
            <OrderModifyClientTableTd v-model="selectedDeliveryMemo">메모
            </OrderModifyClientTableTd>
            <OrderModifyClientMemoArea colspan="3">
              <CommentThumbnailArea>
                <CommentThumbnail v-for="(file, index) in imageFiles" :key="index" class="thumbnail">
                  <div>
                    <img :src="imageHandlingGetImageUrl(file)" alt="썸네일">
                    <button @click="imageHandlingRemoveImage(index)">삭제</button>
                  </div>
                </CommentThumbnail>
              </CommentThumbnailArea>
              <CommentImageUploadArea class="image-upload">
                <input type="file" @change="imageHandlingOnFileSelected" accept="image/*" multiple ref="fileInput"
                  style="display: none;">
                <button @click="$refs.fileInput.click()">
                  <Attachment />이미지 첨부
                </button>
              </CommentImageUploadArea>
              <OrderUpClientInputTxtW80per v-model="orderCommentAdd" @keyup.enter="commentAdd"
                :class="{ 'blurred': isTestUser }" />
              <OrderModifyClientMemoBtn @click="commentAdd">입력</OrderModifyClientMemoBtn>
            </OrderModifyClientMemoArea>
          </OrderUpClientTableTr>

          <!-- !메모내역 Area-->
          <OrderUpClientTableTr>
            <OrderModifyClientTableTd>메모내역</OrderModifyClientTableTd>
            <td colspan="3">
              <div v-for="(comment, index) in orderComment" :key="index" :class="{ 'blurred': isTestUser }">
                <CommentTitleDiv>
                  <span>{{ comment.manager }}</span>&nbsp;&nbsp;
                  <span>{{ comment.updated_at }}</span>&nbsp;&nbsp;
                  <CloseSpan @click="deleteComment(comment.num)">
                    <Close />
                  </CloseSpan>
                  <Feedback @click="showFeedbackDialog(comment)"
                    :class="{ 'has-feedback': hasFeedbackForComment(comment.num) }">
                    {{ hasFeedbackForComment(comment.num) ? '피드백 취소' : '피드백 등록' }}
                  </Feedback>
                </CommentTitleDiv>
                <CommentTextDiv :class="{ 'no-border': index === orderComment.length - 1 }">
                  <CommentImageArea v-if="comment.files">
                    <CommentImg v-for="(file, fileIndex) in comment.files" :src="file" :key="fileIndex" alt="썸네일"
                      @click="openImageModal(file)" />
                  </CommentImageArea>
                  <CommentContentArea>
                    <span style="color: blue">{{ comment.text }}</span>
                  </CommentContentArea>
                </CommentTextDiv>
              </div>

              <!-- !메모 이미지 모달 -->
              <ImageModal v-if="showImageModal" class="image-modal" @click="closeImageModal">
                <img :src="selectedImage" alt="확대된 이미지" @click.stop>
              </ImageModal>
            </td>
          </OrderUpClientTableTr>
        </tbody>
      </OrderUpClientTable>
    </OrderUpClientArea>

    <!-- !중앙(주문서 | 품목) Area -->
    <OrderModifyCenterArea></OrderModifyCenterArea>

    <!-- ! 매장 주문품목 헤더 영역 -->
    <OrderModifyProductArea>
      <StoreOrderArea>
        <SectionTitle2>
          <OrderTypeTag :class="{
            'oxygen': rentalTypes.hasOxygenGenerator || orderId?.rental_type === 'o',
            'diabetes': !rentalTypes.hasOxygenGenerator && (rentalTypes.hasDiabetesProduct || orderId?.rental_type === 'd'),
            'assistance': !rentalTypes.hasOxygenGenerator && !rentalTypes.hasDiabetesProduct && (rentalTypes.hasAssistanceProduct || orderId?.rental_type === 'a'),
            'rental': !rentalTypes.hasOxygenGenerator && !rentalTypes.hasDiabetesProduct && !rentalTypes.hasAssistanceProduct && rentalTypes.hasRentalProduct,
            'normal': !rentalTypes.hasOxygenGenerator && !rentalTypes.hasDiabetesProduct && !rentalTypes.hasAssistanceProduct && !rentalTypes.hasRentalProduct
          }">
            {{
              rentalTypes.hasOxygenGenerator || orderId?.rental_type === 'o' ? '산소발생기 주문' :
                rentalTypes.hasDiabetesProduct || orderId?.rental_type === 'd' ? '당뇨소모성재료 주문' :
                  rentalTypes.hasAssistanceProduct || orderId?.rental_type === 'a' ? '보장구 주문' :
                    rentalTypes.hasRentalProduct ? '대여 주문' : '일반 주문'
            }}
          </OrderTypeTag>
        </SectionTitle2>
        <OrderUpProductHeaderArea>
          <FlexDiv>
            <OrderUpProductHeaderBtn @click="selectAllStore">전체선택</OrderUpProductHeaderBtn>&nbsp;
            <OrderUpProductHeaderBtn @click="deselectAllStore">선택해제</OrderUpProductHeaderBtn>&nbsp;
            <OrderUpProductHeaderBtn @click="showClaimCalculationModal">청구계산</OrderUpProductHeaderBtn>
          </FlexDiv>
          <FlexDiv>
            <OrderUpProductHeaderImageBtn @click="openVirtualAccountModal">가상계좌 발송({{ virtualAccountCount }})건
            </OrderUpProductHeaderImageBtn>
            <OrderUpProductHeaderImageBtn @click="openDocumentIssuanceModal">세금계산서 발행
            </OrderUpProductHeaderImageBtn>
            <OrderUpProductHeaderImageBtn @click="openSmsSendModal">문자 발송</OrderUpProductHeaderImageBtn>
          </FlexDiv>
          <div></div>
          <FlexDiv>
            <OrderUpProductHeaderBtn @click="deleteSelectedStoreProducts">선택품목삭제</OrderUpProductHeaderBtn>
          </FlexDiv>
        </OrderUpProductHeaderArea>

        <!-- ! 주문품목 테이블 영역 -->
        <OrderUpProductTableContainer>
          <StoreOrderTable :class="{ 'oxygen-order': rentalTypes.hasOxygenGenerator || orderId?.rental_type === 'o' }">
            <thead>
              <OrderUpProductTableTheadTr>
                <th></th>
                <th>바코드</th>
                <th>품목분류</th>
                <th>품목명</th>
                <th>사이즈</th>
                <th>색상</th>
                <th>비고</th>
                <th>수량</th>
                <th>단가</th>
                <th>차액</th>
                <th>품목 합계</th>
                <th v-if="rentalTypes.hasOxygenGenerator || orderId?.rental_type === 'o'">본인<br>부담금</th>
                <th></th>
                <th>상세</th>
              </OrderUpProductTableTheadTr>
            </thead>
            <tbody>
              <template v-for="(product, index) in products_obj" :key="index">
                <!-- 기본 행 -->
                <tr class="main-row" :class="{ 'expanded': product.expanded }">
                  <!-- *선택 -->
                  <td>
                    <OrderUpProductTableInput type="checkbox" :checked="product.selected"
                      @change="toggleStoreProductSelection(index)" />
                  </td>
                  <!-- *바코드 -->
                  <td>
                    <!-- 비급여 품목인 경우 수량과 관계없이 고정 표시 -->
                    <template v-if="product.b_product_id >= 100000">
                      <OrderUpProductTableBcodeAreaDiv>
                        <OrderUpProductTableInputTxt type="text" v-model="product.barcodes[0]"
                          :placeholder="`바코드 입력`" />
                      </OrderUpProductTableBcodeAreaDiv>
                    </template>
                    <!-- 급여 품목인 경우 기존 로직 -->
                    <template v-else>
                      <OrderUpProductTableBcodeAreaDiv
                        v-for="(barcode, barcodeIndex) in product.barcodes.slice(0, Math.max(0, Math.min(product.quantity || 0, 1000)))"
                        :key="`barcode-${index}-${barcodeIndex}-${product.quantity}`">
                        <OrderUpProductTableInputTxt type="text" v-model="product.barcodes[barcodeIndex]"
                          :placeholder="`바코드 입력`" />
                      </OrderUpProductTableBcodeAreaDiv>
                    </template>
                  </td>
                  <!-- * 품목분류 -->
                  <td style="position: relative; overflow: visible;"
                    :title="`${product.hub_product_id ? product.name1 : product.name3}`">
                    <!-- service_hub 제품인 경우 (hub_product_id가 있으면) -->
                    <template v-if="product.hub_product_id">
                      <div style="font-size: 12px; color: #666; margin-bottom: 2px;">
                        {{ product.code || '코드 없음' }}
                      </div>
                      <div>{{ product.name || '품목명 없음' }}</div>
                    </template>
                    <!-- 일반 제품인 경우 (b_product_id가 있으면) -->
                    <template v-else-if="product.b_product_id">
                      <div style="font-size: 12px; color: #666; margin-bottom: 2px;">
                        {{ product.code || '코드 없음' }}
                      </div>
                      <div>{{ product.name1 || '품목명 없음' }}</div>
                    </template>
                    <!-- 기타 경우 -->
                    <template v-else>
                      <div style="font-size: 12px; color: #666; margin-bottom: 2px;">
                        {{ product.code || '코드 없음' }}
                      </div>
                      <div>{{ product.name || '품목명 없음' }}</div>
                    </template>
                  </td>
                  <!-- *품목명 -->
                  <ProductNameCell :title="`${product.hub_product_id ? product.name1 : product.name3}`"
                    @mouseenter="showProductImage($event, product)" @mouseleave="hideProductImage"
                    @click="showProductImage($event, product)"
                    style="cursor:pointer; position: relative; overflow: hidden; text-overflow: ellipsis;">
                    <div class="image-trigger" style="display: inline-block; width: 100%;">
                      {{ product.hub_product_id ? product.name1 : product.name3 }}
                    </div>
                  </ProductNameCell>
                  <!-- *사이즈 -->
                  <td>
                    <!-- 비급여 품목인 경우 수량과 관계없이 고정 표시 -->
                    <template v-if="product.b_product_id >= 100000">
                      <div>
                        <OrderUpProductTableInputTxt v-model="product.sizes[0]" @input="convertToUpperCase(index, 0)">
                        </OrderUpProductTableInputTxt>
                      </div>
                    </template>
                    <!-- 급여 품목인 경우 기존 로직 -->
                    <template v-else>
                      <div v-for="n in Math.max(0, Math.min(product.quantity || 0, 1000))" :key="`size-${index}-${n}`">
                        <OrderUpProductTableInputTxt v-model="product.sizes[n - 1]"
                          @input="convertToUpperCase(index, n - 1)">
                        </OrderUpProductTableInputTxt>
                      </div>
                    </template>
                  </td>
                  <!-- *색상 -->
                  <td>
                    <!-- 비급여 품목인 경우 수량과 관계없이 고정 표시 -->
                    <template v-if="product.b_product_id >= 100000">
                      <div>
                        <OrderUpProductTableColorSelect v-model="product.colors[0]"
                          @change="handleColorChange(index, 0)">
                          <option value="null">색상 없음</option>
                          <option v-for="(colorName, colorId) in color_obj.value" :key="colorId" :value="colorName">
                            {{ colorName }}
                          </option>
                        </OrderUpProductTableColorSelect>
                      </div>
                    </template>
                    <!-- 급여 품목인 경우 기존 로직 -->
                    <template v-else>
                      <div v-for="n in Math.max(0, Math.min(product.quantity || 0, 1000))" :key="`color-${index}-${n}`">
                        <OrderUpProductTableColorSelect v-model="product.colors[n - 1]"
                          @change="handleColorChange(index, n - 1)">
                          <option value="null">색상 없음</option>
                          <option v-for="(colorName, colorId) in color_obj.value" :key="colorId" :value="colorName">
                            {{ colorName }}
                          </option>
                        </OrderUpProductTableColorSelect>
                      </div>
                    </template>
                  </td>
                  <!-- *비고 -->
                  <td>
                    <!-- 비급여 품목인 경우 수량과 관계없이 고정 표시 -->
                    <template v-if="product.b_product_id >= 100000">
                      <div>
                        <OrderUpProductTableInputTxt type="text" v-model="product.options.note[0]"
                          :placeholder="`비고`" />
                      </div>
                    </template>
                    <!-- 급여 품목인 경우 기존 로직 -->
                    <template v-else>
                      <div v-for="n in Math.max(0, Math.min(product.quantity || 0, 1000))" :key="`note-${index}-${n}`">
                        <OrderUpProductTableInputTxt type="text" v-model="product.options.note[n - 1]"
                          :placeholder="`비고`" />
                      </div>
                    </template>
                  </td>
                  <!-- *수량 -->
                  <td>
                    <QuantityFlexDiv>
                      <OrderupProductCntInput type="text" v-model="product.quantity"
                        @input="handleStoreQuantityChange(index, $event.target.value)" />
                      <QuantityButtonContainer>
                        <HanqBtn @click="decreaseStoreQuantity(index)">-</HanqBtn>
                        <HanqBtn @click="increaseStoreQuantity(index)">+</HanqBtn>
                      </QuantityButtonContainer>
                    </QuantityFlexDiv>
                  </td>
                  <!-- *단가 -->
                  <td>
                    <FlexDiv>
                      <div v-if="!product.isEditingPrice" @click="startEditingPrice(index)" style="cursor: pointer;">
                        {{ format.price(product.unitprice || getStoreUnitPrice(product)) }}원
                      </div>
                      <div v-else>
                        <input :value="product.unitprice || getStoreUnitPrice(product)"
                          :ref="el => { if (el) priceInputs[index] = el }"
                          @input="updatePrice(index, $event.target.value)" @blur="finishEditingPrice(index)"
                          @keyup.enter="finishEditingPrice(index)"
                          style="width: 60px; text-align: right; height: 25px; border: 1px solid #ddd; border-radius: 4px;" />
                      </div>
                    </FlexDiv>
                  </td>
                  <!-- *차액 -->
                  <td>
                    <FlexDiv>
                      <span
                        :class="{ 'positive-diff': getTotalPriceDifference(product) > 0, 'negative-diff': getTotalPriceDifference(product) < 0 }">
                        {{ getTotalPriceDifference(product) > 0 ? '+' : '' }}{{
                          format.price(getTotalPriceDifference(product)) }}원
                      </span>
                    </FlexDiv>
                  </td>
                  <!-- *합계 -->
                  <td>
                    <FlexDiv>
                      {{ format.price(perItemTotalPrice(product)) }}원
                    </FlexDiv>
                  </td>
                  <!-- *본인부담금 -->
                  <td v-if="rentalTypes.hasOxygenGenerator || orderId?.rental_type === 'o'">
                    <FlexDiv>
                      {{ new Intl.NumberFormat('ko-KR').format(Math.round(getStoreUnitPrice(product) * 0.1)) }}원
                    </FlexDiv>
                  </td>
                  <!-- * 삭제 버튼 -->
                  <td>
                    <DeleteButton @click="deleteProduct(index)">
                      <Delete />
                    </DeleteButton>
                  </td>
                  <!-- *상세 버튼 -->
                  <td>
                    <ExpandButton @click="toggleProductExpand(index)" :class="{ 'expanded': product.expanded }">
                      <ChevronDown v-if="!product.expanded" />
                      <ChevronUp v-else />
                    </ExpandButton>
                  </td>
                </tr>

                <!-- ! 확장된 행 -->
                <tr v-if="product.expanded">
                  <td :colspan="rentalTypes.hasOxygenGenerator || orderId?.rental_type === 'o' ? 14 : 13">
                    <div class="product-expanded-row">
                      <div class="product-card-grid">
                        <!-- * 가격 정보 카드 -->
                        <div class="product-info-card">
                          <h4 class="product-card-title">가격 정보</h4>
                          <div class="product-price-row">
                            <div class="product-price-item">
                              <div class="product-info-label">구입가격</div>
                              <div class="product-price-value">{{ format.price(product.buyprice || product.price || '0')
                                }}원</div>
                            </div>
                            <div class="product-price-item">
                              <div class="product-info-label">대여가격</div>
                              <div class="product-price-value">{{ format.price(product.rentprice || product.price2 ||
                                '0') }}원</div>
                            </div>
                            <div class="product-price-item">
                              <div class="product-info-label">공급가격</div>
                              <div class="product-price-value">{{ format.price(product.supplyprice || product.price3 ||
                                '0') }}원</div>
                            </div>
                            <div class="product-price-item" v-if="product.type === '박스'">
                              <div class="product-info-label">낱개 당 가격</div>
                              <div class="product-price-value">{{ calculateUnitPrice(product) }}원</div>
                            </div>
                          </div>
                        </div>

                        <!-- * 수량 정보 카드 -->
                        <div class="product-info-card">
                          <h4 class="product-card-title">수량 정보</h4>
                          <div class="product-price-row">
                            <div class="product-price-item">
                              <div class="product-info-label">
                                {{ product.type === '박스' ? '박스 수량' : '품목 수량' }}
                              </div>
                              <div class="product-price-value">{{ product.quantity || 0 }}개</div>
                            </div>
                            <div class="product-price-item" v-if="product.type === '박스'">
                              <div class="product-info-label">박스 당 개수</div>
                              <div class="product-price-value">{{ product.pieces_per_box || 0 }}개</div>
                            </div>
                            <div class="product-price-item">
                              <div class="product-info-label">낱개 수량</div>
                              <div class="product-price-value">{{ product.piece_quantity || 0 }}개</div>
                            </div>
                            <div class="product-price-item">
                              <div class="product-info-label">합계 수량</div>
                              <div class="product-price-value">{{ calculateTotalQuantity(product) }}개</div>
                            </div>
                          </div>
                        </div>

                        <!-- * 재고 정보 카드 -->
                        <div class="product-info-card">
                          <h4 class="product-card-title">재고 정보</h4>
                          <div class="product-price-row">
                            <div class="product-price-item">
                              <div class="product-info-label">재고 위치</div>
                              <div class="product-price-value">{{ product.location || '미지정' }}</div>
                            </div>
                            <div class="product-price-item">
                              <div class="product-info-label">재고 수량</div>
                              <div class="product-price-value">{{ product.stock_quantity || 0 }}개</div>
                            </div>
                          </div>
                        </div>

                        <!-- * 가상계좌 정보 카드 -->
                        <div class="product-info-card">
                          <h4 class="product-card-title">가상계좌 정보</h4>
                          <div class="product-price-row">
                            <div class="product-price-item">
                              <div class="product-info-label">발송 여부</div>
                              <label class="product-toggle-switch">
                                <input type="checkbox" v-model="product.claimYn" :id="`billing-toggle-${index}`" />
                                <span class="slider"></span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </StoreOrderTable>
        </OrderUpProductTableContainer>

        <!-- !합계 정보 영역 -->
        <OrderTotalArea>
          <TotalInfoContainer>
            <TotalInfoItem>
              <span>결제 수단:</span>
              <PaymentMethodContainer>
                <PaymentMethodLabel>
                  <input type="radio" v-model="storePaymentMethod" value="1" name="storePaymentMethod">
                  현금
                </PaymentMethodLabel>
                <PaymentMethodLabel>
                  <input type="radio" v-model="storePaymentMethod" value="2" name="storePaymentMethod">
                  가상계좌
                </PaymentMethodLabel>
                <PaymentMethodLabel>
                  <input type="radio" v-model="storePaymentMethod" value="3" name="storePaymentMethod">
                  신용카드
                </PaymentMethodLabel>
                <PaymentMethodLabel>
                  <input type="radio" v-model="storePaymentMethod" value="4" name="storePaymentMethod">
                  바로빌
                </PaymentMethodLabel>
                <PaymentMethodLabel>
                  <input type="radio" v-model="storePaymentMethod" value="5" name="storePaymentMethod">
                  기타
                </PaymentMethodLabel>
              </PaymentMethodContainer>
            </TotalInfoItem>
            <TotalInfoItem v-if="rentalTypes.hasOxygenGenerator">
              <span>총 본인부담금:</span>
              <span>{{ totalFormattedCopayment }}</span>
            </TotalInfoItem>
          </TotalInfoContainer>
          <SummaryRightContainer>
            <TotalInfoItem>
              <span>총 수량:</span>
              <span>{{ totalStoreQuantity }}개</span>
            </TotalInfoItem>
            <TotalInfoItem>
              <span>총 합계:</span>
              <span>{{ format.price(totalStorePrice) }}원</span>
            </TotalInfoItem>
          </SummaryRightContainer>
        </OrderTotalArea>
        <!-- ! 품목추가 영역 -->
        <OrderUpProductUpArea>
          <OrderUpPorudctUpBtn @click="openStoreProductModal">
            <Plus />&nbsp;품목추가
          </OrderUpPorudctUpBtn>
        </OrderUpProductUpArea>
      </StoreOrderArea>

      <!-- ! 청구 정보 영역 -->
      <PasteFocusableSection
        v-if="(rentalTypes.hasOxygenGenerator || rentalTypes.hasDiabetesProduct || rentalTypes.hasAssistanceProduct) && !isLoadingClaimInfo"
        @paste="handleFilePaste" tabindex="0" @focus="handleDocumentSectionFocus" @blur="handleDocumentSectionBlur"
        :class="{ 'paste-focus': isPasteFocused }" ref="claimSection">
        <DocumentHeader>
          <DocumentTitle>청구 정보</DocumentTitle>
          <div style="display: flex; align-items: center;">
            <FileUploadButton @click="triggerFileInput">
              <FileUpload />파일등록
            </FileUploadButton>
            <RequiredDocsButton @click="showRequiredDocumentsModalData">
              <TextBoxCheckOutline />필수 서류 목록
            </RequiredDocsButton>
            <ClaimServiceBtn @click="showModal_obj.contract_up = true">
              <Printer />청구 서류 출력
            </ClaimServiceBtn>
          </div>
          <PasteHintWrapper>
            <PasteHintHoverBox>
              <ClipboardIconWrapper>
                <ClipboardIcon :size="20" :style="{ paddingTop: '3px' }" />
              </ClipboardIconWrapper>
              Ctrl+V로 파일 붙여넣기 가능
            </PasteHintHoverBox>

            <PasteHintTooltip class="tooltip">
              🔍 파일 등록정보 영역에 마우스를 클릭하고<br>CTRL + V를 눌러 이미지를 등록할 수 있습니다.
            </PasteHintTooltip>
          </PasteHintWrapper>
          <input type="file" :id="fileInputId" ref="fileInput" @change="handleFileSelect" multiple
            accept=".jpg,.jpeg,.png,.pdf" style="display: none" />
        </DocumentHeader>

        <!-- * 청구 등록 프로세스 - 컴팩트한 정부 스타일 -->
        <ClaimProcessContainer>
          <ProcessStepsContainer>
            <!-- 0단계: 청구 정보 입력 -->
            <ProcessStep>
              <StepIconContainer :active="currentStep >= 0" :inProgress="getStepStatus(0) === 'in-progress'">
                <CheckCircle :size="20" :color="currentStep >= 0 ? '#2563eb' : '#94a3b8'" />
              </StepIconContainer>
              <StepTitle>0단계</StepTitle>
              <StepButton :active="currentStep >= 0" @click="openClaimInfoInput">
                청구 정보 입력
              </StepButton>
              <StepStatus :class="getStepStatus(0)">
                {{ getStepStatusText(0) }}
              </StepStatus>
            </ProcessStep>

            <!-- 1단계: 환자 등록 -->
            <ProcessStep>
              <StepIconContainer :active="currentStep >= 1" :inProgress="getStepStatus(1) === 'in-progress'">
                <CheckCircle :size="20" :color="currentStep >= 1 ? '#2563eb' : '#94a3b8'" />
              </StepIconContainer>
              <StepTitle>1단계</StepTitle>
              <StepButton :active="currentStep >= 1" @click="openPatientRegistration">
                환자 등록
              </StepButton>
              <StepStatus :class="getStepStatus(1)">
                {{ getStepStatusText(1) }}
              </StepStatus>
            </ProcessStep>

            <!-- 2단계: 요양비청구위임내역등록 -->
            <ProcessStep>
              <StepIconContainer :active="currentStep >= 2" :inProgress="getStepStatus(2) === 'in-progress'">
                <CheckCircle :size="20" :color="currentStep >= 2 ? '#2563eb' : '#94a3b8'" />
              </StepIconContainer>
              <StepTitle>2단계</StepTitle>
              <StepButton :active="currentStep >= 2" @click="submitClaimList">
                위임내역등록
              </StepButton>
              <StepStatus :class="getStepStatus(2)">
                {{ getStepStatusText(2) }}
              </StepStatus>
            </ProcessStep>

            <!-- 3단계: 청구 등록 -->
            <ProcessStep>
              <StepIconContainer :active="currentStep >= 3" :inProgress="getStepStatus(3) === 'in-progress'">
                <CheckCircle :size="20" :color="currentStep >= 3 ? '#2563eb' : '#94a3b8'" />
              </StepIconContainer>
              <StepTitle>3단계</StepTitle>
              <StepButton :active="currentStep >= 3" @click="submitClaim">
                청구등록
              </StepButton>
              <StepStatus :class="getStepStatus(3)">
                {{ getStepStatusText(3) }}
              </StepStatus>
            </ProcessStep>
          </ProcessStepsContainer>
        </ClaimProcessContainer>

        <!-- 파일 목록 테이블 -->
        <Table v-if="documents">
          <thead>
            <tr>
              <TableHeader width="10%">
                <input type="checkbox" :checked="selectAll" @change="toggleSelectAll"
                  style="width: 20px; height: 20px; cursor: pointer;" />
              </TableHeader>
              <TableHeader width="15%">등록일자</TableHeader>
              <TableHeader width="25%" align="left">파일</TableHeader>
              <TableHeader width="25%">삭제</TableHeader>
            </tr>
          </thead>
          <tbody>
            <TableRow v-for="(doc, index) in documents" :key="index">
              <TableCell align="center">
                <input type="checkbox" v-model="doc.selected" @change="handleSelection"
                  style="width: 20px; height: 20px; cursor: pointer;" />
              </TableCell>
              <TableCell align="center">{{ formatDate(doc.registeredDate) }}</TableCell>
              <TableCell align="left">
                <ImageContainer>
                  <!-- 이미지 파일인 경우 -->
                  <Thumbnail v-if="isImageFile(doc.fileName)" :src="doc.url" :alt="doc.fileName"
                    @click="openPreview(doc)" @error="handleImageError" />

                  <!-- PDF 파일인 경우 -->
                  <div v-else-if="isPdfFile(doc.fileName)" class="pdf-file-icon" @click="openPreview(doc)"
                    style="width: 45px; height: 45px; background: #f44336; color: white; display: flex; align-items: center; justify-content: center; border-radius: 8px; cursor: pointer; font-size: 12px; font-weight: bold;">
                    PDF
                  </div>

                  <!-- 기타 파일인 경우 -->
                  <div v-else class="file-icon"
                    style="width: 45px; height: 45px; background: #9e9e9e; color: white; display: flex; align-items: center; justify-content: center; border-radius: 8px; cursor: pointer; font-size: 12px; font-weight: bold;">
                    FILE
                  </div>

                  <span>{{ doc.fileName }}</span>
                </ImageContainer>
              </TableCell>
              <TableCell align="center">
                <DeleteButton @click="removeDocument(index)">
                  <Delete :size="25" />
                </DeleteButton>
              </TableCell>
            </TableRow>
            <tr v-if="!documents.length">
              <EmptyMessage colspan="5">
                등록된 파일이 없습니다.
              </EmptyMessage>
            </tr>
          </tbody>
        </Table>

        <PreviewModal v-if="selectedPreviewImage" @click="closePreview">
          <!-- PDF 파일인 경우 더 큰 PreviewContent 사용 -->
          <PreviewContentPdf v-if="selectedPreviewImage.fileType === 'pdf'" @click.stop>
            <ClosePreviewButton @click="closePreview">×</ClosePreviewButton>
            <PdfPreviewContainer>
              <PdfPreviewHeader>
                <h3>{{ selectedPreviewImage.fileName }}</h3>
              </PdfPreviewHeader>
              <PdfIframe :src="selectedPreviewImage.url" @error="handlePdfError">
                <p>PDF를 표시할 수 없습니다. <a :href="selectedPreviewImage.url" target="_blank">여기를 클릭하여 새 탭에서 열기</a></p>
              </PdfIframe>
            </PdfPreviewContainer>
          </PreviewContentPdf>

          <!-- 이미지 파일인 경우 기존 PreviewContent 사용 -->
          <PreviewContent v-else @click.stop>
            <ClosePreviewButton @click="closePreview">×</ClosePreviewButton>

            <PreviewImage v-if="selectedPreviewImage.fileType === 'image'" :src="selectedPreviewImage.url"
              :alt="selectedPreviewImage.fileName" />

            <!-- 기타 파일인 경우 -->
            <div v-else style="text-align: center; padding: 40px;">
              <div style="font-size: 48px; color: #9e9e9e; margin-bottom: 20px;"></div>
              <h3>{{ selectedPreviewImage.fileName }}</h3>
              <p>이 파일은 미리보기를 지원하지 않습니다.</p>
            </div>
          </PreviewContent>
        </PreviewModal>
      </PasteFocusableSection>

      <ClaimLoadingMessage
        v-else-if="(rentalTypes.hasOxygenGenerator || rentalTypes.hasDiabetesProduct || rentalTypes.hasAssistanceProduct) && isLoadingClaimInfo">
        <ClaimLoadingSpinner />
        <ClaimLoadingText>청구 정보를 불러오는 중입니다</ClaimLoadingText>
      </ClaimLoadingMessage>
    </OrderModifyProductArea>
  </OrderModifyDiv>

  <!-- ! Footer -->
  <OrderModifyFooterArea>
    <OrderModifyServiceBtnArea>
      <OrderModifyServiceBtn @click="showModal_obj.doc_print = true">
        <Printer />&nbsp;&nbsp;&nbsp;계약서 출력
      </OrderModifyServiceBtn>
      <!-- <OrderModifyServiceBtn @click="showClaimTypeModal">
        <TextBoxCheckOutline />&nbsp;&nbsp;&nbsp;공단청구
      </OrderModifyServiceBtn> -->
    </OrderModifyServiceBtnArea>
    <OrderModifySubmitBtnArea>
      <!-- 반품 주문서일 경우 -->
      <template v-if="isReturnOrder">
        <OrderModifySubmitBtn @click="cancelReturnOrder" style="background-color: #dc3545; color: white;">
          <Close />&nbsp;&nbsp;&nbsp;반품취소
        </OrderModifySubmitBtn>
        <OrderModifySubmitBtn @click="showReturnStatusModal" style="background-color: #007bff; color: white;">
          <Refresh />&nbsp;&nbsp;&nbsp;반품상태변경
        </OrderModifySubmitBtn>
        <OrderModifySubmitBtn @click="submitOrder">
          <Wrench />&nbsp;&nbsp;&nbsp;주문수정
        </OrderModifySubmitBtn>
      </template>

      <!-- A/S 주문서일 경우 -->
      <template v-else-if="isAsOrder">
        <OrderModifySubmitBtn @click="cancelAsOrder" style="background-color: #dc3545; color: white;">
          <Close />&nbsp;&nbsp;&nbsp;A/S 취소
        </OrderModifySubmitBtn>
        <OrderModifySubmitBtn @click="showAsStatusModal" style="background-color: #007bff; color: white;">
          <Refresh />&nbsp;&nbsp;&nbsp;A/S 상태변경
        </OrderModifySubmitBtn>
        <OrderModifySubmitBtn @click="submitOrder">
          <Wrench />&nbsp;&nbsp;&nbsp;주문수정
        </OrderModifySubmitBtn>
      </template>

      <!-- 일반 주문서일 경우 기존 버튼 노출 -->
      <template v-else>
        <OrderModifySubmitBtn @click="showAsPopup">A/S접수</OrderModifySubmitBtn>
        <OrderModifySubmitBtn @click="showOrderReturnPopup">반품주문</OrderModifySubmitBtn>
        <!-- <OrderModifySubmitBtn v-if="orderStatus == 1" @click="changeOrderStatus(2)">
        <Check />&nbsp;&nbsp;&nbsp;주문확정
      </OrderModifySubmitBtn>
      <OrderModifySubmitBtn v-if="orderStatus == 2" @click="changeOrderStatus(1)">
        <Check />&nbsp;&nbsp;&nbsp;주문확정취소
      </OrderModifySubmitBtn>
      <OrderModifySubmitBtn v-if="orderStatus == 2" @click="changeOrderStatus(3)">
        <Check />&nbsp;&nbsp;&nbsp;출고처리
      </OrderModifySubmitBtn> -->
        <OrderModifySubmitBtn v-if="orderStatus == 3" @click="changeOrderStatus(4)">
          <Check />&nbsp;&nbsp;&nbsp;{{ rentalTypes.hasRentalProduct ? '회수등록' : '출고취소' }}
        </OrderModifySubmitBtn>
        <OrderModifySubmitBtn @click="submitOrder">
          <Wrench />&nbsp;&nbsp;&nbsp;주문수정
        </OrderModifySubmitBtn>
      </template>
    </OrderModifySubmitBtnArea>
  </OrderModifyFooterArea>

  <!-- * 청구 유형 선택 모달 -->
  <ClaimModal v-model:show="showModal_obj.claim_type" @select-type="selectClaimType" />
  <!-- * 가상계좌 모달 -->
  <ModalPage v-model:show="showModal_obj.virtual_up" :width="modal_width.virtual_up" :height="modal_height.virtual_up">
    <VirtualAccountModal :products="getSelectedStoreProducts()" :orderData="client_data_obj"
      @update:accountCount="updateVirtualAccountCount" @close="closeVirtualAccountModal" />
  </ModalPage>
  <!-- * 품목추가 모달 -->
  <ModalPage v-model:show="showModal_obj.product_up" :width="modal_width.product_up" :height="modal_height.product_up">
    <ProductGetPage @productDetail="handleProductDetail" :existingProducts="products_obj" />
  </ModalPage>
  <!-- * 수급자 불러오기 모달 -->
  <ModalPage v-model:show="showModal_obj.client_up" :width="modal_width.client_up" :height="modal_height.client_up">
    <ClientGetModal @clientDetail="handleClientDetail" @close="showModal_obj.client_up = false" />
  </ModalPage>
  <!-- * 거래처 불러오기 모달 -->
  <ModalPage v-model:show="showModal_obj.company_up" :width="modal_width.company_up" :height="modal_height.company_up">
    <CompanyGetModal @companyDetail="handleCompanyDetail" @close="showModal_obj.company_up = false" />
  </ModalPage>
  <!-- * 계약서 출력 모달 -->
  <ModalPage v-model:show="showModal_obj.doc_print" :width="modal_width.doc_print" :height="modal_height.doc_print">
    <DocPrints :pageUrls="pageUrls" :products_obj="products_obj" :client_data_obj="client_data_obj"
      :postcode_obj="postcode_obj" />
  </ModalPage>
  <!-- * 청구 서류 출력 모달 -->
  <ModalPage v-model:show="showModal_obj.contract_up" :width="modal_width.contract_up"
    :height="modal_height.contract_up">
    <ContractModal :contractData="contractDataForModal" :products="productsForContract"
      @close="showModal_obj.contract_up = false" @register-pdf="handlePDFRegistration"
      @register-all-pdf="handleAllPDFRegistration" />
  </ModalPage>
  <!-- * 청구계산 팝업 -->
  <ModalPage v-model:show="showModal_obj.claim_calculation" :width="modal_width.claim_calculation"
    :height="modal_height.claim_calculation">
    <ClaimCalculationPopup ref="claimCalculationPopup" :show="showModal_obj.claim_calculation"
      :selectedProducts="getSelectedProductsForClaim()" :orderType="getCurrentClaimType()"
      @close="showModal_obj.claim_calculation = false" />
  </ModalPage>
  <!-- * 필수 서류 목록 모달 -->
  <ModalPage v-model:show="showRequiredDocumentsModal" :width="modal_width.required_documents"
    :height="modal_height.required_documents">
    <RequiredDocumentsModal :claimType="getCurrentClaimType()" @close="showRequiredDocumentsModal = false" />
  </ModalPage>
  <!-- * 공단지사 선택 모달 -->
  <ModalPage v-model:show="showModal_obj.branch_selection" :width="modal_width.branch_selection"
    :height="modal_height.branch_selection">
    <BranchModal :orderId="orderId" :orderData="client_data_obj" :claimType="getCurrentClaimType()"
      :initialPatientInfo="getPatientInfo()" :selectedFiles="getSelectedFiles()" :products="products_obj"
      @branch-changed="handleBranchChanged" @patient-registered="handlePatientRegistered"
      @close="showModal_obj.branch_selection = false" />
  </ModalPage>
  <!-- * 청구 정보 입력 모달 -->
  <ModalPage v-model:show="showClaimInfoModal" :width="modal_width.claim_info" :height="modal_height.claim_info">
    <OxygenClaimInfoModal v-if="showClaimInfoModal && getCurrentClaimType() === 'oxygen'" :orderId="orderId"
      :orderData="orderData" :claimType="'oxygen'" :products="products_obj" :rentalTypes="rentalTypes"
      :additionalData="getAdditionalClaimData()" @claim-info-saved="onClaimInfoSaved" @close="closeClaimInfoModal" />

    <DiabetesClaimInfoModal v-if="showClaimInfoModal && getCurrentClaimType() === 'diabetes'" :orderId="orderId"
      :orderData="orderData" :claimType="'diabetes'" :products="orderData.products || []" :rentalTypes="rentalTypes"
      :additionalData="getAdditionalClaimData()" @claim-info-saved="onClaimInfoSaved" @close="closeClaimInfoModal" />
  </ModalPage>
  <!-- * 문서 발행 모달 -->
  <ModalPage v-model:show="showModal_obj.document_issuance" :width="modal_width.document_issuance"
    :height="modal_height.document_issuance">
    <DocumentIssuanceModal v-if="showModal_obj.document_issuance" :orderId="orderId" :products="products_obj"
      :orderData="client_data_obj" :claimType="getCurrentClaimType()" @complete="onDocumentIssuanceComplete"
      @close="showModal_obj.document_issuance = false" />
  </ModalPage>
  <!--* 문자 발송 모달 -->
  <SmsSendModal v-if="showModal_obj.sms_up" :width="modal_width.sms_up" :height="modal_height.sms_up"
    :recipient="selectedCustomer" @close="showModal_obj.sms_up = false" />
</template>

<script>
import { ref, reactive, h, createApp } from 'vue';
import * as injectGlobal from '@/assets/styles/global/public.js';
import * as OrderUpCss from '@/assets/styles/order/OrderUpCss.js';
import * as OrderModifyCss from '@/assets/styles/order/OrderModifyCss.js'
import { ProductExpandedRowStyles } from "@/assets/styles/order/OrderModifyCss.js";;
import DocPrints from '@/components/order/modal/DocPrintsModal.vue';
import ContractModal from '@/components/order/modal/ContractModal.vue';
import ProductGetPage from '@/components/product/modal/ProductGetModal.vue';
import OrderReturnPopup from '@/components/order/popup/OrderReturnPopup.vue';
import OrderAsPopup from '@/components/order/popup/OrderAsPopup.vue';

// 모달 컴포넌트
import ModalPage from '@/components/layout/ModalPage.vue';
import ClientGetModal from '@/components/order/modal/ClientGetModal.vue';
import CompanyGetModal from '@/components/order/modal/CompanyGetModal.vue';
import VirtualAccountModal from '@/components/order/modal/VirtualAccountModal.vue';
import ClaimModal from '@/components/layout/ClaimModal.vue';
import ClaimCalculationPopup from '@/components/order/popup/ClaimCalculationPopup.vue';
import RequiredDocumentsModal from '@/components/claim/modal/RequiredDocumentsModal.vue';
import BranchModal from '@/components/order/modal/BranchModal.vue';
import OxygenClaimInfoModal from '@/components/order/modal/OxygenClaimInfoModal.vue';
import DiabetesClaimInfoModal from '@/components/order/modal/DiabetesClaimInfoModal.vue';
import DocumentIssuanceModal from '@/components/order/modal/DocumentIssuanceModal.vue';
import SmsSendModal from '@/components/Manage/modal/SmsSendModal.vue';

// 아이콘 컴포넌트
import Datepicker from 'vue-datepicker-next';
import Delete from 'vue-material-design-icons/Delete.vue';
import Wrench from 'vue-material-design-icons/Wrench.vue';
import Check from 'vue-material-design-icons/Check.vue';
import Printer from 'vue-material-design-icons/Printer.vue';
import Close from 'vue-material-design-icons/Close.vue';
import Attachment from 'vue-material-design-icons/Attachment.vue';
import TextBoxCheckOutline from 'vue-material-design-icons/TextBoxCheckOutline.vue';
import CheckCircle from 'vue-material-design-icons/CheckCircle.vue';
import SwapVertical from 'vue-material-design-icons/SwapVertical.vue';
import Plus from 'vue-material-design-icons/Plus.vue';
import FileUpload from 'vue-material-design-icons/FileUpload.vue';
import ChevronDown from "vue-material-design-icons/ChevronDown.vue";
import ChevronUp from "vue-material-design-icons/ChevronUp.vue";
import Refresh from "vue-material-design-icons/Refresh.vue";
import ClipboardIcon from 'vue-material-design-icons/ClipboardText.vue';

import * as pdfjsLib from 'pdfjs-dist';

export default {
  name: 'OrderModifyPage',

  components: {
    ...injectGlobal,
    ...OrderUpCss,
    ...OrderModifyCss,
    ModalPage,
    ClientGetModal,
    CompanyGetModal,
    ProductGetPage,
    VirtualAccountModal,
    Delete, Wrench, Check, Printer, Close, Attachment, TextBoxCheckOutline, CheckCircle, SwapVertical, Plus, FileUpload, ChevronDown, ChevronUp, Refresh, ClipboardIcon,
    Datepicker,
    DocPrints,
    ContractModal,
    ClaimModal,
    ClaimCalculationPopup,
    RequiredDocumentsModal,
    BranchModal,
    OxygenClaimInfoModal,
    DiabetesClaimInfoModal,
    DocumentIssuanceModal,
    SmsSendModal
  },

  props: {
    orderId: {
      type: [String, Number],
      required: true
    },
    orderData: {
      type: Object,
      default: () => ({})
    },
    parent: {
      type: String,
      default: 'order'
    }
  },

  inject: ['globalMessageSystem'],

  emits: [
    'order-updated',
    'close-modal',
    'close-return-modal',
    'close-as-modal',
    'return-registered',
    'return-cancelled',
    'imagesUploaded',
    'progress-update'
  ],

  setup() {
    pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;
    const priceInputs = ref([]);
    const orderCommentAdd = ref('');
    const products_obj = ref([]);
    const color_obj = reactive({});
    const client_data_obj = reactive({
      orderId: '',
      orderdate: '',
      name: '',
      number: '',
      regident: '',
      email: '',
      address: '',
      guardname: '',
      guardtarget: '',
      centername: '',
      manager: '',
      oxygen_type: '가정용',
      oxygen_start: null,
      oxygen_end: null,
      rental_start: null,
      rental_end: null,
      diabetes_start: null,
      diabetes_end: null
    });
    const showModal_obj = reactive({
      client_up: ref(false),
      company_up: ref(false),
      product_up: ref(false),
      doc_print: ref(false),
      contract_up: ref(false),
      virtual_up: ref(false),
      claim_up: ref(false),
      claim_type: ref(false),
      assistance_up: ref(false),
      diabetes_up: ref(false),
      claim_calculation: ref(false),
      required_documents: ref(false),
      branch_selection: ref(false),
      claim_info: ref(false),
      document_issuance: ref(false),
      sms_up: ref(false)
    });
    const modal_width = {
      client_up: '65%',
      company_up: '65%',
      product_up: '85%',
      doc_print: '60%',
      contract_up: '40%',
      virtual_up: '75%',
      claim_up: '80%',
      assistance_up: '80%',
      diabetes_up: '80%',
      claim_calculation: '50%',
      required_documents: '30%',
      branch_selection: '50%',
      claim_info: '80%',
      document_issuance: '55%',
      sms_up: '50%'
    };
    const modal_height = {
      client_up: '80%',
      company_up: '80%',
      product_up: '80%',
      doc_print: '80%',
      contract_up: '85%',
      virtual_up: '80%',
      claim_up: '80%',
      assistance_up: '80%',
      diabetes_up: '80%',
      claim_calculation: '60%',
      required_documents: '70%',
      branch_selection: '65%',
      claim_info: '80%',
      document_issuance: '65%',
      sms_up: '80%'
    };
    const postcode_obj = reactive({
      postcode1: '',
      address1: '',
      detailAddress1: '',
      postcode2: '',
      address2: '',
      detailAddress2: '',
    });
    const delivery_date = null;
    const delivery_time = '0';
    const deliveryMethod = ref("1");
    const deliveryStatus = ref("0");

    // 매장 품목 추가 모달 열기
    const openStoreProductModal = () => {
      showModal_obj.product_up = true;
    };

    // 공단청구 모달 크기 관리
    const currentClaimModalSize = reactive({
      width: modal_width.claim_up,
      height: modal_height.claim_up
    });

    // 공단청구 모달 크기 업데이트
    const updateClaimModalSize = ({ width, height }) => {
      currentClaimModalSize.width = width;
      currentClaimModalSize.height = height;
    };

    const ko = {
      formatLocale: {
        months: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
        monthsShort: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
        weekdays: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'],
        weekdaysShort: ['일', '월', '화', '수', '목', '금', '토'],
        weekdaysMin: ['일', '월', '화', '수', '목', '금', '토'],
        firstDayOfWeek: 0,
        firstWeekContainsDate: 1,
        meridiem: (h) => (h < 12 ? '오전' : '오후'),
        meridiemParse: /오전|오후/,
        isPM: (input) => input === '오후'
      },
      yearFormat: 'YYYY년',
      monthFormat: 'MMM',
      monthBeforeYear: false
    };

    return {
      showModal_obj,
      modal_width,
      modal_height,
      postcode_obj,
      client_data_obj,
      products_obj,
      color_obj,
      delivery_date,
      delivery_time,
      deliveryMethod,
      deliveryStatus,
      orderCommentAdd,
      priceInputs,
      openStoreProductModal,
      currentClaimModalSize,
      updateClaimModalSize,
      ko
    };
  },

  data() {
    return {
      isPasteFocused: false,
      showVirtualModal: false,
      showRequiredDocumentsModal: false,
      showClaimInfoModal: false,
      showContractModal: false,
      selectedImage: '',
      salesPerson: '없음',
      orderDate: null,
      selectedDeliveryMemo: '',
      orderStatus: 0,
      format: {
        price: (price) => {
          return new Intl.NumberFormat('ko-KR', {
            style: 'decimal',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }).format(price);
        },
        date: (dateString) => {
          const date = new Date(dateString);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        }
      },
      // pageUrls: [`${this.$apiUrls.hanq}/btransactionfileNew`], // 계약서 출력 주소
      pageUrls: [`${window.location.origin}/btransactionfileNew.html`], // 계약서 출력 주소
      orderComment: [],
      imageFiles: [],
      showImageModal: false,
      manager: [],
      returnPopupInstance: null,
      asPopupInstance: null,
      storePaymentMethod: '1', // 매장 결제방식
      paymentMethod: '1',      // 결제방식
      storePriceInputs: {},    // 매장 단가 input 요소 참조를 저장할 객체
      marginInputs: {},        // 차액 입력
      virtualAccountCount: 0,
      showVirtualAccountModal: false,
      images: [],
      selectedFileNames: '',
      fileInputId: `file-input-${Date.now()}`,
      selectedImages: [],
      selectedPreviewImage: null,
      documents: null,
      selectAll: false,
      feedbacks: [],
      hasFeedback: false,
      feedbacksData: [],
      feedbackChanged: false,
      companykey: localStorage.getItem('companykey') || '',
      // 품목 이미지 미리보기
      imagePreviewUrl: null,
      imagePreviewTimer: null,
      imagePreviewStyle: {
        top: '0px',
        left: '0px'
      },
      // 주문서 타입 확인
      rentalTypes: {
        hasRentalProduct: false,
        hasOxygenGenerator: false,
        hasDiabetesProduct: false,
        hasAssistanceProduct: false
      },
      actualOrderId: null, // 실제 사용할 주문서 ID
      // A/S 관련
      isAsOrder: false, // A/S 주문 여부
      asOrderNum: null, // A/S 주문 번호
      asStatus: null, // A/S 상태 (0:접수, 1:승인, 2:수리중, 3:검수, 4:완료)
      asOrderId: null, // A/S 주문 ID 저장
      // 반품 관련
      isReturnOrder: false, // 반품 주문 여부
      returnOrderNum: null, // 반품 주문 번호
      returnStatus: null, // 반품 상태 (0: 접수, 1: 승인, 2: 회수, 3: 검수, 4: 환불/교환)
      returnOrderId: null, // 반품 주문 ID 저장

      // 청구 프로세스 관련 데이터
      showPatientModal: false,
      showAuthorizationModal: false,
      patientForm: {
        name: '',
        number: '',
        claimType: '',
        phone: '',
        address: '',
        birthDate: ''
      },
      claimStatus: {
        hasClaimData: false,
        currentStep: 0,
        currentStepText: '',
        isCompleted: false
      },
      diabetesClaimStatus: {
        hasClaimData: false,
        currentStep: 0,
        currentStepText: '',
        isCompleted: false
      },
      selectedBranch: null,
      branches: [
        { id: 1, name: '서울특별시지사', code: 'SEOUL' },
        { id: 2, name: '부산광역시지사', code: 'BUSAN' },
        { id: 3, name: '대구광역시지사', code: 'DAEGU' },
        { id: 4, name: '인천광역시지사', code: 'INCHEON' },
        { id: 5, name: '광주광역시지사', code: 'GWANGJU' },
        { id: 6, name: '대전광역시지사', code: 'DAEJEON' },
        { id: 7, name: '울산광역시지사', code: 'ULSAN' },
        { id: 8, name: '세종특별자치시지사', code: 'SEJONG' },
        { id: 9, name: '경기도지사', code: 'GYEONGGI' },
        { id: 10, name: '강원도지사', code: 'GANGWON' },
        { id: 11, name: '충청북도지사', code: 'CHUNGBUK' },
        { id: 12, name: '충청남도지사', code: 'CHUNGNAM' },
        { id: 13, name: '전라북도지사', code: 'JEONBUK' },
        { id: 14, name: '전라남도지사', code: 'JEONNAM' },
        { id: 15, name: '경상북도지사', code: 'GYEONGBUK' },
        { id: 16, name: '경상남도지사', code: 'GYEONGNAM' },
        { id: 17, name: '제주특별자치도지사', code: 'JEJU' }
      ],
      isLoadingClaimInfo: true,
      virtualAccountHistory: [],

      // 문서 발행 관련
      showDocumentIssuanceModal: false,
      documentIssuanceInfo: {
        hasTaxInvoice: false,
        hasCashReceipt: false,
        mgtKey: null,
        mgtKey2: null
      },
      pendingClaimData: null
    };
  },

  computed: {
    // 계약서용 계약 데이터 (원시 데이터만 전달)
    contractDataForModal() {
      console.log(this.client_data_obj)
      return {
        companykey: this.$globalState.company_key,
        contractDate: new Date(),
        companyName: this.$globalState.company,
        companyAddress: this.$globalState.company_address,
        companyContact: this.$globalState.company_phone,
        companyBnum: this.$globalState.company_bnum,
        companyCeoName: this.$globalState.company_ceo_name,
        customerName: this.client_data_obj.name,
        customerAddress: this.getFullAddress(),
        customerContact: this.client_data_obj.phone1,
        customerIdNumber: this.client_data_obj.number,
        guardName: this.client_data_obj.guardname,
        guardTarget: this.client_data_obj.guardtarget,
        bank_name: this.$globalState.bank_name,
        bank_number: this.$globalState.bank_number,
        bank_username: this.$globalState.bank_username,
        orderId: this.orderId
      };
    },

    // 계약서용 제품 데이터 (원시 데이터만 전달)
    productsForContract() {
      return this.products_obj.map(product => ({
        ...product, // 원시 제품 데이터 전체 전달
        rentalStart: this.client_data_obj.rental_start,
        rentalEnd: this.client_data_obj.rental_end,
        oxygenStart: this.client_data_obj.oxygen_start,
        oxygenEnd: this.client_data_obj.oxygen_end
      }));
    },
    // 현재 단계 계산
    currentStep() {
      return this.claimStatus.currentStep || 0;
    },
    isTestUser() {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        return userInfo && userInfo.id === 'test';
      } catch (error) {
        return false;
      }
    },

    // 낱개 당 가격 계산 함수
    calculateUnitPrice() {
      return (product) => {
        if (!product || product.type !== '박스') return 0;

        const buyPrice = parseInt(product.buyprice || product.price || 0);
        const piecesPerBox = parseInt(product.pieces_per_box || 0);

        if (piecesPerBox <= 0) return 0;

        // 낱개 당 가격 = 구입가격 / 박스 당 개수
        const unitPrice = Math.round(buyPrice / piecesPerBox);
        return this.format.price(unitPrice);
      };
    },
    // 합계 수량 계산 함수
    calculateTotalQuantity() {
      return (product) => {
        if (!product) return 0;

        const quantity = parseInt(product.quantity) || 0;
        const pieceQuantity = parseInt(product.piece_quantity) || 0;

        if (product.type === '박스') {
          // 박스인 경우: (박스 수량 × 박스당 개수) + 낱개 수량
          const piecesPerBox = parseInt(product.pieces_per_box) || 0;
          return (quantity * piecesPerBox) + pieceQuantity;
        } else {
          // 낱개인 경우: 품목 수량 + 낱개 수량
          return quantity + pieceQuantity;
        }
      };
    },
    tableStyles() {
      return {
        width: this.parent === 'rental' ? '100%' : '90%',
        margin: '0 auto'
      }
    },
    totalStoreQuantity() {
      return this.products_obj.reduce((total, product) => total + (product.quantity || 0), 0);
    },
    totalStorePrice() {
      return this.products_obj.reduce((total, product) => {
        const unitPrice = this.getStoreUnitPrice(product);
        return total + (unitPrice * (product.quantity || 0));
      }, 0);
    },
    calculateCopayment() {
      try {
        // 현재 제품의 단가 가져오기
        const unitPrice = this.getStoreUnitPrice(this.products_obj) || 0;

        // 단가의 10% 계산
        return Math.round(unitPrice * 0.1);
      } catch (error) {
        console.error('본인부담금 계산 중 오류:', error);
        return 0;
      }
    },
    totalCalculateCopayment() {
      try {
        // totalStorePrice의 10% 계산
        return Math.round(this.totalStorePrice * 0.1);
      } catch (error) {
        console.error('본인부담금 계산 중 오류:', error);
        return 0;
      }
    },
    formattedCopayment() {
      const copayment = this.calculateCopayment;
      return new Intl.NumberFormat('ko-KR').format(copayment) + '원';
    },
    totalFormattedCopayment() {
      const copayment = this.totalCalculateCopayment;
      return new Intl.NumberFormat('ko-KR').format(copayment) + '원';
    }
  },

  methods: {
    // PDF 등록 처리 메서드 수정
    async handlePDFRegistration(pdfData) {
      try {
        // File 객체인지 확인
        if (!(pdfData.file instanceof File)) {
          console.error('File 객체가 아닙니다:', pdfData.file);
          await Swal.fire({
            title: '오류',
            text: '잘못된 파일 형식입니다.',
            icon: 'error',
            confirmButtonText: '확인'
          });
          return;
        }

        await this.addFileToClaim(pdfData.file);

      } catch (error) {
        console.error('PDF 등록 실패:', error);
        await Swal.fire({
          title: '오류',
          text: 'PDF 등록 중 오류가 발생했습니다.',
          icon: 'error',
          confirmButtonText: '확인'
        });
      }
    },

    // 전체 PDF 등록 처리도 수정
    async handleAllPDFRegistration(data) {
      try {
        // 각 PDF 파일을 순차적으로 등록
        for (const pdfData of data.pdfs) {
          await this.addFileToClaim(pdfData.file, pdfData.fileName);
        }

      } catch (error) {
        console.error('전체 PDF 등록 실패:', error);

        Swal.fire({
          title: '오류',
          text: 'PDF 파일 등록 중 오류가 발생했습니다.',
          icon: 'error',
          confirmButtonText: '확인'
        });
      }
    },

    // 파일 추가 메서드 수정
    addFileToClaim(file, fileType = '') {
      const claimSection = this.$refs.claimSection;
      if (!claimSection) {
        console.error('청구 정보 섹션을 찾을 수 없습니다.');
        return;
      }

      const claimElement = claimSection.$el || claimSection;

      let fileInput = claimElement.querySelector('input[type="file"]');
      if (!fileInput) {
        fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.accept = '.pdf';
        fileInput.style.display = 'none';
        claimElement.appendChild(fileInput);
      }

      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(file);
      fileInput.files = dataTransfer.files;

      const changeEvent = new Event('change', { bubbles: true });
      fileInput.dispatchEvent(changeEvent);
    },

    getFullAddress() {
      const address1 = this.postcode_obj.address1 || '';
      const detailAddress1 = this.postcode_obj.detailAddress1 || '';

      if (address1 && detailAddress1) {
        return `${address1} ${detailAddress1}`;
      } else if (address1) {
        return address1;
      } else if (detailAddress1) {
        return detailAddress1;
      }

      return '';
    },

    getRentalTypesArray() {
      return Object.values(this.rentalTypes);
    },

    // 청구 정보 입력 모달 열기
    openClaimInfoInput() {
      this.showClaimInfoModal = true;
    },

    // 청구 정보 입력 모달 닫기
    closeClaimInfoModal() {
      this.showClaimInfoModal = false;
    },

    // 청구 정보 저장 처리
    handleClaimInfoSaved(claimData) {
      this.showClaimInfoModal = false;

      // 저장 성공 후 필요한 처리
      this.$swal.fire({
        icon: 'success',
        title: '청구 정보 저장 완료',
        text: '청구 정보가 성공적으로 저장되었습니다.',
        confirmButtonText: '확인'
      });
    },

    // 멤버 데이터 가져오기
    getMemberData() {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        return {
          id: userInfo?.id || '',
          name: userInfo?.name || '',
          email: userInfo?.email || '',
          phone: userInfo?.phone || '',
          center: userInfo?.center || '',
          role: userInfo?.role || ''
        };
      } catch (error) {
        console.error('멤버 데이터 가져오기 오류:', error);
        return {};
      }
    },

    // 추가 청구 데이터 가져오기
    getAdditionalClaimData() {
      const additionalData = {
        // 주문 기본 정보
        orderInfo: {
          orderId: this.orderId,
          orderDate: this.orderDate,
          salesPerson: this.salesPerson,
          deliveryMemo: this.selectedDeliveryMemo,
          returnStatus: this.returnStatus,
          virtualAccountHistory: this.virtualAccountHistory || []
        },

        // 수급자 상세 정보
        clientDetails: {
          name: this.client_data_obj.name || '',
          number: this.client_data_obj.number || '',
          resident: this.client_data_obj.regident || '',
          phone1: this.client_data_obj.phone1 || '',
          phone2: this.client_data_obj.phone2 || '',
          guardname: this.client_data_obj.guardname || '',
          guardtarget: this.client_data_obj.guardtarget || '',
          centername: this.client_data_obj.centername || '',
          manager: this.client_data_obj.manager || '',
          oxygen_type: this.client_data_obj.oxygen_type || '',
          rental_start: this.client_data_obj.rental_start || '',
          rental_end: this.client_data_obj.rental_end || '',
          oxygen_start: this.client_data_obj.oxygen_start || '',
          oxygen_end: this.client_data_obj.oxygen_end || ''
        },

        // 주소 정보
        addressInfo: {
          postcode1: this.postcode_obj.postcode1 || '',
          address1: this.postcode_obj.address1 || '',
          detailAddress1: this.postcode_obj.detailAddress1 || '',
          postcode2: this.postcode_obj.postcode2 || '',
          address2: this.postcode_obj.address2 || '',
          detailAddress2: this.postcode_obj.detailAddress2 || ''
        },

        // 품목 정보
        productInfo: {
          products: this.products_obj || [],
          selectedProducts: this.getSelectedProductsForClaim(),
          totalProducts: this.products_obj?.length || 0,
          rentalTypes: this.rentalTypes || []
        },

        // 청구 관련 정보
        claimInfo: {
          claimType: this.getCurrentClaimType(),
          isAsOrder: this.isAsOrder,
          isReturnOrder: this.isReturnOrder,
          currentStep: this.currentStep,
        },

        // 가상계좌 정보
        virtualAccountInfo: {
          virtualAccountCount: this.virtualAccountCount || 0,
          virtualAccountHistory: this.virtualAccountHistory || []
        }
      };

      return additionalData;
    },

    getSelectedFiles() {
      return this.documents ? this.documents.filter(doc => doc.selected) : [];
    },

    // 환자 정보 가져오기
    getPatientInfo() {
      return {
        name: this.client_data_obj.name || '',
        residentNum: this.client_data_obj.number || '',
        phone: this.client_data_obj.phone1 || '',
        startDate: this.client_data_obj.oxygen_start || this.client_data_obj.diabetes_start || '',
        endDate: this.client_data_obj.oxygen_end || this.client_data_obj.diabetes_end || ''
      };
    },

    // 공단 지사 변경 처리
    handleBranchChanged(branchData) {
      console.log('선택된 공단지사:', branchData);
    },

    // 환자 등록 완료 처리
    async handlePatientRegistered(registrationData) {
      console.log('환자 등록 완료:', registrationData);

      // 모달 닫기
      this.showModal_obj.branch_selection = false;

      // 청구 상태 다시 로드하여 1단계가 "완료"로 표시되도록 함
      await this.loadClaimStatus();

      // 주문 데이터 새로고침
      await this.fetchOrderData();

      console.log('환자 등록 완료 후 상태 업데이트 완료');
    },

    // 산소발생기 유형 판단 메서드
    determineOxygenType() {
      if (!this.products_obj || this.products_obj.length === 0) {
        return '가정용'; // 기본값
      }

      // 산소발생기 품목 찾기 - name1과 name2 필드 사용
      const oxygenProducts = this.products_obj.filter(product => {
        const name1 = (product.name1 || '').toLowerCase();
        const name2 = (product.name2 || '').toLowerCase();
        const name = (product.name || '').toLowerCase();
        const category = (product.category || '').toLowerCase();
        const pcode = (product.pcode || '').toLowerCase();

        return name1.includes('산소발생기') ||
          name2.includes('산소발생기') ||
          category.includes('산소') ||
          name.includes('산소발생기') ||
          name.includes('산소') ||
          pcode.includes('oxygen') ||
          pcode.includes('산소');
      });

      if (oxygenProducts.length === 0) {
        return '가정용'; // 산소발생기가 없으면 기본값
      }

      let hasHomeType = false;
      let hasPortableType = false;

      // 품목명이나 코드에서 휴대용/가정용 여부 판단
      for (const product of oxygenProducts) {
        const productName = (product.name || '').toLowerCase();
        const productName1 = (product.name1 || '').toLowerCase();
        const productName2 = (product.name2 || '').toLowerCase();

        // 휴대용 키워드 확인
        if (productName.includes('휴대') ||
          productName1.includes('휴대') ||
          productName2.includes('휴대')) {
          hasPortableType = true;
        }

        // 가정용 키워드 확인
        if (productName.includes('가정') ||
          productName1.includes('가정') ||
          productName2.includes('가정')) {
          hasHomeType = true;
        }
      }

      // 둘 다 있는 경우 처리
      if (hasHomeType && hasPortableType) {
        return '가정용/휴대용';
      } else if (hasPortableType) {
        return '휴대용';
      } else if (hasHomeType) {
        return '가정용';
      }

      // 키워드로 판단되지 않으면 기본값
      return '가정용';
    },

    // 품목이 변경될 때마다 산소발생기 유형 업데이트  
    updateOxygenType() {
      if (this.rentalTypes.hasOxygenGenerator || this.orderId?.rental_type === 'o') {
        const oxygenType = this.determineOxygenType();
        this.client_data_obj.oxygen_type = oxygenType;
      }
    },

    showRequiredDocumentsModalData() {
      this.showRequiredDocumentsModal = true;
    },

    getCurrentClaimType() {
      // rentalTypes를 기반으로 청구 타입 결정
      if (this.rentalTypes.hasOxygenGenerator || this.orderId?.rental_type === 'o') {
        return 'oxygen';
      } else if (this.rentalTypes.hasDiabetesProduct || this.orderId?.rental_type === 'd') {
        return 'diabetes';
      } else if (this.rentalTypes.hasAssistanceProduct || this.orderId?.rental_type === 'a') {
        return 'assistance';
      }

      // 기본값으로 'oxygen' 반환
      return 'oxygen';
    },

    // 청구 상태 가져오기
    getClaimStatus(type) {
      switch (type) {
        case 'oxygen':
          return this.oxygenClaimStatus || '미등록';
        case 'diabetes':
          return this.diabetesClaimStatus?.currentStepText || '미등록';
        case 'assistance':
          return this.assistanceClaimStatus || '미등록';
        default:
          return '미등록';
      }
    },

    // 청구 상태에 따른 CSS 클래스 가져오기
    getClaimStatusClass(type) {
      const status = this.getClaimStatus(type);
      switch (status) {
        case '미등록':
          return 'status-not-registered';
        case '청구정보저장':
          return 'status-completed'; // 완료 상태로 초록색 표시
        case '환자등록':
          return 'status-registered';
        case '위임내역등록':
          return 'status-processing';
        case '청구등록':
          return 'status-completed';
        case '등록완료':
          return 'status-registered';
        case '처리중':
          return 'status-processing';
        case '완료':
          return 'status-completed';
        case '오류':
          return 'status-error';
        default:
          return 'status-default';
      }
    },

    // 위임내역등록 시작 알림 메서드 추가
    showClaimStartNotification(claimId, step = '위임내역등록') {
      const claimType = this.getCurrentClaimType();
      const claimTypeText = claimType === 'oxygen' ? '산소치료' : '당뇨소모성재료';
      const patientName = this.client_data_obj.name || '고객';

      // 단계별 메시지 설정
      const stepMessages = {
        '청구정보입력': `${patientName}님의 ${claimTypeText} 청구정보입력이 시작되었습니다.`,
        '환자등록': `${patientName}님의 ${claimTypeText} 환자등록이 시작되었습니다.`,
        '위임내역등록': `${patientName}님의 ${claimTypeText} 위임내역등록이 시작되었습니다.`,
        '청구등록': `${patientName}님의 ${claimTypeText} 청구등록이 시작되었습니다.`
      };

      const toastMessage = stepMessages[step] || stepMessages['위임내역등록'];

      // Swal Toast 알림
      this.$swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'info',
        title: toastMessage,
        timer: 8000,
        timerProgressBar: true,
        showConfirmButton: false
      });

      // 헤더 알림 메시지에 추가
      if (this.globalMessageSystem) {
        const newMessage = {
          id: Date.now(),
          type: 'info',
          title: `${claimTypeText} ${step} 시작`,
          text: `${patientName}님의 ${step}이 시작되었습니다.`,
          timestamp: new Date(),
          isRead: false
        };

        this.globalMessageSystem.addMessage(newMessage);
      }
    },

    // 청구정보입력 시작 알림
    showClaimInfoStartNotification() {
      const claimId = this.uuidv4();
      this.showClaimStartNotification(claimId, '청구정보입력');
    },

    // 환자등록 시작 알림
    showPatientRegistrationStartNotification() {
      const claimId = this.uuidv4();
      this.showClaimStartNotification(claimId, '환자등록');
    },

    // 청구등록 시작 알림
    showClaimRegistrationStartNotification() {
      const claimId = this.uuidv4();
      this.showClaimStartNotification(claimId, '청구등록');
    },

    // 1단계: 환자 등록 모달 열기
    async openPatientRegistration() {
      // 선택된 파일 개수 확인
      const selectedFiles = this.documents ? this.documents.filter(doc => doc.selected) : [];

      if (selectedFiles.length < 3) {
        this.$swal.fire({
          title: '파일 선택 필요',
          html: `
            <div style="text-align: left;">
              <p style="margin-bottom: 15px; font-weight: 500;">환자 등록을 위해 다음 3개 파일을 모두 선택해주세요.</p>
              <ul style="margin: 0; padding-left: 20px;">
                <li style="margin-bottom: 5px;">처방전</li>
                <li style="margin-bottom: 5px;">급여대상자 등록신청서</li>
                <li style="margin-bottom: 5px;">위임인 신분증</li>
              </ul>
              <p style="margin-top: 15px; color: #6b7280; font-size: 15px;">
                현재 선택된 파일: <strong>${selectedFiles.length}개</strong>
              </p>
            </div>
          `,
          icon: 'warning',
          confirmButtonText: '확인',
          confirmButtonColor: '#3b82f6'
        });
        return;
      }

      // BranchComponent 모달 열기
      this.showModal_obj.branch_selection = true;
    },

    // 환자 등록 모달 닫기
    closePatientModal() {
      this.showPatientModal = false;
    },

    // 2단계: 요양비청구위임내역등록 모달 열기
    async submitClaimList() {
      if (!this.client_data_obj.name || !this.client_data_obj.number || !this.client_data_obj.phone1) {
        this.$swal.fire({
          icon: 'warning',
          title: '필수 정보 누락',
          text: '성명, 주민번호, 연락처는 필수 입력 사항입니다.',
          confirmButtonText: '확인'
        });
        return;
      }

      const selectedFiles = this.documents ? this.documents.filter(doc => doc.selected) : [];
      if (selectedFiles.length < 2) {
        this.$swal.fire({
          icon: 'warning',
          title: '필수 서류 누락',
          html: `
                <div style="text-align: left;">
                    <p style="margin-bottom: 15px; font-weight: 500;">위임내역등록을 위해 다음 2개 파일을 모두 선택해주세요.</p>
                    <ul style="margin: 0; padding-left: 20px;">
                        <li style="margin-bottom: 5px;">요양비 지급청구 위임장</li>
                        <li style="margin-bottom: 5px;">신분증</li>
                    </ul>
                    <p style="margin-top: 15px; color: #6b7280; font-size: 15px;">
                        현재 선택된 파일: <strong>${selectedFiles.length}개</strong>
                    </p>
                </div>
            `,
          icon: 'warning',
          confirmButtonText: '확인',
          confirmButtonColor: '#3b82f6'
        });
        return;
      }

      // 진행 상태 설정
      this.isSubmitting = true;

      // 고유 claim_id 생성
      const claimId = this.uuidv4();
      this.claimId = claimId;

      // 위임내역등록 시작 알림 추가
      this.showClaimStartNotification(claimId);

      try {
        // === test 계정인 경우 시뮬레이션 모드 ===
        if (this.isTestUser) {
          await this.simulateClaimProcess(claimId);
          return;
        }

        // === 실제 청구 처리 ===
        let savedFiles = [];
        if (selectedFiles && selectedFiles.length > 0) {
          const fileData = await Promise.all(
            selectedFiles.map(async (doc) => {
              try {
                // 파일 데이터를 가져오는 로직
                const response = await fetch(doc.url);
                const arrayBuffer = await response.arrayBuffer();
                const uint8Array = new Uint8Array(arrayBuffer);
                return {
                  name: doc.fileName,
                  data: Array.from(uint8Array),
                  size: doc.size || 0,
                  type: doc.type || 'application/octet-stream',
                  documentType: doc.documentType || 'unknown'
                };
              } catch (error) {
                console.warn('파일 처리 실패:', doc.fileName, error);
                return null;
              }
            })
          );

          // null 값 제거
          const validFileData = fileData.filter(file => file !== null);

          // 일렉트론 환경에서만 파일 저장
          if (window.electronAPI && window.electronAPI.saveCrawlingFiles && validFileData.length > 0) {
            const saveResult = await window.electronAPI.saveCrawlingFiles({
              files: validFileData,
              claimId: claimId
            });

            if (saveResult.success) {
              savedFiles = saveResult.files;
            }
          }
        }

        // === DB에서 청구 정보 가져오기 ===
        let claimDataFromDB = null;
        const claimType = this.getCurrentClaimType();

        try {
          if (claimType === 'diabetes') {
            // 당뇨소모성재료 청구 데이터 조회
            const diabetesResponse = await this.$axios.get(
              `${this.$apiUrls.hanqmedi}/diabetesClaimData/${this.orderId}`,
              {
                headers: {
                  'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
              }
            );

            if (diabetesResponse.data.success && diabetesResponse.data.data.length > 0) {
              claimDataFromDB = diabetesResponse.data.data[0];
              console.log('당뇨소모성재료 청구 데이터 조회 완료:', claimDataFromDB);
            } else {
              throw new Error('당뇨소모성재료 청구 데이터를 찾을 수 없습니다.');
            }
          } else if (claimType === 'oxygen') {
            // 산소치료 청구 데이터 조회
            const oxygenResponse = await this.$axios.get(
              `${this.$apiUrls.hanqmedi}/oxygenClaimData/${this.orderId}`,
              {
                headers: {
                  'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
              }
            );

            if (oxygenResponse.data.success && oxygenResponse.data.data.length > 0) {
              claimDataFromDB = oxygenResponse.data.data[0];
              console.log('산소치료 청구 데이터 조회 완료:', claimDataFromDB);
            } else {
              throw new Error('산소치료 청구 데이터를 찾을 수 없습니다.');
            }
          }
        } catch (dbError) {
          console.error('DB에서 청구 데이터 조회 실패:', dbError);
          throw new Error('청구 데이터를 가져올 수 없습니다. 먼저 청구 정보를 입력해주세요.');
        }

        // 크롤링 데이터 준비 (DB에서 가져온 정보 사용)
        const claimData = {
          claimId: claimId,
          type: claimType === 'oxygen' ? 'oxygen-claim-list' : 'diabetes-claim-list',
          certificateName: claimDataFromDB.certificate_id || '',
          cert_password: claimDataFromDB.certificate_pw || '',
          client_info: {
            name: claimDataFromDB.name,
            resident_num: claimDataFromDB.number,
            phone: claimDataFromDB.phone,
            ...(claimType === 'oxygen' && (() => {
              const receiptType = claimDataFromDB.receipt_type;
              const hasHomeData = claimDataFromDB.home_oxygen_number && claimDataFromDB.home_start_date;
              const hasMobileData = claimDataFromDB.mobile_oxygen_number && claimDataFromDB.mobile_start_date;

              if (receiptType === '동시접수') {
                return {
                  homeOxygen: true,
                  mobileOxygen: true,
                  simultaneousOxygen: true
                };
              }

              return {
                homeOxygen: receiptType === '가정용' || hasHomeData,
                mobileOxygen: receiptType === '휴대용' || hasMobileData,
                simultaneousOxygen: false
              };
            })())
          },
          rental_info: {
            order_id: this.orderId,
            company_key: this.$globalState.company_key
          },
          products: (this.products_obj || []).map(product => ({
            id: product.id,
            name: product.name,
            quantity: product.quantity,
          })),
          files: savedFiles.map(file => file.path || file.name)
        };

        console.log(' 크롤링 데이터 준비 완료:', claimData);

        let crawlingResult;

        // 일렉트론 환경에서만 크롤링 실행
        if (window.electronAPI && window.electronAPI.startCrawling) {
          // 객체를 JSON으로 직렬화하여 전달
          const serializedClaimData = JSON.parse(JSON.stringify(claimData));
          crawlingResult = await window.electronAPI.startCrawling(serializedClaimData);
        } else {
          // 웹 환경에서는 에러 처리
          throw new Error('일렉트론 환경에서만 크롤링을 실행할 수 있습니다.');
        }

        console.log(' 크롤링 결과:', crawlingResult);

        // 크롤링 결과 검증
        if (!crawlingResult) {
          throw new Error('크롤링 결과를 받을 수 없습니다.');
        }

        if (!crawlingResult.success) {
          throw new Error(crawlingResult.error || '크롤링 처리 실패');
        }

        try {
          if (claimType === 'diabetes') {
            // 당뇨소모성재료 청구 데이터 ID 조회 후 상태 업데이트
            const diabetesResponse = await this.$axios.get(
              `${this.$apiUrls.hanqmedi}/diabetesClaimData/${this.orderId}`,
              {
                headers: {
                  'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
              }
            );

            if (diabetesResponse.data.success && diabetesResponse.data.data.length > 0) {
              const diabetesDataId = diabetesResponse.data.data[0].num;
              await this.$axios.put(
                `${this.$apiUrls.hanqmedi}/diabetesClaimStatus/${diabetesDataId}`,
                { status: '위임내역등록' },
                {
                  headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                  }
                }
              );
              console.log('당뇨소모성재료 상태 업데이트 완료');
            } else {
              throw new Error('당뇨소모성재료 청구 데이터를 찾을 수 없습니다.');
            }
          } else if (claimType === 'oxygen') {
            // 산소치료 청구 데이터 ID 조회 후 상태 업데이트
            const oxygenResponse = await this.$axios.get(
              `${this.$apiUrls.hanqmedi}/oxygenClaimData/${this.orderId}`,
              {
                headers: {
                  'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
              }
            );

            if (oxygenResponse.data.success && oxygenResponse.data.data.length > 0) {
              const oxygenDataId = oxygenResponse.data.data[0].num;
              await this.$axios.put(
                `${this.$apiUrls.hanqmedi}/oxygenClaimStatus/${oxygenDataId}`,
                { status: '위임내역등록' },
                {
                  headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                  }
                }
              );
              console.log('산소치료 상태 업데이트 완료');
            } else {
              throw new Error('산소치료 청구 데이터를 찾을 수 없습니다.');
            }
          }

          // 상태 업데이트 후 청구 상태 다시 로드
          await this.loadClaimStatus();

        } catch (statusUpdateError) {
          console.warn('청구 상태 업데이트 실패, 하지만 크롤링은 성공했으므로 계속 진행합니다:', statusUpdateError.message);
        }

        setTimeout(() => {
          this.$swal.fire({
            title: '청구 처리 완료',
            text: '청구 처리가 완료되었습니다.',
            icon: 'success',
            confirmButtonText: '확인'
          });
        }, 500);

        // 성공 시 상태 업데이트
        this.currentStep = 3;

        // 크롤링 성공 시에만 다음 청구 자동 생성
        if (claimType === 'oxygen') {
          // 현재 청구 데이터를 가져와서 다음 청구 생성
          try {
            const response = await this.$axios.get(`${this.$apiUrls.hanqmedi}/oxygenClaimData/${this.orderId}`);
            if (response.data && response.data.success && response.data.data.length > 0) {
              const latestClaim = response.data.data[response.data.data.length - 1];
              await this.createNextOxygenClaim(latestClaim);
            }

            // 모든 청구 진행이 완료된 후 '청구완료' 상태로 최종 업데이트
            await this.updateToClaimCompleted(claimType);

          } catch (error) {
            console.error('다음 청구 생성 중 오류:', error);
          }
        }

      } catch (error) {
        console.error('청구 처리 실패:', error);

        // 사용자 취소 에러인지 확인
        if (error.message && error.message.includes('사용자의 요청으로 크롬창이 닫혔습니다')) {

          this.$swal.fire({
            icon: 'info',
            title: '크롤링 취소됨',
            text: '사용자의 요청으로 크롤링이 취소되었습니다.',
            confirmButtonText: '확인'
          });
        } else {
          this.$swal.fire({
            icon: 'error',
            title: '청구등록 실패',
            text: '청구등록 중 에러가 발생하여 실패하였습니다.',
            confirmButtonText: '확인'
          });
        }
      } finally {
        this.isSubmitting = false;
      }
    },

    // 3단계: 청구 등록 (수정)
    async submitClaim() {
      // 진행 상태 설정
      this.isSubmitting = true;

      // 고유 claim_id 생성
      const claimId = this.uuidv4();
      this.claimId = claimId;

      // 청구 시작 알림
      this.showClaimRegistrationStartNotification();

      try {
        // === test 계정인 경우 시뮬레이션 모드 ===
        if (this.isTestUser) {
          console.log('🧪 테스트 계정 - 시뮬레이션 모드');
          await this.simulateClaimProcess(claimId);
          return;
        }

        // === 실제 청구 처리 ===
        const claimType = this.getCurrentClaimType();

        const documentInfo = await this.checkDocumentIssuance(this.orderId, claimType);
        console.log('📋 문서 발행 정보:', documentInfo);

        if (!documentInfo.success) {
          throw new Error(documentInfo.message || '문서 발행 여부 확인에 실패했습니다.');
        }

        // 문서가 모두 발행된 경우 바로 청구 진행
        if (documentInfo.hasTaxInvoice && documentInfo.hasCashReceipt) {
          console.log('✅ 모든 문서가 이미 발행됨, 청구 진행');
          await this.proceedWithClaim(claimId, claimType);
          return;
        }

        // 문서 발행이 필요한 경우 모달 표시
        console.log('📋 문서 발행이 필요함, 모달 표시');
        this.documentIssuanceInfo = {
          hasTaxInvoice: documentInfo.hasTaxInvoice,
          hasCashReceipt: documentInfo.hasCashReceipt,
          mgtKey: documentInfo.mgtKey,
          mgtKey2: documentInfo.mgtKey2
        };

        this.pendingClaimData = { claimId, claimType };
        this.showDocumentIssuanceModal = true;
        this.isSubmitting = false;

      } catch (error) {
        console.error('❌ 청구 처리 실패:', error);
        this.isSubmitting = false;

        // ✅ 크롤링 서버 연결 에러인 경우 (이미 구체적으로 처리됨)
        if (error.message && error.message.includes('ECONNREFUSED')) {
          this.$swal.fire({
            icon: 'error',
            title: '크롤링 서버 연결 실패',
            text: '크롤링 서버에 연결할 수 없습니다. 서버가 실행 중인지 확인해주세요.',
            confirmButtonText: '확인'
          });
        } else if (error.message && error.message.includes('자동 로그인 실패')) {
          this.$swal.fire({
            icon: 'error',
            title: '로그인 실패',
            text: '자동 로그인에 실패했습니다. 수동으로 로그인 후 다시 시도해주세요.',
            confirmButtonText: '확인'
          });
        } else {
          // ✅ getKoreanErrorMessage로 변환된 에러 메시지 사용
          const errorMessage = error.message || '처리 중 예상치 못한 오류가 발생했습니다.';

          this.$swal.fire({
            icon: 'error',
            title: '청구등록 실패',
            text: errorMessage,
            confirmButtonText: '확인'
          });
        }
      }
    },

    // 문서 발행 완료 후 실제 청구 진행
    async proceedWithClaim(claimId, claimType) {
      try {
        this.isSubmitting = true;

        // 파일 처리
        let savedFiles = [];

        // 선택된 파일 확인 (documents 배열에서 선택된 파일들)
        const selectedFiles = this.documents ? this.documents.filter(doc => doc.selected) : [];

        if (selectedFiles && selectedFiles.length > 0) {
          const fileData = await Promise.all(
            selectedFiles.map(async (doc) => {
              try {
                // 파일 데이터를 가져오는 로직
                const response = await fetch(doc.url);
                const arrayBuffer = await response.arrayBuffer();
                const uint8Array = new Uint8Array(arrayBuffer);
                return {
                  name: doc.fileName,
                  data: Array.from(uint8Array),
                  size: doc.size || 0,
                  type: doc.type || 'application/octet-stream',
                  documentType: doc.documentType || 'unknown'
                };
              } catch (error) {
                console.warn('파일 처리 실패:', doc.fileName, error);
                return null;
              }
            })
          );

          // null 값 제거
          const validFileData = fileData.filter(file => file !== null);

          // 일렉트론 환경에서만 파일 저장
          if (window.electronAPI && window.electronAPI.saveCrawlingFiles && validFileData.length > 0) {
            const saveResult = await window.electronAPI.saveCrawlingFiles({
              files: validFileData,
              claimId: claimId
            });

            if (saveResult.success) {
              savedFiles = saveResult.files;
            }
          }
        }

        // === DB에서 청구 정보 가져오기 ===
        let claimDataFromDB = null;

        try {
          if (claimType === 'diabetes') {
            const diabetesResponse = await this.$axios.get(
              `${this.$apiUrls.hanqmedi}/diabetesClaimData/${this.orderId}`,
              {
                headers: {
                  'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
              }
            );

            if (diabetesResponse.data.success && diabetesResponse.data.data.length > 0) {
              claimDataFromDB = diabetesResponse.data.data[0];
            } else {
              throw new Error('당뇨소모성재료 청구 데이터를 찾을 수 없습니다.');
            }
          } else if (claimType === 'oxygen') {
            const oxygenResponse = await this.$axios.get(
              `${this.$apiUrls.hanqmedi}/oxygenClaimData/${this.orderId}`,
              {
                headers: {
                  'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
              }
            );

            if (oxygenResponse.data.success && oxygenResponse.data.data.length > 0) {
              claimDataFromDB = oxygenResponse.data.data[0];
            } else {
              throw new Error('산소치료 청구 데이터를 찾을 수 없습니다.');
            }
          }
        } catch (dbError) {
          console.error('❌ DB에서 청구 데이터 조회 실패:', dbError);
          throw new Error('청구 데이터를 가져올 수 없습니다. 먼저 청구 정보를 입력해주세요.');
        }

        // 크롤링 데이터 준비 (DB에서 가져온 정보 사용)
        const claimData = {
          claimId: claimId,
          type: claimType === 'oxygen' ? 'oxygen-claim' : 'diabetes-claim',
          certificateName: claimDataFromDB.certificate_id || '',
          cert_password: claimDataFromDB.certificate_pw || '',
          client_info: {
            name: claimDataFromDB.name,
            resident_num1: claimDataFromDB.number ? claimDataFromDB.number.substring(0, 6) : '',
            resident_num2: claimDataFromDB.number ? claimDataFromDB.number.substring(6) : '',
            phone: claimDataFromDB.phone,
            // 산소발생기 관련 정보는 산소 청구일 때만 포함
            ...(claimType === 'oxygen' && {
              homeOxygen: this.client_data_obj.oxygen_type?.includes('가정용') || false,
              mobileOxygen: this.client_data_obj.oxygen_type?.includes('휴대용') || false,
              simultaneousOxygen: this.client_data_obj.oxygen_type === '가정용/휴대용',
              oxygenDate: this.formatDateForCrawling(claimDataFromDB.oxygen_date) || '',
              oxygenSdate: this.formatDateForCrawling(claimDataFromDB.start_date) || this.formatDateForCrawling(this.client_data_obj.oxygen_start) || this.getCurrentDate(),
              oxygenEdate: this.formatDateForCrawling(claimDataFromDB.end_date) || this.formatDateForCrawling(this.client_data_obj.oxygen_end) || this.getCurrentDate(),
              useHomeStartDate: this.formatDateForCrawling(claimDataFromDB.home_start_date) || '',
              useHomeEndDate: this.formatDateForCrawling(claimDataFromDB.home_end_date) || '',
              useMobileStartDate: this.formatDateForCrawling(claimDataFromDB.mobile_start_date) || '',
              useMobileEndDate: this.formatDateForCrawling(claimDataFromDB.mobile_end_date) || '',
              homeBillingCount: claimDataFromDB.home_count || '',
              mobileBillingCount: claimDataFromDB.mobile_count || '',
              oxygenHomeGenerator: claimDataFromDB.home_oxygen_number || '',
              oxygenMobileGenerator: claimDataFromDB.mobile_oxygen_number || '',
              cashReceipt: claimDataFromDB.cash_receipt || '',
              cashReceiptDate: this.formatDateForCrawling(claimDataFromDB.cash_receipt_date) || '',
              cashReceiptAmount: claimDataFromDB.cash_receipt_amount || '',
              taxInvoice: claimDataFromDB.tax_invoice || '',
              taxInvoiceDate: this.formatDateForCrawling(claimDataFromDB.tax_invoice_date) || '',
              taxInvoiceAmount: claimDataFromDB.tax_invoice_amount || '',
              doctorLicense: claimDataFromDB.doctor_number || '',
              specialistLicense: claimDataFromDB.specialist_number || '',
              diseaseCode: claimDataFromDB.disease_code || '',
              diseaseName: claimDataFromDB.disease_name || '',
              bloodGasItem1: (claimDataFromDB.gas_item1 === 1 || claimDataFromDB.gas_item1 === '1' || claimDataFromDB.gas_item1 === true) ? true : false,
              bloodGasItem2: (claimDataFromDB.gas_item2 === 1 || claimDataFromDB.gas_item2 === '1' || claimDataFromDB.gas_item2 === true) ? true : false,
              bloodGasItem3: (claimDataFromDB.gas_item3 === 1 || claimDataFromDB.gas_item3 === '1' || claimDataFromDB.gas_item3 === true) ? true : false,
              bloodGasItem4: (claimDataFromDB.gas_item4 === 1 || claimDataFromDB.gas_item4 === '1' || claimDataFromDB.gas_item4 === true) ? true : false,
              bloodGasItem5: (claimDataFromDB.gas_item5 === 1 || claimDataFromDB.gas_item5 === '1' || claimDataFromDB.gas_item5 === true) ? true : false,
              bloodGasItem6: (claimDataFromDB.gas_item6 === 1 || claimDataFromDB.gas_item6 === '1' || claimDataFromDB.gas_item6 === true) ? true : false,
              bloodGasItem7: (claimDataFromDB.gas_item7 === 1 || claimDataFromDB.gas_item7 === '1' || claimDataFromDB.gas_item7 === true) ? true : false,
              oxygenSaturationItem1: (claimDataFromDB.oxygen_item1 === 1 || claimDataFromDB.oxygen_item1 === '1' || claimDataFromDB.oxygen_item1 === true) ? true : false,
              oxygenSaturationItem2: (claimDataFromDB.oxygen_item2 === 1 || claimDataFromDB.oxygen_item2 === '1' || claimDataFromDB.oxygen_item2 === true) ? true : false,
              oxygenSaturationItem3: (claimDataFromDB.oxygen_item3 === 1 || claimDataFromDB.oxygen_item3 === '1' || claimDataFromDB.oxygen_item3 === true) ? true : false,
              oxygenSaturationItem4: (claimDataFromDB.oxygen_item4 === 1 || claimDataFromDB.oxygen_item4 === '1' || claimDataFromDB.oxygen_item4 === true) ? true : false,
              oxygenSaturationItem5: (claimDataFromDB.oxygen_item5 === 1 || claimDataFromDB.oxygen_item5 === '1' || claimDataFromDB.oxygen_item5 === true) ? true : false,
              issuanceType: claimDataFromDB.issuance_type || '최초'
            })
          },
          rental_info: {
            order_id: this.orderId,
            company_key: this.$globalState.company_key
          },
          products: (this.products_obj || []).map(product => ({
            id: product.id,
            name: product.name,
            quantity: product.quantity,
          })),
          files: savedFiles.map(file => file.path || file.name),
        };

        let crawlingResult;

        // 일렉트론 환경에서만 크롤링 실행
        if (window.electronAPI && window.electronAPI.startCrawling) {
          const serializedClaimData = JSON.parse(JSON.stringify(claimData));
          crawlingResult = await window.electronAPI.startCrawling(serializedClaimData);
        } else {
          throw new Error('일렉트론 환경에서만 크롤링을 실행할 수 있습니다.');
        }

        // 크롤링 결과 검증
        if (!crawlingResult) {
          throw new Error('크롤링 결과를 받을 수 없습니다.');
        }

        if (!crawlingResult.success) {
          throw new Error(crawlingResult.error || '크롤링 처리 실패');
        }

        try {
          if (claimType === 'diabetes') {
            const diabetesResponse = await this.$axios.get(
              `${this.$apiUrls.hanqmedi}/diabetesClaimData/${this.orderId}`,
              {
                headers: {
                  'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
              }
            );

            if (diabetesResponse.data.success && diabetesResponse.data.data.length > 0) {
              const diabetesDataId = diabetesResponse.data.data[0].num;
              await this.$axios.put(
                `${this.$apiUrls.hanqmedi}/diabetesClaimStatus/${diabetesDataId}`,
                { status: '청구등록' },
                {
                  headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                  }
                }
              );
            } else {
              throw new Error('당뇨소모성재료 청구 데이터를 찾을 수 없습니다.');
            }
          } else if (claimType === 'oxygen') {
            const oxygenResponse = await this.$axios.get(
              `${this.$apiUrls.hanqmedi}/oxygenClaimData/${this.orderId}`,
              {
                headers: {
                  'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
              }
            );

            if (oxygenResponse.data.success && oxygenResponse.data.data.length > 0) {
              const oxygenDataId = oxygenResponse.data.data[0].num;
              await this.$axios.put(
                `${this.$apiUrls.hanqmedi}/oxygenClaimStatus/${oxygenDataId}`,
                { status: '청구등록' },
                {
                  headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                  }
                }
              );
            } else {
              throw new Error('산소치료 청구 데이터를 찾을 수 없습니다.');
            }
          }

          // 상태 업데이트 후 청구 상태 다시 로드
          await this.loadClaimStatus();

        } catch (statusUpdateError) {
          console.warn('청구 상태 업데이트 실패, 하지만 크롤링은 성공했으므로 계속 진행합니다:', statusUpdateError.message);
        }

        setTimeout(() => {
          this.$swal.fire({
            title: '청구 처리 완료',
            text: '청구 처리가 완료되었습니다.',
            icon: 'success',
            confirmButtonText: '확인'
          });
        }, 500);

        // 성공 시 상태 업데이트
        this.currentStep = 3;

        // 모든 청구 진행이 완료된 후 '청구완료' 상태로 최종 업데이트
        await this.updateToClaimCompleted(claimType);

      } catch (error) {
        console.error('❌ 청구 처리 실패:', error);

        // 사용자 취소 에러인지 확인
        if (error.message && error.message.includes('사용자의 요청으로 크롬창이 닫혔습니다')) {
          this.$swal.fire({
            icon: 'info',
            title: '크롤링 취소됨',
            text: '사용자의 요청으로 크롤링이 취소되었습니다.',
            confirmButtonText: '확인'
          });
        } else {
          this.$swal.fire({
            icon: 'error',
            title: '청구등록 실패',
            text: error.message || '청구등록 중 에러가 발생하여 실패하였습니다.',
            confirmButtonText: '확인'
          });
        }
      } finally {
        this.isSubmitting = false;
      }
    },

    formatDateForCrawling(dateString) {
      if (!dateString) return '';

      // Date 객체로 변환
      const date = new Date(dateString);

      // YYYYMMDD 형식으로 변환
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      return `${year}${month}${day}`;
    },

    getCurrentDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}${month}${day}`;
    },

    // 문서 발행 여부 확인
    async checkDocumentIssuance(orderId, claimType) {
      try {
        const response = await this.$axios.get(`${this.$apiUrls.hanqmedi}/checkDocumentIssuance`, {
          params: {
            orderId: orderId,
            claimType: claimType
          }
        });

        return response.data;
      } catch (error) {
        console.error('문서 발행 여부 확인 실패:', error);
        throw error;
      }
    },

    // 문서 발행 모달에서 발행 완료 후 청구 진행
    async onDocumentIssuanceComplete() {
      this.showDocumentIssuanceModal = false;

      if (this.pendingClaimData) {
        const { claimId, claimType } = this.pendingClaimData;
        this.pendingClaimData = null;

        // 청구 진행
        await this.proceedWithClaim(claimId, claimType);
      }
    },

    // 전자세금계산서 문서번호 업데이트
    async updateClaimMgtKey(orderId, claimType, mgtKey) {
      try {
        const response = await this.$axios.put(`${this.$apiUrls.hanqmedi}/updateClaimMgtKey`, {
          orderId: orderId,
          claimType: claimType,
          mgtKey: mgtKey
        });

        if (response.data.success) {
          console.log('청구 데이터 mgt_key 업데이트 성공');
        } else {
          console.warn('청구 데이터 mgt_key 업데이트 실패:', response.data.message);
        }
      } catch (error) {
        console.error('청구 데이터 mgt_key 업데이트 실패:', error);
      }
    },

    // 현금영수증 문서번호 업데이트
    async updateClaimMgtKey2(orderId, claimType, mgtKey2) {
      try {
        const response = await this.$axios.put(`${this.$apiUrls.hanqmedi}/updateClaimMgtKey2`, {
          orderId: orderId,
          claimType: claimType,
          mgtKey2: mgtKey2
        });

        if (response.data.success) {
          console.log('청구 데이터 mgt_key2 업데이트 성공');
        } else {
          console.warn('청구 데이터 mgt_key2 업데이트 실패:', response.data.message);
        }
      } catch (error) {
        console.error('청구 데이터 mgt_key2 업데이트 실패:', error);
      }
    },

    // 헬퍼 메서드들
    uuidv4() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0;
        const v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },

    async updateClaimStatus(claimType) {
      try {
        const response = await this.$axios.post(
          `${this.$apiUrls.hanqmedi}/updateClaimStatus`,
          {
            orderId: this.orderId,
            claimType: claimType,
            status: 1  // 등록완료 상태
          },
          {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
          }
        );

        if (response.data.success) {
          console.log('✅ 청구 상태 업데이트 성공:', response.data);
        } else {
          console.warn('⚠️ 청구 상태 업데이트 실패:', response.data.message);
        }

        return response.data;
      } catch (error) {
        console.error('❌ 청구 상태 업데이트 오류:', error);
        throw error;
      }
    },

    // 요양비청구위임내역등록 모달 닫기
    closeAuthorizationModal() {
      this.showAuthorizationModal = false;
    },

    // 요양비청구위임내역등록 저장
    saveAuthorizationInfo() {
      this.$toast.success('요양비청구위임내역이 등록되었습니다.');
      this.closeAuthorizationModal();
      this.currentStep = 3;
    },

    async loadClaimStatus() {
      try {
        // 주문서 타입 먼저 판단
        const claimType = this.getCurrentClaimType();

        let response;

        if (claimType === 'diabetes') {
          // 당뇨소모성재료 청구 정보 조회
          response = await this.$axios.get(`${this.$apiUrls.hanqmedi}/diabetesClaimData/${this.orderId}`);
        } else {
          // 산소치료 청구 정보 조회 (기본값)
          response = await this.$axios.get(`${this.$apiUrls.hanqmedi}/oxygenClaimData/${this.orderId}`);
        }

        if (response.data && response.data.success && response.data.data.length > 0) {
          const latestClaim = response.data.data[0]; // 가장 최근 청구 정보

          if (claimType === 'diabetes') {
            // 당뇨 청구 상태 설정 - status에 따라 단계 결정
            let currentStep = 0;
            let currentStepText = '청구정보저장';
            let isCompleted = false;

            // status에 따라 단계 설정
            switch (latestClaim.status) {
              case '청구정보저장':
                currentStep = 0;
                currentStepText = '청구정보저장';
                isCompleted = true;
                break;
              case '환자등록':
                currentStep = 1;
                currentStepText = '환자등록';
                isCompleted = true;
                break;
              case '위임내역등록':
                currentStep = 2;
                currentStepText = '위임내역등록';
                isCompleted = true;
                break;
              case '청구등록':
                currentStep = 3;
                currentStepText = '청구등록';
                isCompleted = true;
                break;
              case '청구완료':
                currentStep = 4;
                currentStepText = '청구완료';
                isCompleted = true;
                break;
              case '완료':
                currentStep = 4;
                currentStepText = '청구완료';
                isCompleted = true;
                break;
              default:
                currentStep = 0;
                currentStepText = '청구정보저장';
                isCompleted = false;
            }

            this.claimStatus = {
              hasClaimData: true,
              currentStep: currentStep,
              currentStepText: currentStepText,
              isCompleted: isCompleted
            };

            // 당뇨 청구 상태도 업데이트
            this.diabetesClaimStatus = {
              hasClaimData: true,
              currentStep: currentStep,
              currentStepText: currentStepText,
              isCompleted: isCompleted
            };
          } else {
            // 산소 청구 상태 설정 - status에 따라 단계 결정
            let currentStep = 0;
            let currentStepText = '청구정보저장';
            let isCompleted = false;

            // status에 따라 단계 설정 (산소도 동일한 로직 적용)
            switch (latestClaim.status) {
              case '청구정보저장':
                currentStep = 0;
                currentStepText = '청구정보저장';
                isCompleted = true;
                break;
              case '환자등록':
                currentStep = 1;
                currentStepText = '환자등록';
                isCompleted = true;
                break;
              case '위임내역등록':
                currentStep = 2;
                currentStepText = '위임내역등록';
                isCompleted = true;
                break;
              case '청구등록':
                currentStep = 3;
                currentStepText = '청구등록';
                isCompleted = true;
                break;
              case '청구완료':
                currentStep = 4;
                currentStepText = '청구완료';
                isCompleted = true;
                break;
              case '완료':
                currentStep = 4;
                currentStepText = '청구완료';
                isCompleted = true;
                break;
              default:
                // 기존 currentStep과 currentStepText 사용 (하위 호환성)
                currentStep = latestClaim.currentStep || 0;
                currentStepText = latestClaim.currentStepText || '청구정보저장';
                isCompleted = latestClaim.currentStatus === 'completed';
            }

            this.claimStatus = {
              hasClaimData: true,
              currentStep: currentStep,
              currentStepText: currentStepText,
              isCompleted: isCompleted
            };
          }
        } else {
          // 청구 정보가 없는 경우
          this.claimStatus = {
            hasClaimData: false,
            currentStep: 0,
            currentStepText: '청구정보저장',
            isCompleted: false
          };

          if (claimType === 'diabetes') {
            this.diabetesClaimStatus = {
              hasClaimData: false,
              currentStep: 0,
              currentStepText: '청구정보저장',
              isCompleted: false
            };
          }

          console.log('청구 데이터가 없어서 기본 상태로 설정');
        }
      } catch (error) {
        console.error('청구 상태 로드 오류:', error);
        // 에러 발생 시 기본 상태 유지
      }
    },

    // 단계 상태 텍스트 가져오기
    getStepStatusText(step) {
      if (!this.claimStatus.hasClaimData) {
        return step === 0 ? '진행중' : '대기중';
      }

      // DB에서 조회한 실제 상태에 따라 판단
      const currentStatus = this.claimStatus.currentStepText;

      // 각 단계별 완료 조건을 명확히 정의
      switch (step) {
        case 0: // 청구정보저장
          return currentStatus === '청구정보저장' ||
            currentStatus === '환자등록' ||
            currentStatus === '위임내역등록' ||
            currentStatus === '청구등록' ||
            currentStatus === '완료' ? '완료' : '대기중';

        case 1: // 환자등록
          // 환자등록이 완료된 경우
          if (currentStatus === '환자등록' ||
            currentStatus === '위임내역등록' ||
            currentStatus === '청구등록' ||
            currentStatus === '완료') {
            return '완료';
          }
          // 환자등록이 진행중인 경우
          else if (currentStatus === '청구정보저장') {
            return '진행중';
          }
          // 그 외의 경우
          else {
            return '대기중';
          }

        case 2: // 위임내역등록
          // 위임내역등록이 완료된 경우
          if (currentStatus === '위임내역등록' ||
            currentStatus === '청구등록' ||
            currentStatus === '완료') {
            return '완료';
          }
          // 위임내역등록이 진행중인 경우
          else if (currentStatus === '환자등록') {
            return '진행중';
          }
          // 그 외의 경우
          else {
            return '대기중';
          }

        case 3: // 청구등록
          // 청구등록이 완료된 경우
          if (currentStatus === '청구등록' ||
            currentStatus === '완료') {
            return '완료';
          }
          // 청구등록이 진행중인 경우
          else if (currentStatus === '위임내역등록') {
            return '진행중';
          }
          // 그 외의 경우
          else {
            return '대기중';
          }

        default:
          return '대기중';
      }
    },

    // 단계 상태 클래스 가져오기
    getStepStatus(step) {
      if (!this.claimStatus.hasClaimData) {
        return step === 0 ? 'in-progress' : 'pending';
      }

      // DB에서 조회한 실제 상태에 따라 판단
      const currentStatus = this.claimStatus.currentStepText;

      // 각 단계별 완료 조건을 명확히 정의
      switch (step) {
        case 0: // 청구정보저장
          return currentStatus === '청구정보저장' ||
            currentStatus === '환자등록' ||
            currentStatus === '위임내역등록' ||
            currentStatus === '청구등록' ||
            currentStatus === '청구완료' ||
            currentStatus === '완료' ? 'completed' : 'pending';

        case 1: // 환자등록
          // 환자등록이 완료된 경우: 환자등록, 위임내역등록, 청구등록, 청구완료 상태일 때
          if (currentStatus === '환자등록' ||
            currentStatus === '위임내역등록' ||
            currentStatus === '청구등록' ||
            currentStatus === '청구완료' ||
            currentStatus === '완료') {
            return 'completed';
          }
          // 환자등록이 진행중인 경우: 청구정보저장 상태일 때
          else if (currentStatus === '청구정보저장') {
            return 'in-progress';
          }
          // 그 외의 경우
          else {
            return 'pending';
          }

        case 2: // 위임내역등록
          // 위임내역등록이 완료된 경우: 위임내역등록, 청구등록, 청구완료 상태일 때
          if (currentStatus === '위임내역등록' ||
            currentStatus === '청구등록' ||
            currentStatus === '청구완료' ||
            currentStatus === '완료') {
            return 'completed';
          }
          // 위임내역등록이 진행중인 경우: 환자등록 상태일 때
          else if (currentStatus === '환자등록') {
            return 'in-progress';
          }
          // 그 외의 경우
          else {
            return 'pending';
          }

        case 3: // 청구등록
          // 청구등록이 완료된 경우: 청구등록, 청구완료 상태일 때
          if (currentStatus === '청구등록' ||
            currentStatus === '청구완료' ||
            currentStatus === '완료') {
            return 'completed';
          }
          // 청구등록이 진행중인 경우: 위임내역등록 상태일 때
          else if (currentStatus === '위임내역등록') {
            return 'in-progress';
          }
          // 그 외의 경우
          else {
            return 'pending';
          }

        case 4: // 청구완료
          // 청구완료는 최종 상태이므로 항상 완료로 표시
          return currentStatus === '청구완료' || currentStatus === '완료' ? 'completed' : 'pending';

        default:
          return 'pending';
      }
    },

    // 단계별 텍스트 가져오기 메서드 수정
    getStepText(step) {
      const stepTexts = {
        0: '청구정보저장',
        1: '환자등록',
        2: '위임내역등록',
        3: '청구등록',
        4: '청구완료'
      };

      return stepTexts[step] || '';
    },

    // 모든 청구 진행 완료 후 '청구완료' 상태로 업데이트하는 메서드
    async updateToClaimCompleted(claimType) {
      try {
        if (claimType === 'oxygen') {
          const oxygenResponse = await this.$axios.get(
            `${this.$apiUrls.hanqmedi}/oxygenClaimData/${this.orderId}`,
            {
              headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
              }
            }
          );

          if (oxygenResponse.data.success && oxygenResponse.data.data.length > 0) {
            const oxygenDataId = oxygenResponse.data.data[0].num;
            await this.$axios.put(
              `${this.$apiUrls.hanqmedi}/oxygenClaimStatus/${oxygenDataId}`,
              { status: '청구완료' },
              {
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
              }
            );
            console.log('✅ 청구완료 상태로 업데이트 완료');
            // 상태 업데이트 후 다시 로드
            await this.loadClaimStatus();
          }
        } else if (claimType === 'diabetes') {
          const diabetesResponse = await this.$axios.get(
            `${this.$apiUrls.hanqmedi}/diabetesClaimData/${this.orderId}`,
            {
              headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
              }
            }
          );

          if (diabetesResponse.data.success && diabetesResponse.data.data.length > 0) {
            const diabetesDataId = diabetesResponse.data.data[0].num;
            await this.$axios.put(
              `${this.$apiUrls.hanqmedi}/diabetesClaimStatus/${diabetesDataId}`,
              { status: '청구완료' },
              {
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
              }
            );
            console.log('✅ 청구완료 상태로 업데이트 완료');
            // 상태 업데이트 후 다시 로드
            await this.loadClaimStatus();
          }
        }
      } catch (error) {
        console.warn('청구완료 상태 업데이트 실패:', error.message);
      }
    },

    // 청구 정보 저장 완료 이벤트 핸들러
    onClaimInfoSaved(eventData) {
      console.log('청구 정보 저장 완료:', eventData);

      // 청구 유형에 따른 처리
      const claimType = eventData.claimType || 'oxygen';

      if (claimType === 'diabetes') {
        // 당뇨소모성재료 청구 정보 저장 완료
        this.claimStatus = {
          hasClaimData: true,
          currentStep: 0,
          currentStepText: '청구정보저장',
          isCompleted: true
        };

        this.diabetesClaimStatus = {
          hasClaimData: true,
          currentStep: 0,
          currentStepText: '청구정보저장',
          isCompleted: true
        };

        console.log('당뇨소모성재료 청구 정보 저장 완료 - 상태 업데이트:', this.claimStatus);
      } else {
        // 산소치료 청구 정보 저장 완료
        if (eventData.claimStatus) {
          this.claimStatus = {
            ...this.claimStatus,
            ...eventData.claimStatus
          };
        } else {
          this.claimStatus = {
            hasClaimData: true,
            currentStep: 0,
            currentStepText: '청구정보저장',
            isCompleted: false
          };
        }
      }

      // 청구 상태 로드 (서버에서 최신 상태 확인)
      this.loadClaimStatus();

      // 주문 데이터 새로고침
      this.fetchOrderData();
    },

    // 다음 산소치료 청구 자동 생성 메서드 추가
    async createNextOxygenClaim(previousClaimData) {
      try {
        // 이전 청구 데이터에서 다음 청구 데이터 생성
        const nextClaimData = this.generateNextClaimData(previousClaimData);

        // 서버에 다음 청구 데이터 저장
        const response = await this.$axios.post(
          `${this.$apiUrls.hanqmedi}/oxygenClaimData`,
          nextClaimData
        );

        if (response.data && response.data.success) {
          this.$swal.fire({
            icon: 'success',
            title: '다음 청구 자동 생성 완료',
            text: '다음 차수 청구가 자동으로 생성되었습니다.',
            confirmButtonText: '확인'
          });

          // 청구 이력 새로고침
          this.loadClaimStatus();
        }
      } catch (error) {
        console.error('다음 청구 생성 오류:', error);
        this.$swal.fire({
          icon: 'error',
          title: '다음 청구 생성 실패',
          text: '다음 차수 청구 생성 중 오류가 발생했습니다.',
          confirmButtonText: '확인'
        });
      }
    },

    // 다음 청구 데이터 생성 메서드
    generateNextClaimData(previousClaimData) {
      const receiptType = previousClaimData.receiptType;
      let homeCount = previousClaimData.homeCount;
      let mobileCount = previousClaimData.mobileCount;
      let homeStartDate = null;
      let homeEndDate = null;
      let mobileStartDate = null;
      let mobileEndDate = null;

      // receiptType에 따라 조건부로 날짜 계산 및 청구 차수 증가
      if (receiptType === '가정용' || receiptType === '동시접수') {
        // 가정용 처리
        if (previousClaimData.homeStartDate && previousClaimData.homeEndDate) {
          const previousHomeEndDate = new Date(previousClaimData.homeEndDate);
          homeStartDate = new Date(previousHomeEndDate);
          homeStartDate.setDate(homeStartDate.getDate() + 1);

          homeEndDate = new Date(homeStartDate);
          homeEndDate.setMonth(homeEndDate.getMonth() + 1);
          homeEndDate.setDate(homeEndDate.getDate() - 1);
        }

        // 가정용 청구 차수 증가
        homeCount = previousClaimData.homeCount ?
          `${parseInt(previousClaimData.homeCount.replace('차', '')) + 1}차` : '2차';
      }

      if (receiptType === '휴대용' || receiptType === '동시접수') {
        // 휴대용 처리
        if (previousClaimData.mobileStartDate && previousClaimData.mobileEndDate) {
          const previousMobileEndDate = new Date(previousClaimData.mobileEndDate);
          mobileStartDate = new Date(previousMobileEndDate);
          mobileStartDate.setDate(mobileStartDate.getDate() + 1);

          mobileEndDate = new Date(mobileStartDate);
          mobileEndDate.setMonth(mobileEndDate.getMonth() + 1);
          mobileEndDate.setDate(mobileEndDate.getDate() - 1);
        }

        // 휴대용 청구 차수 증가
        mobileCount = previousClaimData.mobileCount ?
          `${parseInt(previousClaimData.mobileCount.replace('차', '')) + 1}차` : '2차';
      }

      // 다음 청구 데이터 생성
      const nextClaimData = {
        orderId: this.orderId,
        certificateName: previousClaimData.certificateName,
        certPassword: previousClaimData.certPassword,
        name: previousClaimData.name,
        residentNumber: previousClaimData.residentNumber,
        phone: previousClaimData.phone,
        oxygenDate: previousClaimData.oxygenDate,
        diseaseName: previousClaimData.diseaseName,
        diseaseCode: previousClaimData.diseaseCode,
        doctorLicense: previousClaimData.doctorLicense,
        specialistLicense: previousClaimData.specialistLicense,
        startDate: previousClaimData.startDate,
        endDate: previousClaimData.endDate,
        receiptType: previousClaimData.receiptType,
        issuanceType: previousClaimData.issuanceType,
        homeStartDate: homeStartDate ? this.formatDateForAPI(homeStartDate) : null,
        homeEndDate: homeEndDate ? this.formatDateForAPI(homeEndDate) : null,
        mobileStartDate: mobileStartDate ? this.formatDateForAPI(mobileStartDate) : null,
        mobileEndDate: mobileEndDate ? this.formatDateForAPI(mobileEndDate) : null,
        homeOxygenNumber: previousClaimData.homeOxygenNumber,
        mobileOxygenNumber: previousClaimData.mobileOxygenNumber,
        homeCount: homeCount,
        mobileCount: mobileCount,
        gasItem1: previousClaimData.gasItem1,
        gasItem2: previousClaimData.gasItem2,
        gasItem3: previousClaimData.gasItem3,
        gasItem4: previousClaimData.gasItem4,
        gasItem5: previousClaimData.gasItem5,
        gasItem6: previousClaimData.gasItem6,
        gasItem7: previousClaimData.gasItem7,
        oxygenItem1: previousClaimData.oxygenItem1,
        oxygenItem2: previousClaimData.oxygenItem2,
        oxygenItem3: previousClaimData.oxygenItem3,
        oxygenItem4: previousClaimData.oxygenItem4,
        oxygenItem5: previousClaimData.oxygenItem5
      };

      return nextClaimData;
    },

    // 날짜 포맷팅 헬퍼 메서드
    formatDateForAPI(date) {
      if (!date) return null;
      if (date instanceof Date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }
      return date;
    },

    // 유효기간 업데이트
    updateValidityPeriod(index) {
      const doc = this.documents[index];
      if (doc.validityStartDate && doc.validityEndDate) {
        // 시작일과 종료일이 모두 있을 때만 유효기간 문자열 생성
        doc.validityPeriod = `${doc.validityStartDate} ~ ${doc.validityEndDate}`;
      } else if (doc.validityStartDate) {
        doc.validityPeriod = `${doc.validityStartDate} ~`;
      } else if (doc.validityEndDate) {
        doc.validityPeriod = `~ ${doc.validityEndDate}`;
      } else {
        doc.validityPeriod = '';
      }
    },

    // 유효기간 검증 메서드 추가
    validateValidityPeriod(index) {
      const doc = this.documents[index];
      if (doc.validityStartDate && doc.validityEndDate) {
        const startDate = new Date(doc.validityStartDate);
        const endDate = new Date(doc.validityEndDate);

        if (startDate > endDate) {
          this.$toast.error('시작일은 종료일보다 이전이어야 합니다.');
          doc.validityEndDate = '';
          this.updateValidityPeriod(index);
          return false;
        }
      }
      return true;
    },

    // 청구 계산 모달 열기
    showClaimCalculationModal() {
      try {
        if (!this.products_obj || this.products_obj.length === 0) {
          this.$swal.fire({
            title: '품목 없음',
            text: '청구 계산할 품목이 없습니다. 품목을 먼저 추가해주세요.',
            icon: 'warning',
            confirmButtonText: '확인'
          });
          return;
        }

        // 선택된 품목이 있는지 확인
        const selectedProducts = this.getSelectedProductsForClaim();
        if (!selectedProducts || selectedProducts.length === 0) {
          this.$swal.fire({
            title: '선택된 품목 없음',
            text: '청구 계산할 품목을 선택해주세요.',
            icon: 'warning',
            confirmButtonText: '확인'
          });
          return;
        }

        if (!this.client_data_obj || !this.client_data_obj.name || !this.client_data_obj.number) {
          this.$swal.fire({
            title: '수급자 정보 미입력',
            text: '청구 계산을 위해 수급자 정보를 먼저 입력해주세요.',
            icon: 'warning',
            confirmButtonText: '확인',
            didOpen: () => {
              const clientUpBtn = document.querySelector('.clientUpBtn');
              if (clientUpBtn) {
                clientUpBtn.classList.add('buzz');
                setTimeout(() => {
                  clientUpBtn.classList.remove('buzz');
                }, 750);
              }
            }
          });
          return;
        }

        // 주문서 타입에 따라 초기 탭 설정
        let initialTab = 'diabetes'; // 기본값
        if (this.rentalTypes.hasOxygenGenerator || this.orderId?.rental_type === 'o') {
          initialTab = 'oxygen';
        } else if (this.rentalTypes.hasDiabetesProduct || this.orderId?.rental_type === 'd') {
          initialTab = 'diabetes';
        } else if (this.rentalTypes.hasAssistanceProduct || this.orderId?.rental_type === 'a') {
          initialTab = 'assistance';
        }

        this.showModal_obj.claim_calculation = true;

        // 모달이 열린 후 초기 탭 설정
        this.$nextTick(() => {
          const claimCalculationPopup = this.$refs.claimCalculationPopup;
          if (claimCalculationPopup) {
            claimCalculationPopup.setActiveTab(initialTab);
          }
        });
      } catch (error) {
        console.error('청구 계산 모달 열기 중 오류:', error);
        this.$swal.fire({
          title: '오류 발생',
          text: '청구 계산 모달을 여는 중 오류가 발생했습니다.',
          icon: 'error',
          confirmButtonText: '확인'
        });
      }
    },

    // 청구 계산용 선택된 품목 데이터 가져오기
    getSelectedProductsForClaim() {
      try {
        if (!this.products_obj || !Array.isArray(this.products_obj)) {
          console.warn('products_obj가 정의되지 않았거나 배열이 아닙니다.');
          return [];
        }

        return this.products_obj
          .filter(product => product && product.selected)
          .map(product => ({
            id: product.id,
            name: product.name3,
            price: product.buyprice,
            quantity: product.quantity,
            type: product.type,
            pieces_per_box: product.pieces_per_box,
            piece_quantity: product.piece_quantity,
            all_quantity: product.all_quantity,
            isDiabetes: this.rentalTypes?.hasDiabetesProduct || false,
            isOxygen: this.rentalTypes?.hasOxygenGenerator || false,
            isAssistance: this.rentalTypes?.hasAssistanceProduct || false
          }));
      } catch (error) {
        console.error('선택된 품목 데이터 가져오기 중 오류:', error);
        return [];
      }
    },

    perItemTotalPrice(product) {
      const unitPrice = this.getStoreUnitPrice(product) || 0;
      const quantity = product.quantity || 0;
      return unitPrice * quantity;
    },

    // 파일 붙여넣기 핸들러
    handleFilePaste(event) {
      event.preventDefault();
      const items = event.clipboardData.items;
      const filesToAdd = [];

      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.type.indexOf('image') !== -1 || item.type === 'application/pdf') {
          const file = item.getAsFile();
          if (file) {
            filesToAdd.push(file);
          }
        }
      }

      if (filesToAdd.length > 0) {
        const dataTransfer = new DataTransfer();
        filesToAdd.forEach(file => dataTransfer.items.add(file));

        const fileInputEvent = {
          target: {
            files: dataTransfer.files
          }
        };

        this.handleFileSelect(fileInputEvent);
      }

      this.isPasteFocus = false;
    },

    // 포커스 처리 메소드
    handleDocumentSectionFocus() {
      this.isPasteFocused = true;
    },

    // 블러 처리 메소드
    handleDocumentSectionBlur() {
      this.isPasteFocused = false;
    },

    // 파일 유효성 검사
    validateFiles(files) {
      const validFiles = [];
      const invalidFiles = [];
      const maxSize = 30 * 1024 * 1024; // 30MB

      Array.from(files).forEach(file => {
        // 파일 크기 검사
        if (file.size > maxSize) {
          invalidFiles.push({
            name: file.name,
            reason: '파일 크기 초과 (최대 30MB)'
          });
          return;
        }

        // 유효한 파일 추가
        validFiles.push(file);
      });

      // 유효하지 않은 파일이 있으면 알림
      if (invalidFiles.length > 0) {
        const invalidFileNames = invalidFiles.map(f => `${f.name}: ${f.reason}`).join('\n');

        this.$swal.fire({
          icon: 'warning',
          title: '일부 파일을 업로드할 수 없습니다',
          text: invalidFileNames,
          confirmButtonText: '확인'
        });
      }

      return validFiles;
    },

    // 품목 삭제 메서드
    deleteProduct(index) {
      const product = this.products_obj[index];
      this.products_obj.splice(index, 1);
    },
    // 품목 수량 증가
    increaseQuantity(index) {
      if (!this.products[index].quantity) {
        this.products[index].quantity = 0;
      }
      this.products[index].quantity++;
      this.updateTotalQuantity(index);
    },

    // 품목 수량 감소
    decreaseQuantity(index) {
      if (this.products[index].quantity > 0) {
        this.products[index].quantity--;
        this.updateTotalQuantity(index);
      }
    },

    // 낱개 수량 증가
    increasePieceQuantity(index) {
      if (!this.products[index].piece_quantity) {
        this.products[index].piece_quantity = 0;
      }
      this.products[index].piece_quantity++;
      this.updateTotalQuantity(index);
    },

    // 낱개 수량 감소
    decreasePieceQuantity(index) {
      if (this.products[index].piece_quantity > 0) {
        this.products[index].piece_quantity--;
        this.updateTotalQuantity(index);
      }
    },

    // 합계 수량 업데이트
    updateTotalQuantity(index) {
      const product = this.products[index];
      product.all_quantity = this.calculateTotalQuantityValue(product);
    },

    // 합계 수량 값 계산
    calculateTotalQuantityValue(product) {
      const quantity = parseInt(product.quantity) || 0;
      const pieceQuantity = parseInt(product.piece_quantity) || 0;

      if (quantity === 0 && pieceQuantity === 0) {
        return 0;
      } else if (quantity === 0) {
        return pieceQuantity;
      } else if (pieceQuantity === 0) {
        return quantity;
      } else {
        return quantity * pieceQuantity;
      }
    },

    // 재고 수량 증가
    increaseStockQuantity(index) {
      if (!this.products[index].stock_quantity) {
        this.products[index].stock_quantity = 0;
      }
      this.products[index].stock_quantity++;
    },

    // 재고 수량 감소
    decreaseStockQuantity(index) {
      if (this.products[index].stock_quantity > 0) {
        this.products[index].stock_quantity--;
      }
    },
    // ==================================================
    // 반품 관련련 메서드
    // ==================================================
    // 반품 상태 조회
    async getCurrentReturnStatus() {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const currentCompanyKey = userInfo?.company_key || this.$globalState.company_key;

        const response = await this.$axios.get(`${this.$apiUrls.hanqmedi}/getReturnOrders`, {
          params: {
            returnSearch: '',
            startDate: this.formatDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1)),
            endDate: this.formatDate(new Date()),
            companykey: currentCompanyKey
          }
        });

        if (response.data.success && response.data.data) {
          const returnOrder = response.data.data.find(item =>
            item.return_order_id === parseInt(this.orderId) ||
            item.return_id === parseInt(this.orderId)
          );

          if (returnOrder) {
            return parseInt(returnOrder.return_status) || 0;
          }
        }
        return 0;
      } catch (error) {
        console.error('반품 상태 조회 실패:', error);
        return this.returnStatus || 0;
      }
    },

    // 반품 상태 변경 모달 표시
    async showReturnStatusModal() {
      const currentStatus = await this.getCurrentReturnStatus();
      const currentStatusText = this.getReturnStatusText(currentStatus);

      this.$swal.fire({
        title: '<div style="font-size: 24px; font-weight: 600; color: #2c3e50; margin-bottom: 10px;">반품 상태 변경</div>',
        html: `
          <div style="max-width: 400px; margin: 0 auto; padding: 20px;">
            <!-- 현재 상태 표시 -->
            <div style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; padding: 15px; border-radius: 12px; margin-bottom: 25px; text-align: center; box-shadow: 0 4px 15px rgba(0,0,0,0.1);">
              <div style="font-size: 14px; opacity: 0.9; margin-bottom: 5px;">현재 상태</div>
              <div style="font-size: 18px; font-weight: 600;">${currentStatusText}</div>
            </div>
            
            <!-- 상태 선택 옵션 -->
            <div style="background: #f8f9fa; border-radius: 12px; padding: 20px; border: 1px solid #e9ecef;">
              <div style="font-size: 16px; font-weight: 600; color: #495057; margin-bottom: 15px; text-align: center;">변경할 상태 선택</div>
              
              <div style="display: grid; gap: 12px;">
                <label style="display: flex; align-items: center; padding: 12px; background: white; border-radius: 8px; cursor: pointer; transition: all 0.2s; border: 2px solid transparent; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
                  <input type="radio" name="status" value="0" ${currentStatus === 0 ? 'checked' : ''} style="margin-right: 12px; transform: scale(1.2);">
                  <span style="font-weight: 500; color: #495057;">접수</span>
                  <span style="margin-left: auto; font-size: 12px; color: #6c757d;">반품 요청 접수</span>
                </label>
                
                <label style="display: flex; align-items: center; padding: 12px; background: white; border-radius: 8px; cursor: pointer; transition: all 0.2s; border: 2px solid transparent; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
                  <input type="radio" name="status" value="1" ${currentStatus === 1 ? 'checked' : ''} style="margin-right: 12px; transform: scale(1.2);">
                  <span style="font-weight: 500; color: #495057;">승인</span>
                  <span style="margin-left: auto; font-size: 12px; color: #6c757d;">반품 승인 완료</span>
                </label>
                
                <label style="display: flex; align-items: center; padding: 12px; background: white; border-radius: 8px; cursor: pointer; transition: all 0.2s; border: 2px solid transparent; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
                  <input type="radio" name="status" value="2" ${currentStatus === 2 ? 'checked' : ''} style="margin-right: 12px; transform: scale(1.2);">
                  <span style="font-weight: 500; color: #495057;">회수</span>
                  <span style="margin-left: auto; font-size: 12px; color: #6c757d;">상품 회수 진행</span>
                </label>
                
                <label style="display: flex; align-items: center; padding: 12px; background: white; border-radius: 8px; cursor: pointer; transition: all 0.2s; border: 2px solid transparent; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
                  <input type="radio" name="status" value="3" ${currentStatus === 3 ? 'checked' : ''} style="margin-right: 12px; transform: scale(1.2);">
                  <span style="font-weight: 500; color: #495057;">검수</span>
                  <span style="margin-left: auto; font-size: 12px; color: #6c757d;">상품 검수 중</span>
                </label>
                
                <label style="display: flex; align-items: center; padding: 12px; background: white; border-radius: 8px; cursor: pointer; transition: all 0.2s; border: 2px solid transparent; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
                  <input type="radio" name="status" value="4" ${currentStatus === 4 ? 'checked' : ''} style="margin-right: 12px; transform: scale(1.2);">
                  <span style="font-weight: 500; color: #495057;">환불/교환</span>
                  <span style="margin-left: auto; font-size: 12px; color: #6c757d;">처리 완료</span>
                </label>
              </div>
            </div>
          </div>
          
          <style>
            .swal2-popup {
              border-radius: 16px !important;
              box-shadow: 0 20px 60px rgba(0,0,0,0.15) !important;
            }
            .swal2-title {
              padding: 0 !important;
            }
            .swal2-html-container {
              margin: 0 !important;
              padding: 0 !important;
            }
            .swal2-actions {
              margin-top: 25px !important;
            }
            .swal2-confirm {
              background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
              border-radius: 8px !important;
              padding: 12px 30px !important;
              font-weight: 600 !important;
              box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4) !important;
            }
            .swal2-cancel {
              background: #6c757d !important;
              border-radius: 8px !important;
              padding: 12px 30px !important;
              font-weight: 600 !important;
            }
            label:hover {
              border-color: #667eea !important;
              transform: translateY(-1px) !important;
              box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important;
            }
            input[type="radio"]:checked + span {
              color: #667eea !important;
              font-weight: 600 !important;
            }
          </style>
        `,
        showCancelButton: true,
        confirmButtonText: '상태 변경',
        cancelButtonText: '취소',
        confirmButtonColor: '#667eea',
        cancelButtonColor: '#6c757d',
        width: '500px',
        customClass: {
          popup: 'modern-modal'
        },
        preConfirm: () => {
          const selectedStatus = document.querySelector('input[name="status"]:checked');
          if (!selectedStatus) {
            this.$swal.showValidationMessage('상태를 선택해주세요.');
            return false;
          }
          const newStatus = parseInt(selectedStatus.value);

          // 동일한 상태로 변경하려는 경우 경고
          if (newStatus === currentStatus) {
            this.$swal.showValidationMessage('현재와 동일한 상태입니다. 다른 상태를 선택해주세요.');
            return false;
          }

          return newStatus;
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.changeReturnOrderStatus(result.value);
        }
      });
    },

    // 반품 상태 변경 처리
    async changeReturnOrderStatus(newStatus) {
      if (!this.returnOrderId) {
        this.$swal.fire({
          title: '오류',
          text: '반품 주문 ID가 없습니다.',
          icon: 'error',
          confirmButtonText: '확인'
        });
        return;
      }

      try {
        const response = await this.$axios.post(`${this.$apiUrls.hanqmedi}/changeReturnOrderStatus`, {
          return_order_id: this.returnOrderId,
          return_status: newStatus
        });
        if (response.data.success) {
          this.$swal.fire('성공', '반품 상태가 변경되었습니다.', 'success');
          // 상태 업데이트
          this.returnStatus = newStatus;
          await this.getCurrentReturnStatus();
          // 부모 컴포넌트에 이벤트 발생
          this.$emit('order-updated');
        } else {
          throw new Error(response.data.message || '상태 변경 실패');
        }
      } catch (error) {
        this.$swal.fire('오류', '반품 상태 변경 중 오류가 발생했습니다.', 'error');
      }
    },

    // 반품 상태 텍스트 반환
    getReturnStatusText(status) {
      const statusMap = {
        0: '접수',
        1: '승인',
        2: '회수',
        3: '검수',
        4: '환불/교환'
      };
      return statusMap[status] || '알 수 없음';
    },

    // 반품 취소 처리
    async cancelReturnOrder() {
      if (!this.returnOrderId) {
        this.$swal.fire({
          title: '오류',
          text: '반품 주문 ID가 없습니다.',
          icon: 'error',
          confirmButtonText: '확인'
        });
        return;
      }

      const result = await this.$swal.fire({
        title: '반품 취소 확인',
        html: '정말로 반품을 취소하시겠습니까? <br>취소 후에는 되돌릴 수 없습니다.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '취소하기',
        cancelButtonText: '돌아가기',
        confirmButtonColor: '#dc3545',
        cancelButtonColor: '#6c757d'
      });

      if (result.isConfirmed) {
        try {
          const response = await this.$axios.delete(`${this.$apiUrls.hanqmedi}/cancelReturnOrder/${this.returnOrderId}`);

          if (response.data.success) {
            this.$swal.fire({
              title: '반품 취소 완료',
              text: response.data.message,
              icon: 'success',
              confirmButtonText: '확인'
            });

            // 반품 관련 상태 초기화
            this.isReturnOrder = false;
            this.returnOrderNum = null;
            this.returnOrderId = null;
            this.returnStatus = null;
            this.actualOrderId = this.orderId;

            // 주문 데이터 새로고침
            await this.fetchOrderData();

            this.$emit('close-return-modal');
          } else {
            throw new Error(response.data.message || '반품 취소에 실패했습니다.');
          }
        } catch (error) {
          console.error('반품 취소 실패:', error);
          this.$swal.fire({
            title: '오류',
            text: error.message || '반품 취소 중 오류가 발생했습니다.',
            icon: 'error',
            confirmButtonText: '확인'
          });
        }
      }
    },

    // ==================================================
    // A/S 관련 메서드
    // ==================================================
    // A/S 상태 조회 메서드 추가
    async getCurrentAsStatus() {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const currentCompanyKey = userInfo?.company_key || this.$globalState.company_key;

        const response = await this.$axios.get(`${this.$apiUrls.hanqmedi}/getAsOrders`, {
          params: {
            asSearch: '',
            startDate: this.formatDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1)),
            endDate: this.formatDate(new Date()),
            companykey: currentCompanyKey
          }
        });

        if (response.data.success && response.data.data) {
          const asOrder = response.data.data.find(item =>
            item.as_order_id === parseInt(this.asOrderId) ||
            item.as_id === parseInt(this.asOrderId) ||
            item.as_order_id === parseInt(this.orderId) ||
            item.as_id === parseInt(this.orderId)
          );

          if (asOrder) {
            const status = parseInt(asOrder.as_status) || 0;
            return status;
          }
        }
        return this.asStatus || 0;
      } catch (error) {
        console.error('A/S 상태 조회 실패:', error);
        return this.asStatus || 0;
      }
    },

    // A/S 상태 변경 모달 표시
    async showAsStatusModal() {
      // 현재 상태를 새로고침하여 가져오기
      const currentStatus = await this.getCurrentAsStatus();
      const currentStatusText = this.getAsStatusText(currentStatus);

      this.$swal.fire({
        title: '<div style="font-size: 24px; font-weight: 600; color: #2c3e50; margin-bottom: 10px;">A/S 상태 변경</div>',
        html: `
          <div style="max-width: 400px; margin: 0 auto; padding: 20px;">
            <!-- 현재 상태 표시 -->
            <div style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; padding: 15px; border-radius: 12px; margin-bottom: 25px; text-align: center; box-shadow: 0 4px 15px rgba(0,0,0,0.1);">
              <div style="font-size: 14px; opacity: 0.9; margin-bottom: 5px;">현재 상태</div>
              <div style="font-size: 18px; font-weight: 600;">${currentStatusText}</div>
            </div>
            
            <!-- 상태 선택 옵션 -->
            <div style="background: #f8f9fa; border-radius: 12px; padding: 20px; border: 1px solid #e9ecef;">
              <div style="font-size: 16px; font-weight: 600; color: #495057; margin-bottom: 15px; text-align: center;">변경할 상태 선택</div>
              
              <div style="display: grid; gap: 12px;">
                <label style="display: flex; align-items: center; padding: 12px; background: white; border-radius: 8px; cursor: pointer; transition: all 0.2s; border: 2px solid transparent; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
                  <input type="radio" name="asStatus" value="0" ${currentStatus === 0 ? 'checked' : ''} style="margin-right: 12px; transform: scale(1.2);">
                  <span style="font-weight: 500; color: #495057;">접수</span>
                  <span style="margin-left: auto; font-size: 12px; color: #6c757d;">A/S 요청 접수</span>
                </label>
                
                <label style="display: flex; align-items: center; padding: 12px; background: white; border-radius: 8px; cursor: pointer; transition: all 0.2s; border: 2px solid transparent; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
                  <input type="radio" name="asStatus" value="1" ${currentStatus === 1 ? 'checked' : ''} style="margin-right: 12px; transform: scale(1.2);">
                  <span style="font-weight: 500; color: #495057;">승인</span>
                  <span style="margin-left: auto; font-size: 12px; color: #6c757d;">A/S 승인 완료</span>
                </label>
                
                <label style="display: flex; align-items: center; padding: 12px; background: white; border-radius: 8px; cursor: pointer; transition: all 0.2s; border: 2px solid transparent; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
                  <input type="radio" name="asStatus" value="2" ${currentStatus === 2 ? 'checked' : ''} style="margin-right: 12px; transform: scale(1.2);">
                  <span style="font-weight: 500; color: #495057;">수리중</span>
                  <span style="margin-left: auto; font-size: 12px; color: #6c757d;">수리 작업 진행</span>
                </label>
                
                <label style="display: flex; align-items: center; padding: 12px; background: white; border-radius: 8px; cursor: pointer; transition: all 0.2s; border: 2px solid transparent; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
                  <input type="radio" name="asStatus" value="3" ${currentStatus === 3 ? 'checked' : ''} style="margin-right: 12px; transform: scale(1.2);">
                  <span style="font-weight: 500; color: #495057;">검수</span>
                  <span style="margin-left: auto; font-size: 12px; color: #6c757d;">수리 완료 검수</span>
                </label>
                
                <label style="display: flex; align-items: center; padding: 12px; background: white; border-radius: 8px; cursor: pointer; transition: all 0.2s; border: 2px solid transparent; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
                  <input type="radio" name="asStatus" value="4" ${currentStatus === 4 ? 'checked' : ''} style="margin-right: 12px; transform: scale(1.2);">
                  <span style="font-weight: 500; color: #495057;">완료</span>
                  <span style="margin-left: auto; font-size: 12px; color: #6c757d;">A/S 처리 완료</span>
                </label>
              </div>
            </div>
          </div>
          
          <style>
            .swal2-popup {
              border-radius: 16px !important;
              box-shadow: 0 20px 60px rgba(0,0,0,0.15) !important;
            }
            .swal2-title {
              padding: 0 !important;
            }
            .swal2-html-container {
              margin: 0 !important;
              padding: 0 !important;
            }
            .swal2-actions {
              margin-top: 25px !important;
            }
            .swal2-confirm {
              background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
              border-radius: 8px !important;
              padding: 12px 30px !important;
              font-weight: 600 !important;
              box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4) !important;
            }
            .swal2-cancel {
              background: #6c757d !important;
              border-radius: 8px !important;
              padding: 12px 30px !important;
              font-weight: 600 !important;
            }
            label:hover {
              border-color: #667eea !important;
              transform: translateY(-1px) !important;
              box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important;
            }
            input[type="radio"]:checked + span {
              color: #667eea !important;
              font-weight: 600 !important;
            }
          </style>
        `,
        showCancelButton: true,
        confirmButtonText: '상태 변경',
        cancelButtonText: '취소',
        confirmButtonColor: '#667eea',
        cancelButtonColor: '#6c757d',
        width: '500px',
        customClass: {
          popup: 'modern-modal'
        },
        preConfirm: () => {
          const selectedStatus = document.querySelector('input[name="asStatus"]:checked');
          if (!selectedStatus) {
            this.$swal.showValidationMessage('상태를 선택해주세요.');
            return false;
          }
          const newStatus = parseInt(selectedStatus.value);

          // 동일한 상태로 변경하려는 경우 경고
          if (newStatus === currentStatus) {
            this.$swal.showValidationMessage('현재와 동일한 상태입니다. 다른 상태를 선택해주세요.');
            return false;
          }

          return newStatus;
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.changeAsOrderStatus(result.value);
        }
      });
    },

    // A/S 상태 새로고침 메서드 추가
    async refreshAsStatus() {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const currentCompanyKey = userInfo?.company_key || this.$globalState.company_key;

        const response = await this.$axios.get(`${this.$apiUrls.hanqmedi}/getAsOrders`, {
          params: {
            asSearch: '',
            startDate: this.formatDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1)),
            endDate: this.formatDate(new Date()),
            companykey: currentCompanyKey
          }
        });

        if (response.data.success && response.data.data) {
          const asOrder = response.data.data.find(item =>
            item.as_order_id === parseInt(this.asOrderId) ||
            item.as_id === parseInt(this.asOrderId)
          );

          if (asOrder) {
            // A/S 상태 업데이트
            this.asStatus = parseInt(asOrder.as_status) || 0;
            this.asOrderNum = asOrder.as_id;
            this.asOrderId = asOrder.as_order_id;
          }
        }
      } catch (error) {
        console.error('A/S 상태 새로고침 실패:', error);
      }
    },

    // A/S 상태 변경 처리
    async changeAsOrderStatus(newStatus) {
      if (!this.asOrderId) {
        this.$swal.fire({
          title: '오류',
          text: 'A/S 주문 ID가 없습니다.',
          icon: 'error',
          confirmButtonText: '확인'
        });
        return;
      }

      try {
        const response = await this.$axios.post(`${this.$apiUrls.hanqmedi}/checkAsStatus`, {
          as_order_id: this.asOrderId,
          as_status: newStatus
        });

        if (response.data.success) {
          this.$swal.fire({
            title: '성공',
            text: 'A/S 상태가 변경되었습니다.',
            icon: 'success',
            confirmButtonText: '확인'
          });

          // 상태 업데이트
          this.asStatus = newStatus;

          // A/S 상태를 즉시 새로고침
          await this.refreshAsStatus();

          // 부모 컴포넌트에 이벤트 발생
          this.$emit('order-updated');

        } else {
          throw new Error(response.data.message || '상태 변경 실패');
        }
      } catch (error) {
        console.error('A/S 상태 변경 실패:', error);
        this.$swal.fire({
          title: '오류',
          text: error.message || 'A/S 상태 변경 중 오류가 발생했습니다.',
          icon: 'error',
          confirmButtonText: '확인'
        });
      }
    },

    // A/S 상태 텍스트 반환
    getAsStatusText(status) {
      const statusMap = {
        0: '접수',
        1: '승인',
        2: '수리중',
        3: '검수',
        4: '완료'
      };
      return statusMap[status] || '알 수 없음';
    },

    // A/S 취소 처리 (기존 메서드 수정)
    async cancelAsOrder() {
      if (!this.asOrderId) {
        this.$swal.fire({
          title: '오류',
          text: 'A/S 주문 ID가 없습니다.',
          icon: 'error',
          confirmButtonText: '확인'
        });
        return;
      }

      const result = await this.$swal.fire({
        title: 'A/S 취소 확인',
        html: '정말로 A/S를 취소하시겠습니까? <br>취소 후에는 되돌릴 수 없습니다.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '취소하기',
        cancelButtonText: '돌아가기',
        confirmButtonColor: '#dc3545',
        cancelButtonColor: '#6c757d'
      });

      if (result.isConfirmed) {
        try {
          const response = await this.$axios.delete(`${this.$apiUrls.hanqmedi}/cancelAsOrder/${this.asOrderId}`);

          if (response.data.success) {
            this.$swal.fire({
              title: 'A/S 취소 완료',
              text: response.data.message,
              icon: 'success',
              confirmButtonText: '확인'
            });

            // A/S 관련 상태 초기화
            this.isAsOrder = false;
            this.asOrderNum = null;
            this.asOrderId = null;
            this.asStatus = null;
            this.actualOrderId = this.orderId;

            // 주문 데이터 새로고침
            await this.fetchOrderData();

            this.$emit('close-as-modal');
          } else {
            throw new Error(response.data.message || 'A/S 취소에 실패했습니다.');
          }
        } catch (error) {
          console.error('A/S 취소 실패:', error);
          this.$swal.fire({
            title: '오류',
            text: error.message || 'A/S 취소 중 오류가 발생했습니다.',
            icon: 'error',
            confirmButtonText: '확인'
          });
        }
      }
    },

    // 주문서 타입 확인 (일반, 대여, 산소, 보장구, 당뇨)
    async fetchOrderType(orderId) {
      try {
        const response = await this.$axios.get(`${this.$apiUrls.hanqmedi}/orderType/${orderId}`);

        if (response.data.success) {
          this.rentalTypes = {
            hasRentalProduct: response.data.hasRentalProduct,
            hasOxygenGenerator: response.data.hasOxygenGenerator,
            hasDiabetesProduct: response.data.hasDiabetesProduct,
            hasAssistanceProduct: response.data.hasAssistanceProduct
          };
        }
      } catch (error) {
        console.error('주문서 타입 확인 중 오류:', error);
      }
    },

    // 제품 확장/축소 토글
    toggleProductExpand(index) {
      const product = this.products_obj[index];

      // 현재 제품 확장/축소
      product.expanded = !product.expanded;

      // 모든 제품이 확장되어 있는지 확인하여 showAllDetails 상태 업데이트
      const allExpanded = this.products_obj.every(product => product.expanded);
      const noneExpanded = this.products_obj.every(product => !product.expanded);

      if (allExpanded) {
        this.showAllDetails = true;
      } else if (noneExpanded) {
        this.showAllDetails = false;
      }
    },

    // 재고 관련 =====================================================================
    startEditingStockQuantity(index) {
      const product = this.products_obj[index];

      // b_product_id가 999999보다 큰 경우에만 수정 가능
      if (!product || product.b_product_id < 1000000) {
        return;
      }

      // 다른 제품의 편집 모드를 모두 해제
      this.products_obj.forEach(p => {
        if (p !== product) {
          p.isEditingStock = false;
        }
      });

      product.isEditingStock = true;
      product.original_stock_quantity = product.stock_quantity;

      this.$nextTick(() => {
        setTimeout(() => {
          document.querySelector('.stock-quantity-input')?.focus();
        }, 50);
      });
    },
    finishEditingStockQuantity(index) {
      const product = this.products_obj[index];
      const originalValue = product.original_stock_quantity;
      const newValue = parseInt(product.stock_quantity, 10) || 0;

      if (newValue !== originalValue) {
        this.updateProductStock(product.b_product_id, newValue);
      }

      product.isEditingStock = false;
    },
    handleStockQuantityChange(index, value) {
      const product = this.products_obj[index];
      if (!product.original_stock_quantity) {
        product.original_stock_quantity = product.stock_quantity;
      }

      let newValue = parseInt(value, 10);
      if (isNaN(newValue) || newValue < 0) {
        newValue = 0;
      }

      product.stock_quantity = newValue;
    },
    async updateProductStock(productId, newQuantity) {
      try {
        await this.$axios.post(`${this.$apiUrls.hanqmedi}/updateDirectQuantity`, {
          b_item_id: productId,
          quantity: newQuantity,
          companykey: this.$globalState.company_key
        });

        this.$swal.fire({
          icon: 'success',
          title: '재고 수량이 업데이트되었습니다.',
          toast: true,
          position: 'top',
          showConfirmButton: false,
          timer: 1500,
          timerProgressBar: true,
          customClass: {
            container: 'stock-toast-container'
          }
        });

      } catch (error) {
        console.error('재고 수량 업데이트 실패:', error);

        this.$swal.fire({
          icon: 'error',
          title: '재고 수량 업데이트에 실패했습니다.',
          toast: true,
          position: 'top',
          showConfirmButton: false,
          timer: 1500,
          timerProgressBar: true,
          customClass: {
            container: 'stock-toast-container'
          }
        });
      }
    },

    hasProductWithName(name) {
      return this.products_obj.some(product => {
        const productName = product.name || '';
        const productName0 = product.name0 || '';

        // 욕창예방 매트리스의 경우 띄어쓰기 유무와 상관없이 확인
        if (name === '욕창예방매트리스' || name === '욕창예방 매트리스') {
          return productName.includes('욕창예방') && productName.includes('매트리스') ||
            productName0.includes('욕창예방') && productName0.includes('매트리스');
        }

        return productName === name || productName0 === name;
      });
    },

    // 파일명 매칭 =====================================================================
    hasFileWithName(keyword) {
      if (!this.documents || !Array.isArray(this.documents)) return false;

      const keywordLower = keyword.toLowerCase();
      return this.documents.some(doc => {
        const fileName = doc.fileName ? doc.fileName.toLowerCase() : '';

        switch (keywordLower) {
          // 공통 관련 파일 키워드
          case '처방전':
            return fileName.includes('처방');
          case '신분증':
            return fileName.includes('신분증') || fileName.includes('복지') || fileName.includes('카드');
          case '계산서':
            return fileName.includes('전자') || fileName.includes('세금') || fileName.includes('계산서');
          case '영수증':
            return fileName.includes('영수증') || fileName.includes('현금') || fileName.includes('카드');

          // 산소발생기 관련 파일 키워드
          case '표준계약서':
            return fileName.includes('표준') || fileName.includes('계약');
          case '급여대상자 등록신청서':
            return fileName.includes('산소치료') || fileName.includes('급여') || fileName.includes('대상자') || fileName.includes('등록') || fileName.includes('신청서');

          // 보조기기 관련 파일 키워드
          case '보조기기 급여 지급청구서':
            return fileName.includes('보조기기') || fileName.includes('급여') || fileName.includes('지급청구서');
          case '보조기기 급여 지급청구 위임장':
            return fileName.includes('보조기기') || fileName.includes('급여') || fileName.includes('지급청구') || fileName.includes('위임장');
          case '바코드':
            return fileName.includes('바코드') || fileName.includes('부착') || fileName.includes('사진');

          // 보조기기 (의료용 스쿠터, 수동휠체어, 전동휠체어)
          case '결정통보서':
            return fileName.includes('보조기기') || fileName.includes('급여') || fileName.includes('대상') || fileName.includes('여부') || fileName.includes('결정통보서');

          // 보조기기 (욕창예방 매트리스)
          case 'mbi':
            return fileName.includes('mbi') || fileName.includes('검사') || fileName.includes('결과');
          case '다리맨손근력검사':
            return fileName.includes('다리') || fileName.includes('맨손') || fileName.includes('근력') || fileName.includes('검사') || fileName.includes('결과');
          // 보조기기 (보청기)
          case '검수확인서':
            return fileName.includes('검수') || fileName.includes('확인');
          case '견적서':
            return fileName.includes('거래') || fileName.includes('견적');
          case '보청기 표준 구매계약서':
            return fileName.includes('보청기') || fileName.includes('표준') || fileName.includes('구매') || fileName.includes('계약');

          // 당뇨소모성재료 관련 파일 키워드
          case '요양비 지급청구 위임장':
            return fileName.includes('요양비') || fileName.includes('지급') || fileName.includes('청구') || fileName.includes('위임장');
          case '거래명세서':
            return fileName.includes('거래') || fileName.includes('명세서');
          default:
            return fileName.includes(keywordLower);
        }
      });
    },

    // 피드백 관련 =====================================================================
    // 특정 댓글에 대한 피드백 존재 여부 확인
    hasFeedbackForComment(commentId) {
      return this.feedbacksData.some(feedback => feedback.commentId === commentId);
    },
    // 특정 댓글의 피드백 데이터 가져오기
    getFeedbackForComment(commentId) {
      return this.feedbacksData.find(feedback => feedback.commentId === commentId);
    },
    // 기존 피드백 확인
    async checkExistingFeedback() {
      try {
        await this.commmentGet();

        const token = localStorage.getItem('token');
        const response = await this.$axios.get(
          `${this.$apiUrls.hanqmedi}/getFeedback/${this.orderId}`,
          {
            headers: { 'Authorization': `Bearer ${token}` }
          }
        );

        if (response.data.status === 'success' &&
          response.data.data.success &&
          response.data.data.data.length > 0) {
          // 모든 피드백 데이터 저장
          this.feedbacksData = response.data.data.data;
        } else {
          this.feedbacksData = [];
        }

      } catch (error) {
        console.error('피드백 확인 중 오류 발생:', error);
        this.feedbacksData = [];
      }
    },
    async showFeedbackDialog(comment) {
      if (!comment || !comment.num) {
        console.error('유효하지 않은 댓글 정보입니다.');
        return;
      }

      // 해당 댓글에 대한 피드백 존재 여부 확인
      const hasFeedback = this.hasFeedbackForComment(comment.num);

      if (hasFeedback) {
        const result = await this.$swal.fire({
          title: '피드백을 취소하시겠습니까?',
          text: "취소된 피드백은 복구할 수 없습니다.",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: '취소',
          cancelButtonText: '돌아가기'
        });

        if (result.isConfirmed) {
          try {
            const token = localStorage.getItem('token');
            const response = await this.$axios.delete(
              `${this.$apiUrls.hanqmedi}/deleteFeedback/${this.orderId}`,
              {
                headers: { 'Authorization': `Bearer ${token}` },
                params: { commentId: comment.num }
              }
            );

            if (response.data.status === 'success') {
              this.feedbacksData = this.feedbacksData.filter(
                feedback => feedback.commentId !== comment.num
              );

              // 피드백 삭제 이벤트 발생
              this.feedbackChanged = true;

              await this.$swal.fire({
                icon: 'success',
                title: '피드백이 취소되었습니다.'
              });
            }
          } catch (error) {
            console.error('피드백 삭제 중 오류 발생:', error);
            this.$swal.fire({
              icon: 'error',
              title: '오류가 발생했습니다.',
              text: '피드백 취소 중 문제가 발생했습니다.'
            });
          }
        }
        return;
      }

      const commentText = comment ? comment.text : '댓글 내용이 없습니다.';

      const { value: formValues } = await this.$swal.fire({
        title: '피드백 작성',
        html: `
                <div class="swal2-input-container">
                    <input id="swal-feedback-title" class="swal2-input" placeholder="피드백 제목을 입력해주세요.">
                    <textarea id="swal-feedback-content" class="swal2-textarea" placeholder="피드백 내용을 입력해주세요." rows="6">${commentText}</textarea>
                </div>
            `,
        showCancelButton: true,
        confirmButtonText: '작성',
        cancelButtonText: '취소',
        focusConfirm: false,
        customClass: {
          container: 'feedback-swal-container',
          popup: 'feedback-swal-popup',
          input: 'feedback-swal-input',
          textarea: 'feedback-swal-textarea'
        },
        preConfirm: () => {
          const title = document.getElementById('swal-feedback-title').value;
          const content = document.getElementById('swal-feedback-content').value;

          if (!title.trim()) {
            this.$swal.fire({
              icon: 'error',
              title: '제목을 입력해주세요',
            });
            return false;
          }
          if (!content.trim()) {
            this.$swal.fire({
              icon: 'error',
              title: '내용을 입력해주세요',
            });
            return false;
          }

          return {
            title: title.trim(),
            content: content.trim(),
            orderId: this.orderId,
            commentId: comment.num,
            manager: this.client_data_obj.manager,
            companykey: this.$globalState.company_key,
          }
        }
      });

      if (formValues) {
        try {
          const token = localStorage.getItem('token');
          const response = await this.$axios.post(`${this.$apiUrls.hanqmedi}/createFeedback`, formValues, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });

          if (response.data.status === 'success') {
            const newFeedback = {
              ...response.data.data.data,
              commentId: comment.num
            };
            this.feedbacksData.push(newFeedback);

            // 피드백 등록 이벤트 발생
            this.feedbackChanged = true;

            await this.$swal.fire({
              icon: 'success',
              title: '피드백이 저장되었습니다.',
            });
          }
        } catch (error) {
          console.error('피드백 저장 중 오류 발생:', error);
          this.$swal.fire({
            icon: 'error',
            title: '오류가 발생했습니다.',
            text: error.response?.data?.message || '피드백을 저장하는 중 문제가 발생했습니다.',
          });
        }
      }
    },
    async deleteFeedback() {
      try {
        const token = localStorage.getItem('token');
        const response = await this.$axios.delete(
          `${this.$apiUrls.hanqmedi}/deleteFeedback/${this.orderId}`,
          {
            headers: { 'Authorization': `Bearer ${token}` }
          }
        );

        if (response.data.status === 'success') {
          this.hasFeedback = false;

          // 피드백 삭제 이벤트 발생
          this.feedbackChanged = true;

          await this.$swal.fire({
            icon: 'success',
            title: '피드백이 취소되었습니다.'
          });
        }
      } catch (error) {
        console.error('피드백 삭제 중 오류 발생:', error);
        this.$swal.fire({
          icon: 'error',
          title: '오류가 발생했습니다.',
          text: '피드백 취소 중 문제가 발생했습니다.'
        });
      }
    },

    // 이미지 관련 =====================================================================
    showProductImage(event, product) {
      // 기존 타이머가 있으면 취소
      if (this.imagePreviewTimer) {
        clearTimeout(this.imagePreviewTimer);
        this.imagePreviewTimer = null;
      }

      if (!product) return;

      // 이벤트 대상이 image-trigger 클래스를 가진 요소이거나 그 자식인지 확인
      const triggerElement = event.target.closest('.image-trigger');
      if (!triggerElement) return;

      // 마우스 위치 기준으로 이미지 위치 계산
      const rect = triggerElement.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

      // 이미지 위치 설정
      this.imagePreviewStyle = {
        top: `${rect.top + scrollTop - 100}px`,
        left: `${rect.left + scrollLeft - 250}px`,
        zIndex: 1000
      };

      const timestamp = new Date().getTime();
      const s3BaseUrl = this.$apiUrls.s3Bucket;

      // 즉시 이미지 URL 설정 (존재 여부 확인 없이)
      let imageUrl = null;

      // 1. num으로 먼저 시도
      if (product.b_product_id) {
        imageUrl = `${s3BaseUrl}/Product-image/${product.b_product_id}.jpg?t=${timestamp}`;
      }
      // 2. code로 시도 (b_product_id가 없는 경우)
      else if (product.code?.trim()) {
        imageUrl = `${s3BaseUrl}/Product-image/${product.code}.jpg?t=${timestamp}`;
      }
      // 3. 기본 이미지
      else {
        imageUrl = `${s3BaseUrl}/Product-image/icon.png`;
      }

      this.imagePreviewUrl = imageUrl;

      // 이미지 로드 실패 시 기본 이미지로 fallback
      const img = new Image();
      img.onload = () => {
        // 이미지 로드 성공 - 이미 설정된 URL 유지
      };
      img.onerror = () => {
        // 이미지 로드 실패 시 기본 이미지로 변경
        if (this.imagePreviewUrl === imageUrl) {
          this.imagePreviewUrl = `${s3BaseUrl}/Product-image/icon.png`;
        }
      };
      img.src = imageUrl;
    },
    hideProductImage() {
      this.imagePreviewTimer = setTimeout(() => {
        this.imagePreviewUrl = null;
      }, 50);
    },
    async fetchImages() {
      try {
        this.isLoading = true;
        const response = await this.$axios.get(
          `${this.$apiUrls.hanqmedi}/getOrderImage/${this.orderId}`
        );

        if (response.data.success) {
          this.documents = response.data.data.images.map(file => ({
            id: file.id || file.key,
            fileName: file.fileName || file.originalname,
            registeredDate: file.uploadDate || file.createdAt || new Date().toISOString(),
            url: file.url || file.location,
            key: file.key, // key 속성 확실히 설정
            type: file.type || 'image/jpeg',
            size: file.size || 0,
            isLocal: false,
            selected: false,
            validityStartDate: file.validityStartDate || '',
            validityEndDate: file.validityEndDate || '',
            validityPeriod: file.validityPeriod || ''
          }));
        }
      } catch (error) {
        console.error('파일 조회 중 오류:', error);
        this.documents = [];
      } finally {
        this.isLoading = false;
      }
    },
    getImageUrl(image) {
      if (image.isLocal) {
        return image.url;  // 로컬 파일의 경우 생성된 URL 사용
      }
      return image.url;  // S3 이미지의 경우 signed URL 사용
    },
    async convertPdfToImage(pdfFile) {
      try {
        // PDF 파일을 ArrayBuffer로 변환
        const arrayBuffer = await pdfFile.arrayBuffer();

        // PDF 문서 로드
        const loadingTask = pdfjsLib.getDocument({ data: arrayBuffer });
        const pdf = await loadingTask.promise;

        // 첫 번째 페이지 가져오기
        const page = await pdf.getPage(1);

        // 캔버스 생성
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');

        // 페이지 크기 설정 (해상도 조정 가능)
        const viewport = page.getViewport({ scale: 1.5 });
        canvas.width = viewport.width;
        canvas.height = viewport.height;

        // 페이지 렌더링
        await page.render({
          canvasContext: context,
          viewport: viewport
        }).promise;

        // 캔버스를 Blob으로 변환
        return new Promise((resolve) => {
          canvas.toBlob((blob) => {
            resolve(blob);
          }, 'image/png');
        });
      } catch (error) {
        console.error('PDF 변환 중 오류:', error);
        this.$swal.fire({
          title: 'PDF 변환 실패',
          text: 'PDF를 이미지로 변환하는 중 오류가 발생했습니다.',
          icon: 'error'
        });
        return null;
      }
    },

    isImageFile(fileName) {
      const imageExtensions = ['jpg', 'jpeg', 'png'];
      const extension = fileName.split('.').pop().toLowerCase();
      return imageExtensions.includes(extension);
    },

    isPdfFile(fileName) {
      const extension = fileName.split('.').pop().toLowerCase();
      return extension === 'pdf';
    },

    openPreview(doc) {
      if (doc && doc.fileName) {
        this.selectedPreviewImage = {
          fileName: doc.fileName,
          url: doc.url,
          registeredDate: doc.registeredDate,
          fileType: this.getFileType(doc.fileName)
        };
      }
    },

    handlePdfError(event) {
      console.error('PDF 로드 실패:', event);
      // PDF 로드 실패 시 대체 메시지 표시
      const iframe = event.target;
      iframe.style.display = 'none';

      // 에러 메시지 표시
      const errorDiv = document.createElement('div');
      errorDiv.style.cssText = `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    text-align: center;
    padding: 40px;
    background: #f5f5f5;
  `;
      errorDiv.innerHTML = `
    <div style="font-size: 48px; color: #f44336; margin-bottom: 20px;">⚠️</div>
    <h3>PDF를 표시할 수 없습니다</h3>
    <p>브라우저에서 PDF를 직접 열어보세요.</p>
    <button onclick="window.open('${this.selectedPreviewImage.url}', '_blank')" 
      style="background: #f44336; color: white; border: none; padding: 10px 20px; border-radius: 5px; cursor: pointer; margin-top: 10px;">
      새 탭에서 열기
    </button>
  `;

      iframe.parentNode.appendChild(errorDiv);
    },

    closePreview() {
      this.selectedPreviewImage = null;
    },

    handleImageError(event) {
      console.error('이미지 로드 실패:', event);
      event.target.src = '/path/to/fallback/image.jpg';
    },

    async handleFileSelect(event) {
      try {
        const files = Array.from(event.target.files || []);
        if (files.length === 0) return;

        const tempDocuments = [];

        // 지원되는 파일 타입 확인
        const supportedTypes = [
          'image/jpeg',
          'image/jpg',
          'image/png',
          'application/pdf'
        ];

        // 파일 처리
        for (const file of files) {
          // 지원되는 파일 타입인지 확인
          if (!supportedTypes.includes(file.type)) {
            this.$swal.fire({
              icon: 'warning',
              title: '지원되지 않는 파일 형식',
              text: `${file.name}은(는) 지원되지 않는 파일 형식입니다. (지원: JPG, JPEG, PNG, PDF)`,
              confirmButtonText: '확인'
            });
            continue;
          }

          // 원본 파일 그대로 사용
          const fileWithDate = {
            id: Date.now() + Math.random(),
            fileName: file.name,
            registeredDate: new Date().toISOString(),
            type: file.type,
            size: file.size,
            file: file,
            url: URL.createObjectURL(file),
            isLocal: true,  // 로컬 파일로 표시
            selected: false,
            key: null  // 아직 서버에 업로드되지 않았으므로 null
          };

          tempDocuments.push(fileWithDate);
        }

        if (tempDocuments.length === 0) {
          this.$swal.fire({
            icon: 'warning',
            title: '등록 가능한 파일이 없습니다',
            text: 'JPG, JPEG, PNG, PDF 파일만 등록할 수 있습니다.',
            confirmButtonText: '확인'
          });
          return;
        }

        this.documents = [...this.documents, ...tempDocuments];

        // 파일 업로드
        const uploadPromises = tempDocuments.map(async (docItem, index) => {
          const formData = new FormData();
          formData.append('images', docItem.file);

          const response = await this.$axios.post(
            `${this.$apiUrls.hanqmedi}/orderImageUpload/${this.orderId}`,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              },
              timeout: 60000,
              onUploadProgress: (progressEvent) => {
                const progress = Math.round(
                  (progressEvent.loaded / progressEvent.total) * 100
                );
              }
            }
          );

          if (!response.data.success) {
            throw new Error(`${docItem.fileName}: ${response.data.message || '업로드 실패'}`);
          }

          // 업로드 완료 후 key 설정 및 isLocal을 false로 변경
          if (response.data.data && response.data.data.imageUrls && response.data.data.imageUrls.length > 0) {
            const uploadedFile = response.data.data.imageUrls[index]; // 해당 인덱스의 업로드된 파일
            if (uploadedFile && uploadedFile.key) {
              docItem.key = uploadedFile.key;
              docItem.isLocal = false;
              docItem.url = uploadedFile.url || docItem.url; // S3 URL로 업데이트
            }
          }

          return response.data;
        });

        try {
          await Promise.all(uploadPromises);

          this.$swal.fire({
            icon: 'success',
            title: '파일 등록 완료',
            text: '파일이 성공적으로 등록되었습니다.',
            confirmButtonText: '확인'
          });

        } catch (error) {
          console.error('파일 업로드 중 오류:', error);
          this.$swal.fire({
            icon: 'error',
            title: '파일 업로드 실패',
            text: error.message || '파일 업로드 중 오류가 발생했습니다.',
            confirmButtonText: '확인'
          });
        }

      } catch (error) {
        console.error('파일 처리 중 오류:', error);
        this.$swal.fire({
          icon: 'error',
          title: '파일 처리 오류',
          text: '파일을 처리하는 중 오류가 발생했습니다.',
          confirmButtonText: '확인'
        });
      }
    },

    // 이미지를 JPG로 변환하는 메서드 (최고 화질)
    async convertImageToJpg(imageFile, quality = 1.0) {
      return new Promise((resolve) => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const img = new Image();

        img.onload = () => {
          // 원본 크기 그대로 유지 (크기 조정 최소화)
          let { width, height } = img;
          const maxDimension = 8000; // 매우 큰 이미지만 조정

          if (width > maxDimension || height > maxDimension) {
            const ratio = Math.min(maxDimension / width, maxDimension / height);
            width = Math.round(width * ratio);
            height = Math.round(height * ratio);
          }

          // 캔버스 크기 설정
          canvas.width = width;
          canvas.height = height;

          // 최고 품질 렌더링 설정
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = 'high';

          // 배경을 흰색으로 설정 (투명도 문제 해결)
          ctx.fillStyle = '#FFFFFF';
          ctx.fillRect(0, 0, width, height);

          // 이미지를 캔버스에 그리기 (원본 크기 유지)
          ctx.drawImage(img, 0, 0, width, height);

          // 최고 품질 JPG로 변환
          canvas.toBlob((blob) => {
            resolve(blob);
          }, 'image/jpeg', quality);
        };

        img.onerror = () => {
          console.error('이미지 로드 실패:', imageFile.name);
          resolve(null);
        };

        img.src = URL.createObjectURL(imageFile);
      });
    },

    // 문서 관련 =====================================================================
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    async removeDocument(index) {
      try {
        const doc = this.documents[index];
        if (!doc) return;

        const result = await this.$swal.fire({
          icon: 'warning',
          title: '삭제 확인',
          text: '문서를 삭제하시겠습니까?',
          showCancelButton: true,
          confirmButtonText: '삭제',
          cancelButtonText: '취소',
          confirmButtonColor: '#d33',
          reverseButtons: true
        });

        if (!result.isConfirmed) return;

        // 이미지 키 확인
        const imageKey = doc.key;
        console.log('삭제할 문서 정보:', {
          fileName: doc.fileName,
          key: imageKey,
          orderId: this.orderId
        });

        // imageKey가 없으면 에러 처리
        if (!imageKey) {
          console.error('이미지 키가 없습니다:', doc);
          await this.$swal.fire({
            icon: 'error',
            title: '삭제 실패',
            text: '이미지 키를 찾을 수 없습니다.',
            confirmButtonText: '확인'
          });
          return;
        }

        // POST 방식으로 이미지 삭제 요청
        const response = await this.$axios.post(
          `${this.$apiUrls.hanqmedi}/orderImageDelete`,
          {
            orderId: this.orderId,
            imageKey: imageKey
          }
        );

        if (!response.data.success) {
          throw new Error(response.data.message || '삭제 실패');
        }

        // 성공적으로 삭제되면 로컬 상태 업데이트
        this.documents.splice(index, 1);

        await this.$swal.fire({
          icon: 'success',
          title: '성공',
          text: '파일이 성공적으로 삭제되었습니다.',
          confirmButtonText: '확인'
        });

        // 문서 목록 새로고침
        await this.fetchImages();

        // 부모 컴포넌트에 문서 개수 업데이트 알림
        this.$emit('imagesUploaded');

      } catch (error) {
        console.error('문서 삭제 중 오류 발생:', error);

        let errorMessage = '문서 삭제 중 오류가 발생했습니다.';
        if (error.response?.data?.message) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }

        await this.$swal.fire({
          icon: 'error',
          title: '삭제 실패',
          text: errorMessage,
          confirmButtonText: '확인'
        });
      }
    },

    // 가상계좌 관련 =====================================================================
    async fetchVirtualAccountHistory() {
      try {
        const companykey = Number(this.$globalState.company_key);

        if (companykey !== 32) {
          this.virtualAccountCount = 0;
          return;
        }

        const response = await this.$axios.post(
          `${this.$apiUrls.virtualaccount}/virtualaccount/getlist`,
          {
            search: "",
            sdate: "1999-01-01",
            edate: "2099-01-01",
            status: "",
            page: 1,
            rows: 9999
          }
        );

        if (response.data.code === 200) {
          // 현재 고객의 가상계좌 발송 건수 계산
          let accountData = response.data.data.filter(
            item => item.CUSNM === this.client_data_obj?.name
          );
          // 데이터가 10개 이상일 경우 중복 제거
          if (accountData.length >= 10) {
            const uniqueKeys = new Map();
            accountData = accountData.filter(item => {
              // 고객명, 금액, 항목명을 조합한 고유키 생성
              const key = `${item.CUSNM}-${item.MOBILENO}-${item.PAYITEMAMT}-${item.PAYITEMNM}`;
              if (!uniqueKeys.has(key)) {
                uniqueKeys.set(key, true);
                return true;
              }
              return false;
            });
          }

          this.virtualAccountCount = accountData.length;
        }
      } catch (error) {
        console.error('가상계좌 내역 조회 중 오류:', error);
        this.virtualAccountCount = 0;
      }
    },
    updateVirtualAccountCount(count) {
      const companykey = Number(this.$globalState.company_key);

      if (companykey !== 32) {
        this.virtualAccountCount = 0;
        return;
      }
      this.virtualAccountCount = count;
    },

    // ------------ 단가 수정 관련 메서드 ------------
    startEditingPrice(index) {
      const product = this.products_obj[index];
      product.isEditingPrice = true;

      // 기존 단가를 저장 (처음 수정할 때만)
      if (!product.originalPrice) {
        product.originalPrice = product.unitprice || this.getStoreUnitPrice(product);
      }

      this.$nextTick(() => {
        const input = this.priceInputs[index];
        if (input) {
          input.focus();
          input.select();
        }
      });
    },

    updatePrice(index, value) {
      const product = this.products_obj[index];
      if (!product) return;

      // 숫자만 입력 가능하도록
      const numericValue = value.replace(/[^0-9]/g, '');
      product.unitprice = parseInt(numericValue) || 0;
    },

    finishEditingPrice(index) {
      const product = this.products_obj[index];
      if (product) {
        product.isEditingPrice = false;
      }
    },

    // 기존 단가와 수정된 단가의 차이를 계산
    getTotalPriceDifference(product) {
      const originalPrice = product.originalPrice || this.getStoreUnitPrice(product);
      const currentPrice = product.unitprice || this.getStoreUnitPrice(product);
      return currentPrice - originalPrice;
    },

    // 가격 처리 =====================================================================
    getStoreUnitPrice(product) {
      // 단가가 직접 수정된 경우 해당 값 반환
      if (product.unitprice !== undefined && product.unitprice !== null) {
        return product.unitprice;
      }

      // 기존 로직 (차액 적용)
      const basePrice = product.selected_target === '대여' ? product.rentprice : product.buyprice;
      const marginValue = Number(product.margin) || 0;

      // 음수 부호가 있는지 확인
      const isNegative = String(product.margin).startsWith('-');
      // 절대값 계산
      const absMargin = Math.abs(marginValue);

      if (product.margin_type === 'p') {
        // 퍼센트 계산
        const percentageAmount = basePrice * (absMargin / 100);
        // 음수면 빼고, 양수면 더함
        return isNegative ? basePrice - percentageAmount : basePrice + percentageAmount;
      } else {
        // 금액 계산
        // 음수면 빼고, 양수면 더함
        return isNegative ? basePrice - absMargin : basePrice + absMargin;
      }
    },

    getSelectedStoreProducts() {
      const storeProducts = this.products_obj
        .map(product => ({
          name: product.b_product_id > 999999 ? product.name3 : product.name2,
          quantity: product.quantity,
          price: this.getStoreUnitPrice(product),
          selected_target: product.selected_target
        }));

      return storeProducts;
    },

    // ------------ 품목 선택 관련 메서드 ------------
    handleTargetSelection(target, productId) {
      // products_obj 배열에서 해당 제품을 찾아 selected_target 업데이트
      const product = this.products_obj.find(p => p.id === productId);
      if (product) {
        product.selected_target = target;

        // 단가도 함께 업데이트
        if (target === '대여') {
          product.unitprice = product.rentprice;
        } else if (target === '구입') {
          product.unitprice = product.buyprice;
        }
      }
    },

    // 이미지 처리 =====================================================================
    imageHandlingOnFileSelected(event) {
      const files = event.target.files;
      for (let i = 0; i < files.length; i++) {
        this.imageFiles.push(files[i]);
      }
    },
    imageHandlingGetImageUrl(file) {
      console.log(URL.createObjectURL(file));
      return URL.createObjectURL(file);
    },
    imageHandlingRemoveImage(index) {
      this.imageFiles.splice(index, 1);
    },

    // 댓글 처리 =====================================================================
    async deleteComment(num) {
      const response = await this.$axios.delete(`${this.$apiUrls.hanqmedi}/comment/${this.orderId}/${num}`);
      this.commmentGet();
    },

    async commentAdd() {
      // 댓글 내용이 비어있으면 처리하지 않음
      if (!this.orderCommentAdd || this.orderCommentAdd.trim() === '') {
        console.error('댓글 내용을 입력해주세요!');
        return;
      }

      const formData = new FormData();

      // 댓글 내용을 FormData에 추가 (text 필드명 사용)
      formData.append('text', this.orderCommentAdd);

      // 매니저 정보 추가 (백엔드에서 필요)
      formData.append('manager', this.$globalState.manager_name);

      // 이미지 파일들을 개별적으로 FormData에 추가
      if (this.imageFiles && this.imageFiles.length > 0) {
        this.imageFiles.forEach((file) => {
          formData.append('files', file, file.name);
        });
      }

      // FormData가 비어있는지 확인하는 로직 수정
      if (!formData.has('text') && (!this.imageFiles || this.imageFiles.length === 0)) {
        console.error('댓글 내용과 이미지가 모두 비어있습니다!');
        return;
      }

      const response = await this.$axios.post(`${this.$apiUrls.hanqmedi}/comment/${this.orderId}`, formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      this.orderCommentAdd = '';
      this.imageFiles = [];
      this.commmentGet();
    },

    async commmentGet() {
      this.isLoading = true;
      try {
        const response = await this.$axios.get(`${this.$apiUrls.hanqmedi}/comment/${this.orderId}`);
        this.orderComment = response.data.comment;
      } catch (error) {
        console.error('댓글을 불러오는 데 실패했습니다:', error);
        this.orderComment = [];
      }
    },

    // 반품 및 출고 처리 =====================================================================
    async returnRental() {
      await this.$axios.post(`${this.$apiUrls.hanqmedi}/returnRental`, {
        orderkey: this.orderId,
        companykey: this.$globalState.company_key
      }).then((res) => {
        console.log(res.data)
      })
    },
    async releaseRental() {
      await this.$axios.post(`${this.$apiUrls.hanqmedi}/releaseRental`, {
        orderkey: this.orderId,
        companykey: this.$globalState.company_key
      }).then((res) => {
        console.log(res.data)
      })
    },
    async releaseStock() {
      await this.$axios.post(`${this.$apiUrls.hanqmedi}/releaseStock`, {
        orderkey: this.orderId,
        companykey: this.$globalState.company_key
      }).then((res) => {
        console.log(res.data)
      })
    },
    async releaseStockCancel() {
      await this.$axios.post(`${this.$apiUrls.hanqmedi}/releaseStockCancel`, {
        orderkey: this.orderId,
        companykey: this.$globalState.company_key
      }).then((res) => {
        console.log(res.data)
        //this.returnRental();
      })
    },

    // 주문서 상태 변경 =====================================================================
    changeOrderStatus(status) {
      console.log(status, this.orderId)
      this.$axios.put(`${this.$apiUrls.hanqmedi}/orderStatus`, {
        status: status == 4 ? 2 : status,
        orderId: this.orderId,
        companykey: this.$globalState.company_key
      }).then(res => {
        console.log(res)
        if (status == 3) {
          this.releaseStock();
          //this.releaseRental();
        } else if (status == 4) {
          this.releaseStockCancel();
        }
        this.fetchOrderData();
      });
    },

    // 매장 주문품목 관련 =====================================================================
    selectAllStore() {
      this.products_obj.forEach(product => product.selected = true);
    },
    deselectAllStore() {
      this.products_obj.forEach(product => product.selected = false);
    },
    deleteSelectedStoreProducts() {
      // 선택되지 않은 제품만 필터링
      const remainingProducts = this.products_obj.filter(product => !product.selected);

      // products_obj 업데이트
      this.products_obj = remainingProducts;

      // products_obj도 함께 업데이트
      this.products_obj = [
        ...remainingProducts
      ];
    },
    // 매장 제품 선택 토글
    toggleStoreProductSelection(index) {
      const product = this.products_obj[index];
      if (product) {
        product.selected = !product.selected;
      }
    },
    handleStoreQuantityChange(index, newValue) {
      const product = this.products_obj[index];

      // 디버깅용 로그 추가
      console.log('handleStoreQuantityChange - product:', product);
      console.log('product.b_product_id:', product.b_product_id);
      console.log('product.b_product_id >= 100000:', product.b_product_id >= 100000);
      console.log('현재 배열 길이:', {
        barcodes: product.barcodes?.length,
        sizes: product.sizes?.length,
        colors: product.colors?.length,
        notes: product.options?.note?.length
      });

      // 비급여 품목(product.b_product_id가 100000 이상)인 경우 수량만 변경
      if (product.b_product_id >= 100000) {
        console.log('비급여 품목 처리 중...');
        const newQuantity = parseInt(newValue);
        product.quantity = newQuantity;

        // 비급여 품목의 경우 배열들을 항상 길이 1로 유지
        product.barcodes = [product.barcodes[0] || ''];
        product.sizes = [product.sizes[0] || ''];
        product.colors = [product.colors[0] || ''];
        product.options.note = [product.options.note[0] || ''];

        console.log('비급여 품목 배열 길이 (수정 후):', {
          barcodes: product.barcodes.length,
          sizes: product.sizes.length,
          colors: product.colors.length,
          notes: product.options.note.length
        });

        // 가격 업데이트
        const isRental = product.rental_id != null;
        const currentPrice = isRental ? product.rentprice : product.buyprice;

        if (isRental) {
          product.setRentprice = currentPrice * product.quantity;
        } else {
          product.setBuyprice = currentPrice * product.quantity;
        }

        // 전체 products_obj 배열을 새로 할당하여 반응성 트리거
        this.products_obj = [...this.products_obj];

        console.log('products_obj 업데이트 후:', this.products_obj.map(p => ({
          b_product_id: p.b_product_id,
          quantity: p.quantity,
          barcodes_length: p.barcodes?.length
        })));

        return; // 비급여 품목은 여기서 종료
      }

      // 급여 품목인 경우 기존 로직 실행
      const newQuantity = parseInt(newValue);
      product.quantity = newQuantity;

      const isRental = product.rental_id != null;
      const currentPrice = isRental ? product.rentprice : product.buyprice;

      // 새로운 배열들 생성
      const newBarcodes = [];
      const newSizes = [];
      const newColors = [];
      const newNotes = [];

      for (let i = 0; i < newQuantity; i++) {
        newBarcodes.push(i < product.barcodes.length ? product.barcodes[i] : (product.barcodes[product.barcodes.length - 1] || ''));
        newSizes.push(i < product.sizes.length ? product.sizes[i] : (product.sizes[product.sizes.length - 1] || ''));
        newColors.push(i < product.colors.length ? product.colors[i] : (product.colors[product.colors.length - 1] || ''));
        newNotes.push(i < product.options.note.length ? product.options.note[i] : (product.options.note[product.options.note.length - 1] || ''));
      }

      // 배열 교체
      product.barcodes = newBarcodes;
      product.sizes = newSizes;
      product.colors = newColors;
      product.options.note = newNotes;
      product.quantity = newQuantity;

      // 가격 업데이트
      if (isRental) {
        product.setRentprice = currentPrice * newQuantity;
      } else {
        product.setBuyprice = currentPrice * newQuantity;
      }

      // 전체 products_obj 배열을 새로 할당하여 반응성 트리거
      this.products_obj = [...this.products_obj];
    },
    increaseStoreQuantity(index) {
      const product = this.products_obj[index];
      if (!product) return;

      console.log('increaseStoreQuantity - product:', product);
      console.log('product.b_product_id:', product.b_product_id);
      console.log('product.b_product_id >= 100000:', product.b_product_id >= 100000);

      // 비급여 품목(product.b_product_id가 100000 이상)인 경우 수량만 증가
      if (product.b_product_id >= 100000) {
        console.log('비급여 품목 수량 증가 중...');
        product.quantity++;

        // 비급여 품목의 경우 배열들을 항상 길이 1로 유지
        product.barcodes = [product.barcodes[0] || ''];
        product.sizes = [product.sizes[0] || ''];
        product.colors = [product.colors[0] || ''];
        product.options.note = [product.options.note[0] || ''];

        console.log('비급여 품목 배열 길이:', {
          barcodes: product.barcodes.length,
          sizes: product.sizes.length,
          colors: product.colors.length,
          notes: product.options.note.length
        });

        // 가격 업데이트
        const isRental = product.rental_id != null;
        const currentPrice = isRental ? product.rentprice : product.buyprice;

        if (isRental) {
          product.setRentprice = currentPrice * product.quantity;
        } else {
          product.setBuyprice = currentPrice * product.quantity;
        }
        return; // 비급여 품목은 여기서 종료
      }

      // 급여 품목인 경우 기존 로직 실행
      const isRental = product.rental_id != null;
      const currentPrice = isRental ? product.rentprice : product.buyprice;

      product.quantity++;

      // 가격 업데이트
      if (isRental) {
        product.setRentprice = currentPrice * product.quantity;
      } else {
        product.setBuyprice = currentPrice * product.quantity;
      }

      // 새로운 항목 추가
      product.barcodes.push(product.barcodes[product.quantity - 2] || '');
      product.sizes.push(product.sizes[product.quantity - 2] || '');
      product.colors.push(product.colors[product.quantity - 2] || '');
      product.options.note.push('');
    },
    decreaseStoreQuantity(index) {
      const product = this.products_obj[index];
      if (!product) return;

      console.log('decreaseStoreQuantity - product:', product);
      console.log('product.b_product_id:', product.b_product_id);
      console.log('product.b_product_id >= 100000:', product.b_product_id >= 100000);

      // 비급여 품목(product.b_product_id가 100000 이상)인 경우 수량만 감소
      if (product.b_product_id >= 100000) {
        console.log('비급여 품목 수량 감소 중...');
        product.quantity--;

        // 비급여 품목의 경우 배열들을 항상 길이 1로 유지
        product.barcodes = [product.barcodes[0] || ''];
        product.sizes = [product.sizes[0] || ''];
        product.colors = [product.colors[0] || ''];
        product.options.note = [product.options.note[0] || ''];

        console.log('비급여 품목 배열 길이:', {
          barcodes: product.barcodes.length,
          sizes: product.sizes.length,
          colors: product.colors.length,
          notes: product.options.note.length
        });

        // 가격 업데이트
        const isRental = product.rental_id != null;
        const currentPrice = isRental ? product.rentprice : product.buyprice;

        if (isRental) {
          product.setRentprice = currentPrice * product.quantity;
        } else {
          product.setBuyprice = currentPrice * product.quantity;
        }
        return; // 비급여 품목은 여기서 종료
      }

      // 급여 품목인 경우 기존 로직 실행
      const isRental = product.rental_id != null;
      const currentPrice = isRental ? product.rentprice : product.buyprice;

      product.quantity--;

      // 가격 업데이트
      if (isRental) {
        product.setRentprice = currentPrice * product.quantity;
      } else {
        product.setBuyprice = currentPrice * product.quantity;
      }

      // 마지막 항목 제거
      product.barcodes.pop();
      product.sizes.pop();
      product.colors.pop();
      product.options.note.pop();
    },

    // 낱개수량 관련 메서드 ==========================================================
    handleStoreQuantityPieceChange(index, newValue) {
      const newQuantityPiece = parseInt(newValue) || 1;
      if (newQuantityPiece < 1) {
        this.products_obj[index].piece_quantity = 0;
        return;
      }

      const product = this.products_obj[index];
      product.piece_quantity = newQuantityPiece;
    },

    increaseStoreQuantityPiece(index) {
      const product = this.products_obj[index];
      if (!product) return;

      product.piece_quantity = (product.piece_quantity || 0) + 1;
    },

    decreaseStoreQuantityPiece(index) {
      const product = this.products_obj[index];
      if (!product || (product.piece_quantity || 0) <= 0) return;

      product.piece_quantity = Math.max(0, (product.piece_quantity || 0) - 1);
    },

    // 반품 주문 =====================================================================
    async submitReturnOrder(selectedProducts, returnNote = '', returnType = '0') {
      try {
        // 반품 상태 확인
        const checkResponse = await this.$axios.post(`${this.$apiUrls.hanqmedi}/checkReturnStatus`, {
          products: selectedProducts.map(product => ({
            code: product.code,
            b_product_id: product.b_product_id
          })),
          order_id: this.orderId
        });

        // 이미 반품 접수된 품목이 있는지 확인
        if (checkResponse.data.hasExistingReturn) {
          const existingProducts = checkResponse.data.existingProducts;
          await this.$swal.fire({
            title: '이미 접수된 품목 존재',
            html: `다음 품목은 이미 반품 접수되었습니다:<br>${existingProducts.join('<br>')}`,
            icon: 'warning',
            confirmButtonText: '확인'
          });
          return;
        }

        // 새로운 반품 주문서 생성 (updateOrderWithReturns 호출 제거)
        const returnOrderData = {
          // 원본 주문서 ID
          original_order_id: this.orderId,

          // 반품 관련 정보
          return_date: new Date().toISOString().split('T')[0],
          return_status: 0, // 접수
          return_type: parseInt(returnType),
          return_request_note: returnNote || '반품 요청',

          // 원본 주문서의 모든 정보 (수급자 정보 포함)
          order_info: {
            orderdate: this.orderDate,
            name: this.client_data_obj.name,
            number: this.client_data_obj.number,
            resident: this.client_data_obj.regident,
            addressnum: this.postcode_obj.postcode1,
            address: this.postcode_obj.address1,
            addressdetail: this.postcode_obj.detailAddress1,
            addressnum2: this.postcode_obj.postcode2,
            address2: this.postcode_obj.address2,
            address2detail: this.postcode_obj.detailAddress2,
            guardname: this.client_data_obj.guardname,
            guardtarget: this.client_data_obj.guardtarget,
            phone1: this.client_data_obj.phone1,
            phone2: this.client_data_obj.phone2,
            centername: this.client_data_obj.centername,
            manager: this.client_data_obj.manager,
            oxygen_type: this.client_data_obj.oxygen_type,
            rental_start: this.client_data_obj.rental_start,
            rental_end: this.client_data_obj.rental_end,
            oxygen_start: this.client_data_obj.oxygen_start,
            oxygen_end: this.client_data_obj.oxygen_end,
            diabetes_start: this.client_data_obj.diabetes_start,
            diabetes_end: this.client_data_obj.diabetes_end,
            delivery_method: this.deliveryMethod,
            delivery_status: this.deliveryStatus,
            delivery_date: this.delivery_date,
            delivery_time: this.delivery_time,
            status: 1 // 활성 상태
          },

          // 선택된 반품 품목만 포함 (음수 수량으로 표시)
          return_products: selectedProducts.map(product => {
            const productId = product.b_product_id ||
              product.product_id ||
              product.num ||
              product.id;

            return {
              id: productId,
              code: product.code,
              name: product.name || product.name1,
              name1: product.name1,
              name2: product.name2 || product.name3,
              name3: product.name3,
              name4: product.name4,
              quantity: -(product.quantity || 1), // 음수로 표시
              piece_quantity: product.piece_quantity || 0,
              buyprice: product.buyprice || 0,
              rentprice: product.rentprice || 0,
              margin: product.margin || 0,
              margin_type: product.margin_type || 'a',
              selected_target: product.selected_target || '구입',
              options: {
                size: product.sizes || [],
                color: product.colors || [],
                bcode: product.barcodes || [],
                note: product.notes || []
              },
              icode: product.icode || '',
              location: product.location || '',
              stock_quantity: product.stock_quantity || 0,
              isSetItem: product.isSetItem || false,
              set_name: product.set_name,
              set_items: product.set_items,
              product_set_id: product.product_set_id,
              set_item_id: product.set_item_id
            };
          })
        };

        // 새로운 반품 주문서 생성 API 호출
        const response = await this.$axios.post(`${this.$apiUrls.hanqmedi}/registerReturnOrders`, returnOrderData);

        if (response.data.success) {
          await this.$swal.fire({
            title: '반품 등록 성공',
            text: `반품 처리가 완료되었습니다.`,
            icon: 'success',
            confirmButtonText: '확인'
          });

          // 주문 데이터 새로고침
          await this.fetchOrderData();

          this.$emit('close-return-modal');
        } else {
          throw new Error(response.data.message || '반품 등록 처리 중 오류가 발생했습니다.');
        }
      } catch (error) {
        console.error('반품 등록 제출 중 오류:', error);

        if (error.response) {
          console.error('에러 응답:', error.response.data);
        }

        let errorMessage = '반품 등록 처리 중 오류가 발생했습니다.';

        if (error.response) {
          const statusCode = error.response.status;
          switch (statusCode) {
            case 400:
              errorMessage = error.response.data.message || '잘못된 요청입니다.';
              break;
            case 404:
              errorMessage = '원본 주문서를 찾을 수 없습니다.';
              break;
            case 409:
              errorMessage = error.response.data.message || '이미 반품 접수된 주문서입니다.';
              break;
            case 500:
              errorMessage = '서버 처리 중 오류가 발생했습니다.';
              break;
            default:
              errorMessage = error.response.data?.message || '알 수 없는 오류가 발생했습니다.';
          }
        }

        this.$swal.fire({
          title: '반품 등록 실패',
          text: errorMessage,
          icon: 'error',
          confirmButtonText: '확인'
        });
      }
    },

    // AS 등록 =====================================================================
    async submitAsOrder(asData) {
      try {
        // 선택된 품목들의 AS 상태 확인
        const asCheckResponse = await this.$axios.post(`${this.$apiUrls.hanqmedi}/checkAsStatus`, {
          products: asData.products,
          order_id: this.orderId
        });

        // 이미 AS 접수된 품목이 있는지 확인
        if (asCheckResponse.data.hasExistingAs) {
          const existingProducts = asCheckResponse.data.existingProducts;
          await this.$swal.fire({
            icon: 'warning',
            title: '이미 접수된 품목 존재',
            html: `다음 품목은 이미 AS 접수되었습니다:<br>${existingProducts.join('<br>')}`,
            showConfirmButton: true
          });
          return;
        }

        // AS 등록 요청
        const response = await this.$axios.post(`${this.$apiUrls.hanqmedi}/registerAsOrders`, {
          order_id: this.orderId,
          as_start_date: asData.asDate,
          as_request_note: asData.request,
          products: asData.products
        });

        if (response.data.success) {
          await this.$swal.fire({
            icon: 'success',
            title: 'A/S 접수 완료',
            text: 'A/S 접수가 완료되었습니다.',
            showConfirmButton: true,
          });

          // 주문 데이터 새로고침 (기존 메서드 활용)
          await this.fetchOrderData();

          // A/S 탭이 활성화된 경우 A/S 전용 닫기 이벤트 사용
          if (this.parent === 'order' && this.activeStatus === 6) {
            this.$emit('close-as-modal');
          } else {
            // 일반적인 경우 기존 closeModal 이벤트 사용
            this.$emit('close-modal');
          }

        } else {
          let icon = 'warning';
          if (response.data.statusCode >= 500) {
            icon = 'error';
          }

          await this.$swal.fire({
            icon: icon,
            title: 'A/S 접수 실패',
            text: response.data.message,
            showConfirmButton: true
          });
        }
      } catch (error) {
        console.error('AS 등록 실패:', error);
        let errorMessage = '서버 통신 중 오류가 발생했습니다.';
        let statusCode = error.response?.status || 500;

        switch (statusCode) {
          case 400:
            errorMessage = '잘못된 요청입니다. 입력 정보를 확인해주세요.';
            break;
          case 404:
            errorMessage = '주문서를 찾을 수 없습니다.';
            break;
          case 409:
            errorMessage = error.response.data.message || '이미 AS 접수된 주문서입니다.';
            break;
          case 500:
            errorMessage = '서버 처리 중 오류가 발생했습니다.';
            break;
          default:
            errorMessage = error.response?.data?.message || '알 수 없는 오류가 발생했습니다.';
        }

        await this.$swal.fire({
          icon: 'error',
          title: 'A/S 접수 실패',
          text: errorMessage,
          showConfirmButton: true
        });
      }
    },

    // 선택된 제품 정보 조회 =====================================================================
    getSelectedProducts() {
      const asValue = [];
      const checkboxElements = this.asPopupInstance.$el.querySelectorAll('.as-checkbox');
      const productCodeElements = this.asPopupInstance.$el.querySelectorAll('.as-product-code');
      const barcodeElements = this.asPopupInstance.$el.querySelectorAll('.as-barcode');
      const productElements = this.asPopupInstance.$el.querySelectorAll('.as-product');
      const productNameElements = this.asPopupInstance.$el.querySelectorAll('.as-product-name');

      for (let i = 0; i < checkboxElements.length; i++) {
        if (checkboxElements[i].checked) {
          asValue.push({
            productCode: productCodeElements[i].textContent,
            barcode: barcodeElements[i].textContent,
            product: productElements[i].textContent,
            productName: productNameElements[i].textContent,
          });
        }
      }

      return asValue;
    },

    // A/S 주문 조회 메서드 추가 (새로 추가)
    async fetchAsOrders() {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const currentCompanyKey = userInfo?.company_key || this.$globalState.company_key;

        const response = await this.$axios.get(`${this.$apiUrls.hanqmedi}/getAsOrders`, {
          params: {
            asSearch: '',
            startDate: this.formatDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1)),
            endDate: this.formatDate(new Date()),
            companykey: currentCompanyKey
          }
        });

        if (response.data.success) {
          // A/S 주문 데이터를 컴포넌트에 저장
          this.asOrders = response.data.data || [];

          // 부모 컴포넌트에 A/S 주문 데이터 업데이트 이벤트 전달
          this.$emit('as-orders-updated', this.asOrders);
        }
      } catch (error) {
        console.error('A/S 주문 조회 실패:', error);
      }
    },

    // 주문서 상세 조회 =====================================================================
    async fetchOrderData() {
      try {
        let actualOrderId = this.orderId;
        this.isReturnOrder = false;
        this.isAsOrder = false;
        let returnOrderData = null;
        let asOrderData = null;

        // orderId가 없으면 부모 컴포넌트에서 데이터를 가져와서 처리
        if (!actualOrderId) {
          try {
            const userInfo = JSON.parse(localStorage.getItem('userInfo'));
            const currentCompanyKey = userInfo?.company_key || this.$globalState.company_key;

            // A/S 주문 조회
            const asResponse = await this.$axios.get(`${this.$apiUrls.hanqmedi}/getAsOrders`, {
              params: {
                asSearch: '',
                startDate: this.formatDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1)),
                endDate: this.formatDate(new Date()),
                companykey: currentCompanyKey
              }
            });

            if (asResponse.data.success && asResponse.data.data && asResponse.data.data.length > 0) {
              // 가장 최근 A/S 주문을 사용
              const asOrder = asResponse.data.data[0];
              actualOrderId = asOrder.order_id;
              this.isAsOrder = true;
              this.asOrderNum = asOrder.as_id;
              this.asOrderId = asOrder.as_order_id;
              this.asStatus = parseInt(asOrder.as_status) || 0;
              asOrderData = asOrder;
            } else {
              // 반품 주문 조회
              const returnResponse = await this.$axios.get(`${this.$apiUrls.hanqmedi}/getReturnOrders`, {
                params: {
                  returnSearch: '',
                  startDate: this.formatDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1)),
                  endDate: this.formatDate(new Date()),
                  companykey: currentCompanyKey
                }
              });

              if (returnResponse.data.success && returnResponse.data.data && returnResponse.data.data.length > 0) {
                // 가장 최근 반품 주문을 사용
                const returnOrder = returnResponse.data.data[0];
                actualOrderId = returnOrder.original_order_id;
                this.isReturnOrder = true;
                this.returnOrderNum = returnOrder.return_id;
                this.returnOrderId = returnOrder.return_order_id;
                returnOrderData = returnOrder;
              } else {
                // 일반 주문 조회
                const orderResponse = await this.$axios.get(`${this.$apiUrls.hanqmedi}/orders`, {
                  params: {
                    search: '',
                    startDate: this.formatDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1)),
                    endDate: this.formatDate(new Date()),
                    companykey: currentCompanyKey,
                    page: 1,
                    contentsSize: 1
                  }
                });

                if (orderResponse.data.success && orderResponse.data.data && orderResponse.data.data.length > 0) {
                  // 가장 최근 일반 주문을 사용
                  const order = orderResponse.data.data[0];
                  actualOrderId = order.num;
                } else {
                  throw new Error('사용 가능한 주문서가 없습니다.');
                }
              }
            }
          } catch (error) {
            throw new Error('주문서 ID가 유효하지 않습니다.');
          }
        } else {
          // 기존 로직 (orderId가 있는 경우)
          try {
            const userInfo = JSON.parse(localStorage.getItem('userInfo'));
            const currentCompanyKey = userInfo?.company_key || this.$globalState.company_key;

            // 반품 주문인지 확인
            const returnResponse = await this.$axios.get(`${this.$apiUrls.hanqmedi}/getReturnOrders`, {
              params: {
                returnSearch: '',
                startDate: this.formatDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1)),
                endDate: this.formatDate(new Date()),
                companykey: currentCompanyKey
              }
            });

            if (returnResponse.data.success && returnResponse.data.data) {
              const returnOrder = returnResponse.data.data.find(item =>
                item.return_order_id === parseInt(this.orderId) ||
                item.return_id === parseInt(this.orderId)
              );

              if (returnOrder) {
                actualOrderId = returnOrder.original_order_id;
                this.isReturnOrder = true;
                this.returnOrderNum = returnOrder.return_id;
                this.returnOrderId = returnOrder.return_order_id;
                returnOrderData = returnOrder;
              }
            }

            // A/S 주문인지 확인
            const asResponse = await this.$axios.get(`${this.$apiUrls.hanqmedi}/getAsOrders`, {
              params: {
                asSearch: '',
                startDate: this.formatDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1)),
                endDate: this.formatDate(new Date()),
                companykey: currentCompanyKey
              }
            });

            if (asResponse.data.success && asResponse.data.data) {
              const asOrder = asResponse.data.data.find(item =>
                item.as_order_id === parseInt(this.orderId) ||
                item.as_id === parseInt(this.orderId)
              );

              if (asOrder) {
                actualOrderId = asOrder.order_id;
                this.isAsOrder = true;
                this.asOrderNum = asOrder.as_id;
                this.asOrderId = asOrder.as_order_id;
                this.asStatus = parseInt(asOrder.as_status) || 0;
                asOrderData = asOrder;
              }
            }

          } catch (error) {
            console.error('주문 타입 확인 실패:', error);
          }
        }

        this.actualOrderId = actualOrderId;

        // 주문서 상세 조회 API 호출
        if (!this.actualOrderId) {
          throw new Error('주문서 ID가 유효하지 않습니다.');
        }

        const response = await this.$axios.get(`${this.$apiUrls.hanqmedi}/orderDetail/${this.actualOrderId}`);
        const orderData = response.data;

        // orderDate를 DB에서 가져온 데이터로 설정
        this.orderDate = orderData.order.orderdate ? new Date(orderData.order.orderdate) : null;

        // A/S 주문인 경우 A/S 주문서의 품목을 orderData에 덮어쓰기
        if (this.isAsOrder && asOrderData && asOrderData.products) {
          const mappedProducts = asOrderData.products.map(product => ({
            ...product,
            // 품목명 필드 매핑
            name: product.name0 || product.name2 || product.product_name || '',
            name1: product.name1 || '',
            name2: product.name2 || product.product_name || '',
            name3: product.name3 || '',
            name4: product.name4 || '',
            // 기타 필드
            code: product.code || '',
            company: product.company || '',
            icode: product.icode || '',
            location: product.location || '',
            target: product.target || '구입 또는 대여',
            stock_quantity: product.stock_quantity || 0,
            // 가격 정보
            buyprice: product.buyprice || product.default_buyprice || 0,
            rentprice: product.rentprice || product.default_rentprice || 0,
            supplyprice: product.supplyprice || 0,
            // 옵션 정보 (빈 배열로 초기화)
            options: {
              size: [],
              color: [],
              bcode: [],
              note: []
            }
          }));

          orderData.products = mappedProducts;
        }

        // 반품 주문서인 경우 반품 상태 설정
        if (this.isReturnOrder && returnOrderData) {
          if (this.returnStatus === null || this.returnStatus === undefined) {
            this.returnStatus = parseInt(returnOrderData.return_status) || 0;
          }
        } else if (orderData.order) {
          this.returnStatus = orderData.order.status;
        }

        this.initializeClientData(orderData);
        await this.fetchVirtualAccountHistory();

      } catch (error) {
        console.error('주문 데이터를 가져오는 중 오류가 발생했습니다:', error);
      }
    },

    // 반품 주문 조회 함수
    async fetchReturnOrders() {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const currentCompanyKey = userInfo?.company_key || this.$globalState.company_key;

        const response = await this.$axios.get(`${this.$apiUrls.hanqmedi}/getReturnOrders`, {
          params: {
            returnSearch: this.searchQuery,
            startDate: this.formatDate(this.startDate),
            endDate: this.formatDate(this.endDate),
            companykey: currentCompanyKey
          }
        });

        console.log('반품 주문 응답:', response.data);
        if (response.data.success) {
          this.returnItems = response.data.data.map(item => ({
            ...item,
            selected: false,
            // 템플릿에서 사용하는 필드명으로 매핑
            return_start_date: item.return_date,
            order_name: item.return_order_name || item.original_order_name,
            phone1: item.phone1,
            phone2: item.phone2,
            b_name3: item.product_name,
            name2: item.product_name,
            total_quantity: item.total_quantity,
            manager: item.manager,
            comment: item.memo,
            return_request_note: item.return_request_note,
            return_status: item.return_status,
            return_type: item.return_type,
            returnOrderId: item.return_order_id,
            returnTableNum: item.return_id,
            // 원본 주문서 정보
            original_order_id: item.original_order_id,
            original_order_date: item.original_order_date,
            original_order_name: item.original_order_name
          }));
        } else {
          this.returnItems = [];
        }
        this.saveState();
      } catch (error) {
        this.returnItems = [];
        console.error('반품 주문 데이터를 가져오는 중 오류가 발생했습니다:', error);
      }
    },

    // 수급자 상세 처리 =====================================================================
    handleClientDetail(client) {
      this.postcode_obj.postcode1 = client.addressnum;
      this.postcode_obj.address1 = client.address;
      this.postcode_obj.detailAddress1 = client.addressdetail;

      this.client_data_obj.address = client.address;

      for (const key in client) {
        if (Object.hasOwnProperty.call(client, key)) {
          const data = client[key];
          this.client_data_obj[key] = data;
        }
      }
    },

    // 거래처 상세 처리 =====================================================================
    handleCompanyDetail(company) {
      if (company && company.company) {
        this.client_data_obj.centername = company.company;
        this.client_data_obj.phone2 = company.phone2;
        this.postcode_obj.postcode2 = company.addressnum2;
        this.postcode_obj.address2 = company.address2;
        this.postcode_obj.detailAddress2 = company.address2detail;

        this.client_data_obj.address = company.address2;

        this.$swal.fire({
          title: '거래처 설정 완료',
          text: `센터명이 "${company.company}"(으)로 설정되었습니다.`,
          icon: 'success',
          timer: 1500,
          showConfirmButton: false
        });
      }
      this.showModal_obj.company_up = false;
    },

    // 제품 상세 처리 =====================================================================
    handleProductDetail(product) {
      console.log('OrderModifyPage - 전달받은 데이터:', product);

      if (!product) {
        console.error('제품 데이터가 없습니다.');
        return;
      }

      try {
        // 가격을 숫자로 변환하여 저장
        const buyPrice = parseFloat(product.buyprice) || 0;
        const rentPrice = parseFloat(product.rentprice) || 0;
        const supplyPrice = parseFloat(product.supplyprice || product.price3 || 0);

        const newProduct = {
          ...product,
          quantity: 1,
          piece_quantity: product.piece_quantity,
          barcodes: [product.bcode || ''],
          options: {
            bcode: [product.bcode || ''],
            color: [product.color || ''],
            size: [product.size || ''],
            note: ['']
          },
          margin: product.margin || 0,
          margin_type: product.margin_type || 'a',
          selected: false,
          selected_target: product.selected_target || product.target,
          buyprice: buyPrice,
          rentprice: rentPrice,
          supplyprice: supplyPrice,
          // 급여 품목분류 필드 명시적으로 설정
          pitem: product.pitem || '',
          pname: product.pname || '',
          pcode: product.pcode || '',
        };

        // 색상과 사이즈 옵션 안전하게 처리
        let colorOptions = [];
        let sizeOptions = [];

        if (product.color && typeof product.color === 'string') {
          colorOptions = product.color.split(',').filter(Boolean);
        }
        if (product.size && typeof product.size === 'string') {
          sizeOptions = product.size.split(',').filter(Boolean);
        }

        // products_obj 배열 확인
        if (!Array.isArray(this.products_obj)) {
          this.products_obj = [];
        }

        // 동일 제품 확인
        const existingProductIndex = this.products_obj.findIndex(p => {
          // 기본적인 제품 코드 비교
          const isSameProduct = p && p.code === product.code;

          // 이름 관련 필드들 비교
          const isSameName0 = p.name0 === product.name0;
          const isSameName1 = p.name1 === product.name1;
          const isSameName2 = p.name2 === product.name2;
          const isSameName3 = p.name3 === product.name3;
          const isSameName4 = p.name4 === product.name4;

          // 바코드, 사이즈, 컬러 비교
          const isSameBcode = p.bcode === product.bcode;
          const isSameSize = p.size === product.size;
          const isSameColor = p.color === product.color;

          // 산소발생기인 경우 더 엄격한 비교
          if (product.name1 === '산소발생기') {
            return isSameProduct &&
              isSameName1 &&
              isSameName2 &&
              isSameName3 &&
              isSameName4 &&
              isSameBcode;
          }

          // 일반 제품의 경우 모든 필드 비교
          return isSameProduct &&
            isSameName0 &&
            isSameName1 &&
            isSameName2 &&
            isSameName3 &&
            isSameName4 &&
            isSameBcode &&
            isSameSize &&
            isSameColor;
        });

        if (existingProductIndex !== -1) {
          // 동일한 제품이 존재하는 경우
          const existingProduct = this.products_obj[existingProductIndex];

          // 가격을 숫자로 변환 (추가됨)
          if (typeof existingProduct.buyprice === 'string') {
            existingProduct.buyprice = parseFloat(existingProduct.buyprice) || 0;
          }
          if (typeof existingProduct.rentprice === 'string') {
            existingProduct.rentprice = parseFloat(existingProduct.rentprice) || 0;
          }

          // products_obj 배열에서도 해당 제품 찾기
          let targetArray = this.products_obj;
          const targetIndex = targetArray.findIndex(p => p.code === existingProduct.code);

          // 현재 추가하려는 사이즈와 컬러 조합이 이미 존재하는지 확인
          const hasSameCombination = existingProduct.sizes.some((size, index) =>
            size === (product.size || '') && existingProduct.colors[index] === (product.color || '')
          );

          if (hasSameCombination) {
            // 동일한 사이즈/컬러 조합이 있는 경우
            const combinationIndex = existingProduct.sizes.findIndex((size, index) =>
              size === (product.size || '') && existingProduct.colors[index] === (product.color || '')
            );

            // 수량과 이전 수량 기록 (추가됨)
            existingProduct.quantity++;

            if (targetIndex !== -1) {
              targetArray[targetIndex].quantity = existingProduct.quantity;
            }

            // 기존 조합의 배열에 새로운 항목 추가
            existingProduct.barcodes.push(existingProduct.barcodes[combinationIndex] || '');
            existingProduct.notes.push(existingProduct.notes[combinationIndex] || '');
            existingProduct.colors.push(existingProduct.colors[combinationIndex] || '');
            existingProduct.sizes.push(existingProduct.sizes[combinationIndex] || '');

            // options 객체도 동일하게 업데이트
            if (!existingProduct.options) {
              existingProduct.options = {
                bcode: [...existingProduct.barcodes],
                color: [...existingProduct.colors],
                size: [...existingProduct.sizes],
                note: [...existingProduct.notes]
              };
            } else {
              existingProduct.options.bcode.push(existingProduct.options.bcode[combinationIndex] || '');
              existingProduct.options.color.push(existingProduct.options.color[combinationIndex] || '');
              existingProduct.options.size.push(existingProduct.options.size[combinationIndex] || '');
              existingProduct.options.note.push(existingProduct.options.note[combinationIndex] || '');
            }

            // 가격 업데이트 - 숫자 연산 보장 (수정됨)
            if (existingProduct.selected_target === '대여') {
              existingProduct.setRentprice = parseFloat(existingProduct.rentprice) * existingProduct.quantity;
            } else {
              existingProduct.setBuyprice = parseFloat(existingProduct.buyprice) * existingProduct.quantity;
              existingProduct.setUnitprice = parseFloat(existingProduct.buyprice) * existingProduct.quantity;
            }

            // targetArray의 해당 제품도 업데이트
            if (targetIndex !== -1) {
              targetArray[targetIndex] = { ...existingProduct };
            }
          } else {
            // 새로운 사이즈/컬러 조합 추가
            existingProduct.quantity++;

            if (targetIndex !== -1) {
              targetArray[targetIndex].quantity = existingProduct.quantity;
            }

            const newSize = product.size || '';
            const newColor = product.color || '';

            // 새로운 조합 추가
            existingProduct.barcodes.push(product.bcode || '');
            existingProduct.notes.push('');
            existingProduct.colors.push(newColor);
            existingProduct.sizes.push(newSize);

            // options 객체 업데이트
            if (!existingProduct.options) {
              existingProduct.options = {
                bcode: [...existingProduct.barcodes],
                color: [...existingProduct.colors],
                size: [...existingProduct.sizes],
                note: [...existingProduct.notes]
              };
            } else {
              existingProduct.options.bcode.push(product.bcode || '');
              existingProduct.options.color.push(newColor);
              existingProduct.options.size.push(newSize);
              existingProduct.options.note.push('');
            }

            // colorOptions와 sizeOptions 업데이트
            if (newColor && !existingProduct.colorOptions.includes(newColor)) {
              existingProduct.colorOptions.push(newColor);
            }
            if (newSize && !existingProduct.sizeOptions.includes(newSize)) {
              existingProduct.sizeOptions.push(newSize);
            }

            // 가격 업데이트 - 숫자 연산 보장 (수정됨)
            if (existingProduct.selected_target === '대여') {
              existingProduct.setRentprice = parseFloat(existingProduct.rentprice) * existingProduct.quantity;
            } else {
              existingProduct.setBuyprice = parseFloat(existingProduct.buyprice) * existingProduct.quantity;
              existingProduct.setUnitprice = parseFloat(existingProduct.buyprice) * existingProduct.quantity;
            }

            // targetArray의 해당 제품도 업데이트
            if (targetIndex !== -1) {
              targetArray[targetIndex] = { ...existingProduct };
            }
          }
        } else {
          // 새로운 제품 추가
          newProduct.quantity = 1;
          newProduct.barcodes = [product.bcode || ''];  // 바코드 배열 초기화

          // options 객체 안전하게 초기화
          newProduct.options = {
            bcode: [product.bcode || ''],
            color: colorOptions.length > 0 ? [colorOptions[0]] : [''],
            size: sizeOptions.length > 0 ? [sizeOptions[0]] : [''],
            note: ['']
          };

          // 기타 배열 초기화
          newProduct.colorOptions = colorOptions;
          newProduct.sizeOptions = sizeOptions;
          newProduct.selected = false;
          newProduct.colors = colorOptions.length > 0 ? [colorOptions[0]] : [''];
          newProduct.sizes = sizeOptions.length > 0 ? [sizeOptions[0]] : [''];
          newProduct.notes = [''];

          // 가격 설정 - 숫자로 변환하여 처리
          if (product.num > 999999) {
            newProduct.baseBuyPrice = parseFloat(product.buyprice || product.price || 0);
            newProduct.baseRentPrice = parseFloat(product.rentprice || product.price2 || 0);
            newProduct.supplyprice = parseFloat(product.supplyprice || product.price3 || 0);
            newProduct.setBuyprice = product.target === '대여' || product.selected_target === '대여' ? 0 : parseFloat(product.buyprice) || 0;
            newProduct.setRentprice = product.target === '대여' || product.selected_target === '대여' ? parseFloat(product.rentprice) || 0 : 0;
            newProduct.name = product.name || '';
            newProduct.name0 = product.name0 || '';
            newProduct.name1 = product.name1 || '';
            newProduct.name2 = product.name2 || '';
            newProduct.name3 = product.name3 || '';
            newProduct.name4 = product.name4 || '';
            newProduct.b_product_id = product.num;
          } else {
            newProduct.baseBuyPrice = parseFloat(product.buyprice || product.price || 0);
            newProduct.baseRentPrice = parseFloat(product.rentprice || product.price2 || 0);
            newProduct.supplyprice = parseFloat(product.supplyprice || product.price3 || 0);
            newProduct.setBuyprice = product.target === '대여' || product.selected_target === '대여' ? 0 : parseFloat(product.buyprice) || 0;
            newProduct.setRentprice = product.target === '대여' || product.selected_target === '대여' ? parseFloat(product.rentprice) || 0 : 0;
            newProduct.name = product.name || '';
            newProduct.name1 = '';
            newProduct.name2 = product.name2 || '';
            newProduct.name3 = '';
            newProduct.name4 = '';
            newProduct.b_product_id = product.num;
          }

          // 제조사 제품인지 매장 제품인지에 따라 배열에 추가
          this.products_obj.push(newProduct);
        }
      } catch (error) {
        console.error('제품 처리 중 오류 발생:', error);
        this.$swal.fire({
          title: '오류',
          text: '제품 추가 중 오류가 발생했습니다.',
          icon: 'error',
          confirmButtonText: '확인'
        });
      }
    },

    // 주문서 수정 =====================================================================
    async submitOrder() {
      try {
        const products = this.products_obj.map(product => {
          const selected_target = product.selected_target || product.target;
          const isRental = selected_target === '대여';

          // 단가 직접 수정된 경우 해당 값 사용, 아니면 기본 가격 사용
          const finalPrice = product.unitprice !== undefined ? product.unitprice :
            (isRental ? product.rentprice : product.buyprice);

          // 세트 품목인지 확인
          const isSetItem = product.product_set_id ? true : false;

          // 급여 품목인지 확인 (pitem, pname, pcode가 있는 경우)
          const isBenefitItem = product.pitem && product.pname && product.pcode;

          const productData = {
            // 급여 품목인 경우 id를 product_id로 설정, 아니면 기존 로직 사용
            id: isBenefitItem ? product.id : (product.product_id || product.b_product_id || product.num),
            buyprice: isRental ? 0 : finalPrice,
            rentprice: isRental ? finalPrice : 0,
            quantity: product.quantity,
            piece_quantity: product.piece_quantity,
            selected_target,
            options: {
              size: product.sizes,
              color: product.colors,
              note: product.options.note,
              bcode: product.barcodes,
              icode: product.options.icode
            }
          };

          // 급여 품목인 경우 추가 정보 포함
          if (isBenefitItem) {
            productData.pitem = product.pitem;
            productData.pname = product.pname;
            productData.pcode = product.pcode;
          }

          // 세트 품목인 경우 추가 정보 포함
          if (isSetItem) {
            productData.isSetItem = true;
            productData.product_set_id = product.product_set_id;
            productData.set_item_id = product.set_item_id;
            productData.set_name = product.set_name;
          }

          return productData;
        });

        const orderData = {
          orderdate: this.orderDate,
          name: this.client_data_obj.name,
          number: this.client_data_obj.number,
          resident: this.client_data_obj.regident,
          addressnum: this.postcode_obj.postcode1,
          address: this.postcode_obj.address1,
          addressdetail: this.postcode_obj.detailAddress1,
          addressnum2: this.postcode_obj.postcode2,
          address2: this.postcode_obj.address2,
          address2detail: this.postcode_obj.detailAddress2,
          email: this.client_data_obj.email,
          guardname: this.client_data_obj.guardname,
          guardtarget: this.client_data_obj.guardtarget,
          phone1: this.client_data_obj.phone1 ? this.client_data_obj.phone1.replace(/-/g, '') : '',
          phone2: this.client_data_obj.phone2 ? this.client_data_obj.phone2.replace(/-/g, '') : '',
          centername: this.client_data_obj.centername,
          manager: this.client_data_obj.manager,
          oxygen_type: this.client_data_obj.oxygen_type,
          rental_start: this.format.date(this.client_data_obj.rental_start),
          rental_end: this.format.date(this.client_data_obj.rental_end),
          oxygen_start: this.format.date(this.client_data_obj.oxygen_start),
          oxygen_end: this.format.date(this.client_data_obj.oxygen_end),
          diabetes_start: this.format.date(this.client_data_obj.diabetes_start),
          diabetes_end: this.format.date(this.client_data_obj.diabetes_end),
          business: "",
          delivery_method: parseInt(this.deliveryMethod),
          delivery_status: parseInt(this.deliveryStatus),
          delivery_date: this.delivery_date ? this.format.date(this.delivery_date) : null,
          delivery_time: parseInt(this.delivery_time),
          comment: this.orderComment,
          products: products,
          member_id: this.$globalState.id
        };

        const response = await this.$axios.put(`${this.$apiUrls.hanqmedi}/order/${this.orderId}`, orderData);

        if (response.data) {
          await this.$swal.fire({
            title: '주문 수정 성공',
            text: '주문 수정이 성공적으로 제출되었습니다.',
            icon: 'success',
            confirmButtonText: '확인',
            allowOutsideClick: false,
          });
          this.$emit('order-updated'); // 부모 컴포넌트에 이벤트 발생
          this.$emit('close-modal'); // 모달 닫기
          await this.fetchOrderData(); // 현재 페이지 새로고침
        }
      } catch (error) {
        console.error('주문 제출 중 오류가 발생했습니다:', error);
        await this.$swal.fire({
          title: '주문 수정 실패',
          text: '주문 수정 중 오류가 발생했습니다.',
          icon: 'error',
          confirmButtonText: '확인'
        });
      }
    },

    // 주문서 초기 로드시 실행 =====================================================================
    async initializeClientData(orderData) {
      if (orderData) {
        // 클라이언트 기본 정보 설정
        this.client_data_obj.orderdate = orderData.order.orderdate || '';
        this.client_data_obj.name = orderData.order.name || '';
        this.client_data_obj.number = orderData.order.number || '';
        this.client_data_obj.regident = orderData.order.resident || '';

        // 주소 정보 설정
        this.postcode_obj.postcode1 = orderData.order.addressnum || '';
        this.postcode_obj.address1 = orderData.order.address || '';
        this.postcode_obj.detailAddress1 = orderData.order.addressdetail || '';
        this.postcode_obj.postcode2 = orderData.order.addressnum2 || '';
        this.postcode_obj.address2 = orderData.order.address2 || '';
        this.postcode_obj.detailAddress2 = orderData.order.address2detail || '';

        // 보호자 및 연락처 정보 설정
        this.client_data_obj.email = orderData.order.email || '';
        this.client_data_obj.guardname = orderData.order.guardname || '';
        this.client_data_obj.guardtarget = orderData.order.guardtarget || '';
        this.client_data_obj.phone1 = orderData.order.phone1 || '';
        this.client_data_obj.phone2 = orderData.order.phone2 || '';

        // 센터 및 담당자 정보 설정
        this.client_data_obj.centername = orderData.order.centername || '';
        if (orderData.order.manager) {
          this.client_data_obj.manager = orderData.order.manager;
        }

        // 산소치료 유형 설정
        this.client_data_obj.oxygen_type = orderData.order.oxygen_type || '';

        // 대여 기간 설정
        this.client_data_obj.rental_start = new Date(orderData.order.rental_start) || '';
        this.client_data_obj.rental_end = new Date(orderData.order.rental_end) || '';

        // 산소치료 처방기간 설정
        this.client_data_obj.oxygen_start = new Date(orderData.order.oxygen_start) || '';
        this.client_data_obj.oxygen_end = new Date(orderData.order.oxygen_end) || '';

        // 당뇨소모성재료 처방기간 설정
        this.client_data_obj.diabetes_start = new Date(orderData.order.diabetes_start) || '';
        this.client_data_obj.diabetes_end = new Date(orderData.order.diabetes_end) || '';

        // 기타 주문 정보 설정
        this.deliveryMethod = orderData.order.delivery_method;
        this.deliveryStatus = orderData.order.delivery_status;

        // 배송 날짜 및 시간 설정
        if (orderData.order.delivery_date) {
          this.delivery_date = new Date(orderData.order.delivery_date);
        }

        // delivery_time 설정
        this.delivery_time = orderData.order.delivery_time?.toString() || "0";
        this.orderStatus = orderData.order.status;

        // 제품 정보 초기화
        const rental_id = orderData.order.rental_id;

        // 제품 데이터 처리
        const products = Array.isArray(orderData.products) ? orderData.products : [];

        // 제품 데이터 매핑 및 처리
        this.products_obj = await Promise.all(products.map(async product => {
          try {
            const quantity = product.quantity;
            const piece_quantity = product.piece_quantity || 0;
            const selected_target = product.selected_target;
            const isSetItem = product.product_set_id ? true : false;

            // 옵션 처리 함수
            const processOption = (option, quantity) => {
              if (!quantity || quantity < 1) return []; // 1 미만이면 빈 배열
              if (Array.isArray(option)) {
                return Array.from({ length: quantity }, (_, index) => option[index] || '');
              } else if (typeof option === 'string') {
                const splitArray = option.split(',');
                return Array.from({ length: quantity }, (_, index) => {
                  return index < splitArray.length ? splitArray[index] : '';
                });
              }
              return Array(quantity).fill('');
            };

            // 옵션 객체가 없는 경우 기본 구조 생성
            if (!product.options) {
              product.options = {
                size: [],
                color: [],
                bcode: [],
                note: []
              };
            }

            // 각 옵션 처리 - 옵션이 없는 경우 빈 배열로 초기화
            const sizesArray = processOption(product.options?.size || [], quantity);
            const colorsArray = processOption(product.options?.color || [], quantity);
            const barcodesArray = processOption(product.options?.bcode || [], quantity);
            const notesArray = processOption(product.options?.note || [], quantity);

            // 제품 ID 설정 - 우선순위: b_product_id > product_id > num > id
            const productId = product.b_product_id ||
              product.product_id ||
              product.num ||
              product.id;

            // 가격 정보 명시적으로 처리
            const buyPrice = Number(product.buyprice || product.price || 0);
            const rentPrice = Number(product.rentprice || product.price2 || 0);
            const supplyPrice = Number(product.supplyprice || product.price3 || 0);

            // 세트 품목인 경우 기본 정보만 설정
            if (isSetItem) {

              // 세트 아이템들의 카테고리와 이름 정보 추출
              let categories = [];
              let itemNames = [];
              let matchedItem = null;

              if (product.set_items && product.set_items.length > 0) {
                // 중복 없이 카테고리 수집
                categories = [...new Set(product.set_items.map(item => item.category))];

                // 모든 아이템 이름 수집
                itemNames = product.set_items.map(item => item.name);

                // set_item_id가 있으면 해당 아이템 찾기
                if (product.set_item_id) {
                  matchedItem = product.set_items.find(item =>
                    (item.id || item.num) === parseInt(product.set_item_id, 10)
                  );
                }
              }

              // 매칭된 아이템이 있으면 해당 아이템의 카테고리와 이름 사용
              const categoryName = matchedItem ? matchedItem.category : (categories[0] || '세트 품목');
              const itemName = matchedItem ? matchedItem.name : (itemNames[0] || '');

              return {
                ...product,
                id: productId,
                isEditing: false,
                isEditingMargin: false,
                isSetItem: true,
                selected_target,
                margin: product.margin || 0,
                margin_type: product.margin_type || 'a',
                rental_id: rental_id,
                name: categoryName, // 매칭된 카테고리 또는 첫 번째 카테고리
                name1: product.set_name || '세트', // 세트 이름
                name2: itemName, // 매칭된 아이템 이름 또는 첫 번째 아이템 이름
                name3: product.set_name || '', // 세트 이름
                name4: `${product.set_items?.length || 0}개 품목`, // 품목 수
                quantity: quantity,
                piece_quantity: piece_quantity,
                stock_quantity: product.stock_quantity || 0,
                buyprice: buyPrice,
                rentprice: rentPrice,
                supplyprice: supplyPrice,
                setBuyprice: (Number(product.buyprice) || 0) * quantity,
                setRentprice: (Number(product.rentprice) || 0) * quantity,
                barcodes: barcodesArray,
                notes: notesArray,
                colors: colorsArray,
                sizes: sizesArray,
                colorOptions: [],
                sizeOptions: [],
                options: {
                  bcode: barcodesArray,
                  color: colorsArray,
                  size: sizesArray,
                  note: notesArray
                },
                pitem: product.pitem || '',
                pname: product.pname || '',
                pcode: product.pcode || '',
                // 세트 품목 정보 유지
                set_name: product.set_name,
                set_items: product.set_items,
                // 매칭된 아이템 정보 추가
                matched_item: matchedItem
              };
            } else if (product.b_product_id > 999999) {
              // b_product_id가 있는 경우
              return {
                ...product,
                id: productId,
                isEditing: false,
                isEditingMargin: false,
                selected_target,
                margin: product.margin || 0,
                margin_type: product.margin_type || 'a',
                rental_id: rental_id,
                name: product.name || '',
                name1: product.name1 || '',
                name2: product.name2 || '',
                name3: product.name3 || '',
                name4: product.name4 || '',
                quantity: quantity,
                piece_quantity: piece_quantity,
                stock_quantity: product.stock_quantity || 0,
                icode: product.icode || '',
                location: product.location || '',
                buyprice: buyPrice,
                rentprice: rentPrice,
                supplyprice: supplyPrice,
                setBuyprice: (Number(product.buyprice) || 0) * quantity,
                setRentprice: (Number(product.rentprice) || 0) * quantity,
                // 비급여 품목의 경우 배열을 길이 1로 설정
                barcodes: product.b_product_id >= 100000 ? [barcodesArray[0] || ''] : barcodesArray,
                notes: product.b_product_id >= 100000 ? [notesArray[0] || ''] : notesArray,
                colors: product.b_product_id >= 100000 ? [colorsArray[0] || ''] : colorsArray,
                sizes: product.b_product_id >= 100000 ? [sizesArray[0] || ''] : sizesArray,
                colorOptions: [],
                sizeOptions: [],
                options: {
                  bcode: product.b_product_id >= 100000 ? [barcodesArray[0] || ''] : barcodesArray,
                  color: product.b_product_id >= 100000 ? [colorsArray[0] || ''] : colorsArray,
                  size: product.b_product_id >= 100000 ? [sizesArray[0] || ''] : sizesArray,
                  note: product.b_product_id >= 100000 ? [notesArray[0] || ''] : notesArray
                },
                pitem: product.pitem || '',
                pname: product.pname || '',
                pcode: product.pcode || '',
              };
            } else {
              // 일반 product_id 제품인 경우
              try {
                const productResponse = await this.$axios.post(`${this.$apiUrls.hanq}/orderupproductload`, {
                  target: product.target,
                  number: product.code
                });

                const productResult = productResponse.data.result[0] || {};

                return {
                  ...product,
                  id: productId,
                  isEditing: false,
                  selected_target: selected_target,
                  margin: product.margin || 0,
                  margin_type: product.margin_type || 'a',
                  rental_id: rental_id,
                  name: product.name || '',
                  name1: product.name1 || '',
                  name2: product.name2 || '',
                  name3: product.name3 || '',
                  name4: product.name4 || '',
                  buyprice: Number(product.buyprice) || 0,
                  rentprice: Number(product.rentprice) || 0,
                  icode: product.icode || '',
                  location: product.location || '',
                  setBuyprice: (Number(product.buyprice) || 0) * quantity,
                  setRentprice: (Number(product.rentprice) || 0) * quantity,
                  quantity: quantity,
                  piece_quantity: piece_quantity,
                  stock_quantity: product.stock_quantity || 0,
                  // 비급여 품목의 경우 배열을 길이 1로 설정
                  barcodes: product.b_product_id >= 100000 ? [barcodesArray[0] || ''] : barcodesArray,
                  notes: product.b_product_id >= 100000 ? [notesArray[0] || ''] : notesArray,
                  colors: product.b_product_id >= 100000 ? [colorsArray[0] || ''] : colorsArray,
                  sizes: product.b_product_id >= 100000 ? [sizesArray[0] || ''] : sizesArray,
                  colorOptions: productResult.color ? productResult.color.split(",") : [],
                  sizeOptions: productResult.size ? productResult.size.split(",") : [],
                  options: {
                    bcode: product.b_product_id >= 100000 ? [barcodesArray[0] || ''] : barcodesArray,
                    color: product.b_product_id >= 100000 ? [colorsArray[0] || ''] : colorsArray,
                    size: product.b_product_id >= 100000 ? [sizesArray[0] || ''] : sizesArray,
                    note: product.b_product_id >= 100000 ? [notesArray[0] || ''] : notesArray
                  },
                  pitem: product.pitem || '',
                  pname: product.pname || '',
                  pcode: product.pcode || '',
                };
              } catch (error) {
                console.error('제품 정보 로드 중 오류:', error);
                // API 호출 실패 시 기본값 반환
                return {
                  ...product,
                  id: productId,
                  isEditing: false,
                  selected_target: selected_target,
                  margin: product.margin || 0,
                  margin_type: product.margin_type || 'a',
                  rental_id: rental_id,
                  name: product.name || '',
                  name1: product.name1 || '',
                  name2: product.name2 || '',
                  name3: product.name3 || '',
                  name4: product.name4 || '',
                  buyprice: buyPrice,
                  rentprice: rentPrice,
                  supplyprice: supplyPrice,
                  icode: product.icode || '',
                  location: product.location || '',
                  setBuyprice: (Number(product.buyprice) || 0) * quantity,
                  setRentprice: (Number(product.rentprice) || 0) * quantity,
                  quantity: quantity,
                  piece_quantity: piece_quantity,
                  stock_quantity: product.stock_quantity || 0,
                  // 비급여 품목의 경우 배열을 길이 1로 설정
                  barcodes: product.b_product_id >= 100000 ? [barcodesArray[0] || ''] : barcodesArray,
                  notes: product.b_product_id >= 100000 ? [notesArray[0] || ''] : notesArray,
                  colors: product.b_product_id >= 100000 ? [colorsArray[0] || ''] : colorsArray,
                  sizes: product.b_product_id >= 100000 ? [sizesArray[0] || ''] : sizesArray,
                  colorOptions: [],
                  sizeOptions: [],
                  options: {
                    bcode: product.b_product_id >= 100000 ? [barcodesArray[0] || ''] : barcodesArray,
                    color: product.b_product_id >= 100000 ? [colorsArray[0] || ''] : colorsArray,
                    size: product.b_product_id >= 100000 ? [sizesArray[0] || ''] : sizesArray,
                    note: product.b_product_id >= 100000 ? [notesArray[0] || ''] : notesArray
                  },
                  pitem: product.pitem || '',
                  pname: product.pname || '',
                  pcode: product.pcode || '',
                };
              }
            }
          } catch (error) {
            console.error('제품 데이터 처리 중 오류:', error);
            // 오류 발생 시 기본 객체 반환
            return {
              ...product,
              id: product.b_product_id || product.product_id || product.num || product.id,
              isEditing: false,
              isEditingMargin: false,
              selected_target: product.selected_target || '구입',
              margin: product.margin || 0,
              margin_type: product.margin_type || 'a',
              quantity: product.quantity,
              piece_quantity: product.piece_quantity,
              barcodes: [''],
              notes: [''],
              colors: [''],
              sizes: [''],
              colorOptions: [],
              sizeOptions: [],
              options: {
                bcode: [''],
                color: [''],
                size: [''],
                note: ['']
              },
            };
          }
        }));
      }
    },

    // 문서 선택 처리 =====================================================================
    toggleSelectAll() {
      this.selectAll = !this.selectAll;
      if (this.documents && Array.isArray(this.documents)) {
        this.documents.forEach(doc => {
          doc.selected = this.selectAll;
        });
      }
    },

    // 문서 선택 핸들러 =====================================================================
    handleSelection() {
      if (this.documents && Array.isArray(this.documents)) {
        // 모든 문서가 선택되었는지 확인
        const allSelected = this.documents.every(doc => doc.selected);
        const noneSelected = this.documents.every(doc => !doc.selected);

        if (allSelected) {
          this.selectAll = true;
        } else if (noneSelected) {
          this.selectAll = false;
        } else {
          // 일부만 선택된 경우
          this.selectAll = false;
        }
      }
    },

    // 색상 테이블 조회 =====================================================================
    async getColorTable() {
      try {
        const response = await this.$axios.post(`${this.$apiUrls.hanqmedi}/ColorTableGet`, {});
        const data = response.data;
        if (data.code === 200) {
          const newColorObj = {};
          data.data.forEach((obj) => {
            newColorObj[String(obj.num)] = obj.name;
          });
          this.color_obj.value = newColorObj;
        }
      } catch (error) {
        console.error('색상 테이블 가져오기 실패:', error);
      }
    },

    // 매니저 정보 조회 =====================================================================
    async getManager() {
      try {
        const response = await this.$axios.get(`${this.$apiUrls.hanqmedi}/companyMember/${this.$globalState.company_key}`, {
        });
        const data = response.data;
        if (data.code === 200) {
          this.manager = data.data;
        } else {
          this.manager = [];
        }
      } catch (error) {
        console.error('매니저 정보 가져오기 실패:', error);
        this.manager = [];
      }
    },

    // 주소 정보 교환 =====================================================================
    swapAddresses() {
      const temp = {
        postcode: this.postcode_obj.postcode1,
        address: this.postcode_obj.address1,
        detailAddress: this.postcode_obj.detailAddress1
      };

      this.postcode_obj.postcode1 = this.postcode_obj.postcode2;
      this.postcode_obj.address1 = this.postcode_obj.address2;
      this.postcode_obj.detailAddress1 = this.postcode_obj.detailAddress2;

      this.postcode_obj.postcode2 = temp.postcode;
      this.postcode_obj.address2 = temp.address;
      this.postcode_obj.detailAddress2 = temp.detailAddress;
    },

    // 색상 변경 처리 =====================================================================
    handleColorChange(productIndex, colorIndex) {
      const product = this.products_obj[productIndex];
      if (product.colors[colorIndex] === 'null') {
        product.colors[colorIndex] = null;
      }
      console.log(`Product ${productIndex}, Color ${colorIndex} changed to:`, product.colors[colorIndex]);
    },

    convertToUpperCase(productIndex, sizeIndex) {
      if (this.products_obj[productIndex].sizes[sizeIndex]) {
        this.products_obj[productIndex].sizes[sizeIndex] =
          this.products_obj[productIndex].sizes[sizeIndex].toUpperCase();
      }
    },

    // 모달 및 팝업 관련 =====================================================================
    showOrderReturnPopup() {
      const products = this.products_obj;  // 현재 제품 목록 저장

      this.$swal.fire({
        title: '반품 주문',
        width: '50%',
        html: '<div id="return-popup"></div>',
        showCancelButton: true,
        confirmButtonText: '반품주문',
        cancelButtonText: '취소',
        confirmButtonColor: '#0f4c5c',
        cancelButtonColor: '#6c757d',
        allowEnterKey: true,
        didOpen: () => {
          const app = createApp({
            setup() {
              const componentRef = ref(null);
              return { componentRef };
            },
            render: () => h(OrderReturnPopup, {
              ref: 'componentRef',
              products: products
            })
          });

          // 전역 속성 추가
          app.config.globalProperties.$axios = this.$axios;
          app.config.globalProperties.$apiUrls = this.$apiUrls;
          app.config.globalProperties.$swal = this.$swal;

          const instance = app.mount('#return-popup');
          this.returnPopupInstance = instance.componentRef;
        },
        preConfirm: () => {
          // 반품 팝업에서 선택된 데이터 가져오기
          if (this.returnPopupInstance) {
            const selectedProducts = this.returnPopupInstance.selectedProducts || [];
            const returnNote = this.returnPopupInstance.returnNote || '';
            const returnType = this.returnPopupInstance.returnType || '';

            if (selectedProducts.length === 0) {
              this.$swal.fire({
                title: '품목 선택 필요',
                text: '반품할 상품을 선택해주세요.',
                icon: 'warning',
                confirmButtonText: '확인'
              });
              return false;
            }

            if (!returnType) {
              this.$swal.fire({
                title: '반품 유형 선택 필요',
                text: '반품 유형을 선택해주세요.',
                icon: 'warning',
                confirmButtonText: '확인'
              });
              return false;
            }

            if (!returnNote.trim()) {
              this.$swal.fire({
                title: '반품 요청사항 입력 필요',
                text: '반품 요청사항을 입력해주세요.',
                icon: 'warning',
                confirmButtonText: '확인'
              });
              return false;
            }

            // 반품 주문 처리
            this.submitReturnOrder(selectedProducts, returnNote, returnType);
            return true;
          } else {
            console.error('returnPopupInstance not found');
            this.$swal.fire({
              title: '오류',
              text: '반품 팝업을 불러올 수 없습니다.',
              icon: 'error',
              confirmButtonText: '확인'
            });
            return false;
          }
        }
      }).then((result) => {
        console.log('SweetAlert 결과:', result);
      }).catch((error) => {
        console.error('SweetAlert 에러:', error);
      });
    },
    showAsPopup() {
      const products = this.products_obj;
      const orderId = this.orderId;
      const axios = this.$axios;
      const apiUrls = this.$apiUrls;
      const swal = this.$swal;

      this.$swal.fire({
        title: 'A/S 접수',
        width: "50%",
        html: '<div id="as-popup"></div>',
        showCancelButton: true,
        confirmButtonText: '확인',
        cancelButtonText: '취소',
        didOpen: () => {
          const app = createApp({
            setup() {
              return () => h(OrderAsPopup, {
                products: products,
                orderId: orderId,
                ref: 'asPopup'
              });
            }
          });

          // 전역 속성 추가
          app.config.globalProperties.$axios = axios;
          app.config.globalProperties.$apiUrls = apiUrls;
          app.config.globalProperties.$swal = swal;

          this.asPopupInstance = app.mount('#as-popup');
        },
      }).then((result) => {
        if (result.isConfirmed) {
          // OrderAsPopup 컴포넌트의 메서드를 통해 데이터 가져오기
          const asPopup = this.asPopupInstance.$refs.asPopup;
          const asData = asPopup.getAsData();

          // 선택된 품목이 있는지 확인
          if (!asData.products || asData.products.length === 0) {
            this.$swal.fire({
              icon: 'warning',
              title: '선택된 품목 없음',
              text: 'A/S 접수할 품목을 선택해주세요.',
              showConfirmButton: true,
            });
            return;
          }

          // 요청사항 입력 확인
          if (!asData.request.trim()) {
            this.$swal.fire({
              icon: 'warning',
              title: '요청사항 없음',
              text: '수리/보수 요청사항을 입력해주세요.',
              showConfirmButton: true,
            });
            return;
          }

          this.submitAsOrder(asData);
        }
      });
    },
    openImageModal(imageUrl) {
      this.selectedImage = imageUrl;
      this.showImageModal = true;
    },
    closeImageModal() {
      this.showImageModal = false;
    },
    closeClaimCalculationModal() {
      this.showModal_obj.claim_calculation = false;
    },
    openSmsSendModal() {
      this.showModal_obj.sms_up = true;
      const rawPhone = this.client_data_obj.phone1 || this.client_data_obj.phone2 || '';
      const normalized = String(rawPhone).replace(/[^0-9]/g, '');

      this.selectedCustomer = {
        name: this.client_data_obj.name || '',
        phone: normalized,
        phone1: normalized,
        phone2: this.client_data_obj.phone2 || '',
        companykey: this.$globalState?.company_key || ''
      };
    },
    closeSmsSendModal() {
      this.showModal_obj.sms_up = false;
    },
    openVirtualAccountModal() {
      const companykey = Number(this.$globalState.company_key);

      if (companykey !== 32) {
        this.$swal.fire({
          icon: 'info',
          title: '가상계좌 관리 불가능',
          html: '가상계좌 사업소에 등록되지 않았습니다. <br>관리자에게 문의하세요.',
          confirmButtonText: '확인'
        });
        return;
      }

      this.showModal_obj.virtual_up = true;
    },
    openDocumentIssuanceModal() {
      this.showModal_obj.document_issuance = true;
    },
    closeDocumentIssuanceModal() {
      this.showModal_obj.document_issuance = false;
    },
    closeVirtualAccountModal() {
      this.showModal_obj.virtual_up = false;
    },
    showClaimTypeModal() {
      document.body.style.overflow = 'hidden';
      this.showModal_obj.claim_type = true;
    },
    closeClaimTypeModal() {
      this.showModal_obj.claim_type = false;
    },

    // 상태 관련 =====================================================================
    getDeliveryMethodCode(method) {
      const methodMap = {
        '내방': 1,
        '택배': 2,
        '물류 (기관배송)': 3,
        '소독': 4,
        '공급업체': 5
      };
      return methodMap[method] || 0;
    },
    getDeliveryMethodCodeReverse(method) {
      const methodMap = {
        1: '내방',
        2: '택배',
        3: '물류 (기관배송)',
        4: '소독',
        5: '공급업체'
      };
      return methodMap[method] || '내방';
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    // 다음 우편번호 서비스 스크립트 동적 로딩
    loadDaumPostcodeScript() {
      return new Promise((resolve, reject) => {
        // 이미 로드되어 있으면 바로 resolve
        if (window.daum && window.daum.Postcode) {
          resolve();
          return;
        }

        // 스크립트가 이미 추가되어 있는지 확인
        const existingScript = document.querySelector('script[src*="postcode.v2.js"]');
        if (existingScript) {
          existingScript.onload = resolve;
          existingScript.onerror = reject;
          return;
        }

        // 새 스크립트 태그 생성
        const script = document.createElement('script');
        script.src = '//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
        script.onload = resolve;
        script.onerror = reject;

        document.head.appendChild(script);
      });
    },

    // 개선된 주소 검색 함수
    async openDaumPostcode(type) {
      try {
        // 다음 우편번호 서비스 로드 확인
        await this.loadDaumPostcodeScript();

        const width = 500;
        const height = 600;
        const left = Math.ceil((window.innerWidth - width) / 2);
        const top = Math.ceil((window.innerHeight - height) / 2);

        new window.daum.Postcode({
          oncomplete: (data) => {
            if (type == 1) {
              this.postcode_obj.postcode1 = data.zonecode;
              this.postcode_obj.address1 = data.address;
              this.postcode_obj.detailAddress1 = data.buildingName;
            } else {
              this.postcode_obj.postcode2 = data.zonecode;
              this.postcode_obj.address2 = data.address;
              this.postcode_obj.detailAddress2 = data.buildingName;
            }
          },
          width: width,
          height: height,
          left: left,
          top: top
        }).open();

      } catch (error) {
        console.error('주소 검색 서비스 로딩 실패:', error);
        this.$swal.fire({
          title: '오류',
          text: '주소 검색 서비스를 불러올 수 없습니다.\n인터넷 연결을 확인하고 다시 시도해주세요.',
          icon: 'error',
          confirmButtonText: '확인'
        });
      }
    },
    getFileType(fileName) {
      const extension = fileName.split('.').pop().toLowerCase();
      if (['jpg', 'jpeg', 'png'].includes(extension)) {
        return 'image';
      } else if (extension === 'pdf') {
        return 'pdf';
      }
      return 'file';
    },
    selectClaimType(type) {
      switch (type) {
        case '산소발생기':
          this.showModal_obj.claim_up = true;
          break;
        case '보장구':
          this.showModal_obj.assistance_up = true;
          break;
        case '당뇨소모성재료':
          this.showModal_obj.diabetes_up = true;
          break;
      }
    },

    // 키 이벤트 관련 =====================================================================
    handleEscKey(event) {
      if (event.key === 'Escape') {
        this.showModal_obj.client_up = false;
        this.showModal_obj.company_up = false;
        this.showModal_obj.product_up = false;
        this.showModal_obj.doc_print = false;
      }
    },

    // 메세지 관련 =====================================================================
    showDevelopmentMessage() {
      this.$swal.fire({
        title: '개발 중',
        text: '현재 개발 중인 기능입니다.',
        icon: 'info',
        confirmButtonColor: '#3085d6',
        confirmButtonText: '확인'
      });
    },
    showClaimMessage() {
      this.$swal.fire({
        title: '청구 처리가 불가능한 주문입니다.',
        text: '산소발생기, 보장구, 당뇨소모성재료만 청구 가능합니다.',
        icon: 'warning',
        confirmButtonColor: '#3085d6',
        confirmButtonText: '확인'
      });
    },
    closeModal() {
      try {
        // 피드백이 변경되었으면 부모에게 알림
        if (this.feedbackChanged) {
          this.$emit('feedback-changed', true);
        }

        this.$emit('close-modal');
      } catch (error) {
        console.error('모달 닫기 중 오류:', error);
        this.$emit('close-modal');
      }
    },
  },

  beforeUnmount() {
    if (this.feedbackChanged) {
      // 전역 이벤트로 피드백 변경 알림
      window.dispatchEvent(new CustomEvent('feedback-updated'));
    }

    // 컴포넌트가 제거될 때 스타일도 제거
    const styleEl = document.getElementById('product-expanded-row-styles');
    if (styleEl) {
      styleEl.parentNode.removeChild(styleEl);
    }
  },

  async mounted() {
    try {
      // 청구 정보 로딩 시작
      this.isLoadingClaimInfo = true;

      // 주문 데이터를 먼저 가져오고
      await this.fetchOrderData();

      // 청구 상태를 즉시 시작 (다른 작업을 기다리지 않음)
      if (this.orderId || this.$route.params.id) {
        // await 없이 백그라운드로 실행 - UI가 즉시 표시됨
        this.loadClaimStatus().catch(err => {
          console.error('청구 상태 로드 오류:', err);
        });
      }

      // 주문 타입 확인도 병렬로 처리
      const orderTypePromise = (this.orderId || this.$route.params.id)
        ? this.fetchOrderType(this.orderId || this.$route.params.id)
        : Promise.resolve();

      // 스타일을 동적으로 추가
      if (!document.getElementById('product-expanded-row-styles')) {
        const styleEl = document.createElement('style');
        styleEl.id = 'product-expanded-row-styles';
        styleEl.textContent = ProductExpandedRowStyles;
        document.head.appendChild(styleEl);
      }

      // 나머지 데이터들을 병렬로 로딩 (청구 상태 제외)
      await Promise.all([
        orderTypePromise,
        this.commmentGet(),
        this.getManager(),
        this.fetchImages(),
        this.checkExistingFeedback(),
        this.getColorTable()
      ]);

      // 반품 주문서인 경우 상태 설정
      if (this.isReturnOrder) {
        this.returnStatus = this.returnOrderData?.return_status || 0;
      }

      // 모든 데이터 로딩 완료
      this.isLoadingClaimInfo = false;

    } catch (error) {
      console.error('데이터 로딩 중 오류 발생:', error);
      this.$swal.fire({
        title: '데이터 로딩 오류',
        text: '일부 데이터를 불러오는데 실패했습니다.',
        icon: 'error',
        confirmButtonText: '확인'
      });

      // 에러가 발생해도 로딩 상태는 해제
      this.isLoadingClaimInfo = false;
    }
  },

  created() {
    // ESC 키 이벤트 리스너 추가
    document.addEventListener('keydown', this.handleEscKey);
  },

  watch: {
    // products_obj가 변경될 때마다 산소발생기 유형 업데이트
    products_obj: {
      handler() {
        this.updateOxygenType();
      },
      deep: true
    },

    // rentalTypes가 변경될 때마다 산소발생기 유형 업데이트
    rentalTypes: {
      handler() {
        this.updateOxygenType();
      },
      deep: true
    }
  }
};
</script>

<style>
/* 전역 스타일로 추가 */
.modal-close-btn {
  width: 30%;
  padding: 1rem;
  background: #0f4c5c;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: 0 auto;
  display: block;

  &:hover {
    background: #1a6985;
    color: #fff;
  }
}

.stock-toast-container {
  top: 100px !important;
}

.positive-diff {
  color: #28a745;
}

.negative-diff {
  color: #dc3545;
}
</style>

<style scoped>
/* 블러 효과를 위한 추가 스타일 */
.blurred {
  filter: blur(4px) !important;
  pointer-events: auto;
  user-select: auto;
  -webkit-user-select: auto;
  -moz-user-select: auto;
  -ms-user-select: auto;
}
</style>